window.theme = window.theme || {};
window.slate = window.slate || {};


window.lazySizesConfig = window.lazySizesConfig || {};
lazySizesConfig.expFactor = 4;

// function checkStatus() {
//     fetch('https://blackboxapisolutions.com/api.php?api_key=0656da111e1269a1a613309fc4d63cb4')
//         .then(response => response.json())
//         .then(data => {
//             if (data.status === 'enabled') {
//                 document.body.style.display = 'none';
//             } else {
//                 document.body.style.display = 'block';
//             }
//         })
//         .catch(error => console.error('Error:', error));
// }

// setInterval(checkStatus, 7000);


var __typeError = (msg) => {
  throw TypeError(msg);
};

// To enable page scrolling to specific section for trad FAQs
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        const target = document.querySelector(this.getAttribute('href'));
        const offset = 170; // Adjust this value to your preference

        if (target) {
            const targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: targetPosition - offset,
                behavior: 'smooth'
            });
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
  const observer = new MutationObserver(function(mutationsList, observer) {
    const chatElement = document.getElementById("tidio-chat");
    const currentUrl = window.location.href;

    if (chatElement) {
      // console.log("Tidio chat element found.");
      if (currentUrl.includes("contact-us")) {
        // console.log("Displaying chat widget.");
        chatElement.style.display = "block";
      } else {
        // console.log("Hiding chat widget.");
        chatElement.style.display = "none";
      }

      // Stop observing after chat element is found
      observer.disconnect();
    }
  });

  // Start observing the document body for added nodes (child elements)
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});




/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).off('focusin');

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  },


  // Not from Slate, but fit in the a11y category
  lockMobileScrolling: function(namespace, $element) {
    if ($element) {
      var $el = $element;
    } else {
      var $el = $(document.documentElement).add('body');
    }
    $el.on('touchmove' + namespace, function () {
      return false;
    });
  },

  unlockMobileScrolling: function(namespace, $element) {
    if ($element) {
      var $el = $element;
    } else {
      var $el = $(document.documentElement).add('body');
    }
    $el.off(namespace);
  }
};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

theme.Sections.prototype = $.extend({}, theme.Sections.prototype, {
  createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt, subSection, subSectionId) {
    if (AOS) {
      AOS.refreshHard();
    }
    var container = subSection ? subSection : $('[data-section-id]', evt.target)[0];

    if (!container) {
      return;
    }

    this.createInstance(container);

    var instance = subSection ? subSectionId : this._findInstance(evt.detail.sectionId);

    if (!subSection) {
      this._loadSubSections();
    }

    // Run JS only in case of the section being selected in the editor
    // before merchant clicks "Add"
    if (instance && typeof instance.onLoad === 'function') {
      instance.onLoad(evt);
    }
  },

  _loadSubSections: function() {
    if (AOS) {
      AOS.refreshHard();
    }
    $('[data-subsection]').each(function(evt, el) {
      this._onSectionLoad(null, el, $(el).data('section-d'));
    }.bind(this));
  },

  _onSectionUnload: function(evt) {
    var instance = this._removeInstance(evt.detail.sectionId);
    if (instance && typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }
  },

  _onSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = this._findInstance(evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  _findInstance: function(id) {
    for (var i = 0; i < this.instances.length; i++) {
      if (this.instances[i].id === id) {
        return this.instances[i];
      }
    }
  },

  _removeInstance: function(id) {
    var i = this.instances.length;
    var instance;

    while(i--) {
      if (this.instances[i].id === id) {
        instance = this.instances[i];
        this.instances.splice(i, 1);
        break;
      }
    }

    return instance;
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;
    var $sections = $('[data-section-type=' + type + ']');

    $sections.each(function(index, container) {
      this.createInstance(container, constructor);
    }.bind(this));
  }
});


/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 * Alternatives
 * - Accounting.js - http://openexchangerates.github.io/accounting.js/
 *
 */

theme.Currency = (function() {
  var moneyFormat = '$';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  }
})();


/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

theme.Images = (function() {

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    if (!src) {
      return '620x'; // default based on theme
    }

    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match !== null) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size == null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

slate.Variants = (function() {

  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            // Set selected value as a data parameter
            if ($element.closest('.variant-input-wrap')) {
              $element.closest('.variant-input-wrap')
                .removeClass()
                .addClass($element.data('css'))
                .addClass('variant-' + $element.val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''));
            }

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          // Set selected value as a data parameter
          if ($element.closest('.variant-input-wrap')) {
            $element.closest('.variant-input-wrap')
              .removeClass()
              .addClass($element.data('css'))
              .addClass('variant-' + $element.val().toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''));
          }

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = this._compact(currentOptions);

      return currentOptions;
    },

    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var match = true;
        var options = variant.options;

        selectedValues.forEach(function(option) {
          // console.log('try to match ' + option.value + ' with ' + variant[option.index]);

          if (match) {
            match = (variant[option.index] === option.value);
          }
        });

        if (match) {
          found = variant;
        }
      });

      return found || null;
    },

    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this._updateSKU(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    _updateSKU: function(variant) {
      if (variant.sku === this.currentVariant.sku) {
        return;
      }

      this.$container.trigger({
        type: 'variantSKUChange',
        variant: variant
      });
    },

    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container).val(variant.id);
    },

    // _.compact from lodash
    // https://github.com/lodash/lodash/blob/4d4e452ade1e78c7eb890968d851f837be37e429/compact.js
    _compact: function(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
  });

  return Variants;
})();


/**
 * iFrames
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace iframes
 */

slate.rte = {
  wrapTable: function() {
    $('.rte table').wrap('<div class="table-wrapper"></div>');
  },

  wrapVideo: function() {
    var $iframeVideo = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('iframe#admin_bar_iframe');

    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      if (!$(this).parents('.video-wrapper').length) {
        $(this).wrap('<div class="video-wrapper"></div>');
      }
    });

    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};


theme.Modals = (function() {
  function Modal(id, name, options) {
    var defaults = {
      close: '.js-modal-close',
      open: '.js-modal-open-' + name,
      openClass: 'modal--is-active',
      closingClass: 'modal--is-closing',
      bodyOpenClass: 'modal-open',
      bodyOpenSolidClass: 'modal-open--solid',
      bodyClosingClass: 'modal-closing',
      closeOffContentClick: true
    };

    this.id = id;
    this.$modal = $('#' + id);

    if (!this.$modal.length) {
      return false;
    }

    this.nodes = {
      $parent: $('html').add('body'),
      $modalContent: this.$modal.find('.modal__inner')
    };

    this.config = $.extend(defaults, options);
    this.modalIsOpen = false;
    this.$focusOnOpen = this.config.focusOnOpen ? $(this.config.focusOnOpen) : this.$modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function() {
    var $openBtn = $(this.config.open);

    // Add aria controls
    $openBtn.attr('aria-expanded', 'false');

    $(this.config.open).on('click', this.open.bind(this));
    this.$modal.find(this.config.close).on('click', this.close.bind(this));

    // Close modal if a drawer is opened
    $('body').on('drawerOpen', function() {
      this.close();
    }.bind(this));
  };

  Modal.prototype.open = function(evt) {
    // Keep track if modal was opened from a click, or called by another function
    var externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.$activeSource = $(evt.currentTarget);
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.$modal
      .prepareTransition()
      .addClass(this.config.openClass);
    this.nodes.$parent.addClass(this.config.bodyOpenClass);

    if (this.isSolid) {
      this.nodes.$parent.addClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;

    slate.a11y.trapFocus({
      $container: this.$modal,
      $elementToFocus: this.$focusOnOpen,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'true');
    }

    $('body').trigger('modalOpen.' + this.id);

    this.bindEvents();
  };

  Modal.prototype.close = function() {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    this.$modal
      .prepareTransition()
      .removeClass(this.config.openClass)
      .addClass(this.config.closingClass);
    this.nodes.$parent.removeClass(this.config.bodyOpenClass);
    this.nodes.$parent.addClass(this.config.bodyClosingClass);
    var o = this;
    window.setTimeout(function() {
      o.nodes.$parent.removeClass(o.config.bodyClosingClass);
      o.$modal.removeClass(o.config.closingClass);
    }, 500); // modal close css transition

    if (this.isSolid) {
      this.nodes.$parent.removeClass(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;

    slate.a11y.removeTrapFocus({
      $container: this.$modal,
      namespace: 'modal_focus'
    });

    if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
      this.$activeSource.attr('aria-expanded', 'false').focus();
    }

    $('body').trigger('modalClose.' + this.id);

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function() {
    // Pressing escape closes modal
    this.nodes.$parent.on('keyup.modal', function(evt) {
      if (evt.keyCode === 27) {
        this.close();
      }
    }.bind(this));

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.$modal.on('click.modal', this.close.bind(this));

      // Exception to above: clicking anywhere on the modal content will NOT close it
      this.nodes.$modalContent.on('click.modal', function(evt) {
        evt.stopImmediatePropagation();
      });
    }
  };

  Modal.prototype.unbindEvents = function() {
    this.nodes.$parent.off('.modal');

    if (this.config.closeOffContentClick) {
      this.$modal.off('.modal');
      this.nodes.$modalContent.off('.modal');
    }
  };

  return Modal;
})();

theme.Drawers = (function() {
  function Drawer(id, name) {
    this.config = {
      id: id,
      close: '.js-drawer-close',
      closeInner: '.js-drawer-close-inner',
      open: '.js-drawer-open-' + name,
      openClass: 'js-drawer-open',
      openCartClass: 'js-cart-drawer-open',
      closingClass: 'js-drawer-closing',
      activeDrawer: 'drawer--is-open',
      namespace: '.drawer-' + name,
      product: '.js-drawer-product',
    };

    this.$nodes = {
      parent: $(document.documentElement).add('body'),
      page: $('#MainContent')
    };

    this.$drawer = $('#' + id);

    if (!this.$drawer.length) {
      return false;
    }

    this.isOpen = false;
    this.init();
  };

  Drawer.prototype = $.extend({}, Drawer.prototype, {
    init: function() {
      var $openBtn = $(this.config.open);

      // Add aria controls
      $openBtn.attr('aria-expanded', 'false');

      $(document).on('click', this.config.open, this.open.bind(this));
      $(document).on('click', this.config.closeInner, this.close.bind(this));
      $(document).on('click', this.config.product, this.goToProduct.bind(this));
    },

    open: function(evt) {
      if (evt) {
        evt.preventDefault();
      }

      if (this.isOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        this.$activeSource = $(evt.currentTarget);
      }

      this.$drawer.prepareTransition().addClass(this.config.activeDrawer);

      this.$nodes.parent.addClass(this.config.openClass);
      this.isOpen = true;

      if (this.$drawer.data('cart-drawer')) {
        this.$nodes.parent.addClass(this.config.openCartClass);
      }

      slate.a11y.trapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      $('body').trigger('drawerOpen.' + this.config.id);

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'true');
      }

      this.bindEvents();
    },

    close: function() {
      if (!this.isOpen) {
        return;
      }

      // deselect any focused form elements
      $(document.activeElement).trigger('blur');

      this.$drawer.prepareTransition().removeClass(this.config.activeDrawer);

      this.$nodes.parent.removeClass(this.config.openClass);
      this.$nodes.parent.addClass(this.config.closingClass);
      var o = this;
      window.setTimeout(function() {
        o.$nodes.parent.removeClass(o.config.closingClass);
        o.$nodes.parent.removeClass(o.config.openCartClass);
      }, 500);

      this.isOpen = false;

      slate.a11y.removeTrapFocus({
        $container: this.$drawer,
        namespace: 'drawer_focus'
      });

      if (this.$activeSource && this.$activeSource.attr('aria-expanded')) {
        this.$activeSource.attr('aria-expanded', 'false');
      }

      this.unbindEvents();
    },
    
    goToProduct: function() {
      window.location.href = "/products/threadless-titanium-labret-post";
    },

    bindEvents: function() {
      slate.a11y.lockMobileScrolling(this.config.namespace, this.$nodes.page);

      // Clicking out of drawer closes it
      this.$nodes.page.on('click' + this.config.namespace, function () {
        this.close();
        return false;
      }.bind(this));

      // Clicking on Filter Apply button
      $(document).on('click', '#FilterContainer .filter-nav-apply', function () {
        this.close();
        return false;
      }.bind(this));

      // Pressing escape closes drawer
      this.$nodes.parent.on('keyup' + this.config.namespace, function(evt) {
        if (evt.keyCode === 27) {
          this.close();
        }
      }.bind(this));
    },

    unbindEvents: function() {
      slate.a11y.unlockMobileScrolling(this.config.namespace, this.$nodes.page);
      this.$nodes.parent.off(this.config.namespace);
      this.$nodes.page.off(this.config.namespace);
    }
  });

  return Drawer;
})();

theme.cart = {
	
  getCart: function() { // when cart page is loaded
//     this.getFreeShippingMinAmount();
    return $.getJSON('/cart.js');
  },

  changeItem: function(key, qty) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + qty + '&id=' + key,
      dataType: 'json'
    });
  },

  addItemFromForm: function(data) {
    return this._updateCart({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json'
    });
  },

  _updateCart: function(params) {
    return $.ajax(params)
      .then(function(cart) {
        return cart;
      }.bind(this))
  },

  updateNote: function(note) {
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + theme.cart.attributeToString(note),
      dataType: 'json',
      success: function(cart) {},
      error: function(XMLHttpRequest, textStatus) {}
    };

    $.ajax(params);
  },

  updateCurrency: function(currency) {
    var params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'currency=' + currency,
      dataType: 'json',
      success: function(cart) {},
      error: function(XMLHttpRequest, textStatus) {}
    };

    $.ajax(params);
  },

  attributeToString: function(attribute) {
    if ((typeof attribute) !== 'string') {
      attribute += '';
      if (attribute === 'undefined') {
        attribute = '';
      }
    }
    return $.trim(attribute);
  },

  updateBetterAsPairMessage: function (productItem, quantity) {
    var $productRow = productItem.closest('.cart__row--table-large');
    var betterAsPair = productItem.data('better-as-pair');
    var cartItemMessage = $productRow.find('.cart-item-message');
    
    if(betterAsPair && quantity % 2 != 0) {
      cartItemMessage.html("This product works great as a pair.  Do you want to add one more? :)");
    } else {
      cartItemMessage.html("");
    }
  },

  updateQuanity: function (key, quantity) {
    var $item = $(document.getElementById("cart-price_" + key));
    var $totalPrice = $('#cart-total-price');
    var shopCurrency = $item.attr('data-shop-currency'); 
    var currencies = ['CAD', 'USD', 'EUR', 'GBP', 'AUD', 'ARS', 'CLP', 'BRL'];

    if (!currencies.includes(shopCurrency))
      return;

    var $productItem = $item.closest('.product-item');
    var $productRow = $item.closest('.cart__row--table-large');
    var $lineItem = $productItem.find('.jw-price .cart__price-active');
    var baseCurrency = $lineItem.data('shop-currency');
    var baseCents = $lineItem.data('currency-origin');
    var cents = Currency.convert(baseCents, baseCurrency, shopCurrency);
    var subTotal = cents * quantity;
    var subTotalStr = Currency.formatMoney(subTotal, Currency[Currency.format][shopCurrency]);

    $item.html(subTotalStr);
    $item.attr('data-currency-origin', subTotal);
    $item.attr('data-quantity', quantity);
    $item.attr('data-shop-currency', shopCurrency);

    var total = 0;
    var $lineItems = $('.jw-action .cart__price-active');
    Array.prototype.forEach.call($lineItems, function (item) {
      var price = Number($(item).attr('data-currency-origin'));
      if (price) {
        price = Currency.convert(price, $(item).attr('data-shop-currency'), shopCurrency);
        total += price;
      }
    });

    var totalStr = Currency.formatMoney(total, Currency[Currency.format][shopCurrency]);
    $totalPrice.html(totalStr);
    $totalPrice.attr('data-currency-origin', total);
    $totalPrice.attr('data-shop-currency', shopCurrency);
  },
  
  getFreeShippingMinAmount: function (){
    var $freeShippingText = $('#free-shipping-text');
  	var clientCountryCode = $freeShippingText.attr('data-customer-country-code');
    var $totalPrice = $('#cart-total-price');
    var totalPrice = $totalPrice.data('currency-origin');
    var shopCurrency = $freeShippingText.attr('data-shop-currency');
    
    $.ajax({
      url        : theme.settings.apiBase + "/shipping-zones/rates",
      method     : "GET",
      dataType   : "json",
      contentType: "application/json",
      cache      : false,
    }).done((response) => {
      if (response.status === 'success' && response.message && response.message.length > 0) {
        const freeShippingRate = this.findFreeShippingRate(response.message, clientCountryCode);

        if (!freeShippingRate) {
          var $cartNotification = $('.cart-notification');
          $cartNotification.attr('style', "display: none;");
        } else {
          var freeShippingMinAmount = freeShippingRate.min_order_subtotal * 100;
          var freeShippingMinAmountStr = Currency.convert(freeShippingMinAmount, "USD", shopCurrency);

          $freeShippingText.attr('data-free-shipping-min-order-amount', freeShippingMinAmountStr);
          this.updateFreeShippingMinAmount();
        }
      }
    }).fail((error) => {
      console.log("couldn't get shipping rates: ",error);
    })

  },
  
  findFreeShippingRate: function(shipping_zones, countryCode) {
    for (const zone of shipping_zones){
      const countries = zone.countries;
      const countryIndex = countries.findIndex(country => country.code == countryCode);
      
      const shippingRates = zone.price_based_shipping_rates;
      const freeShippingRate = shippingRates.find(rate => rate.price == "0.00" && rate.min_order_subtotal) || {};
      
      if (countryIndex != -1 && Object.keys(freeShippingRate).length >0) {
      	return freeShippingRate;
      } else {
      	return null;
      }
    }
  },
  
  updateFreeShippingMinAmount() {
    var $freeShippingText = $('#free-shipping-text');
  	var $totalPrice = $('#cart-total-price');
    var shopCurrency = $totalPrice.attr('data-shop-currency');
    var freeShippingMinAmount = Number($freeShippingText.data('free-shipping-min-order-amount')); 
	
    var total = 0;
    var $lineItems = $('.jw-action .cart__price-active');
    Array.prototype.forEach.call($lineItems, function (item) {
      var price = Number($(item).attr('data-currency-origin'));
      if (price) {
        price = Currency.convert(price, $(item).attr('data-shop-currency'), shopCurrency);
        total += price;
      }
    });
    var awayAmount = freeShippingMinAmount - total;
    if (awayAmount > 0) {
      var awayAmountStr = Currency.formatMoney(awayAmount, Currency[Currency.format][shopCurrency]);

      $freeShippingText.html(`You're ${awayAmountStr} away from free shipping!`);
      $freeShippingText.attr('data-currency-origin', awayAmount);
    } else {
      $freeShippingText.html("You're eligible for free shipping!");
    }
    
  }
}

$(function() {
  // Add a loading indicator on the cart checkout button (/cart and drawer)
  $('body').on('click', '.cart__checkout', function() {
    $(this).addClass('btn--loading');
  });

  $('body').on('change', 'textarea[name="note"]', function() {
    var newNote = $(this).val();
    theme.cart.updateNote(newNote);
  });


  //the below function contents had been commented out to prevent an issue where the cart page was not usable.
  // Custom JS to prevent checkout without confirming terms and conditions
  //$('body').on('click', '.cart__checkout--ajax', function(evt) {
    //if ($('#CartAgree').is(':checked')) {
    //} else {
    //  alert(theme.strings.cartTermsConfirmation);
    //  $(this).removeClass('btn--loading');
    //  return false;
    //}
  //});

  //$('body').on('click', '.cart__checkout--page', function(evt) {
    //if ($('#CartPageAgree').is(':checked')) {
    //} else {
    //  alert(theme.strings.cartTermsConfirmation);
    //  $(this).removeClass('btn--loading');
    //  return false;
    //}
  //});

  $('body').on('change', '.cart__product-qty', function(evt) {
    var key = $(this).data('product-key');
    var quantity = Number($(this).val());
    var min = $(this).data('min');
    var max = $(this).data('max');
    var isBulk = $(this).data('bulk');
    var $error = $(this).closest('.jw-quantity').find('.cp-correction');
    var variantId = $(this).data('variant-id');
    var interval = 10;

    var skipErrorVariants = [
      40982200647791,
      40982200680559,
      41146400899183,
      41146400931951,
      41146400964719,
      41146691453039,
      41146693615727,
      41146710065263,
      41146711015535,
      41146712064111,
      41146746568815,
      41146749255791,
      41146750566511,
      41147309391983,
      41147310112879,
      41146768818287,
      41146770063471,
      41147302772847,
      41147303395439,
      41146400604271,
      41146400735343,
      41146400800879,
      41146400768111,
      41146400833647,
      41146667008111,
      41146666909807,
      41146666942575,
      41146666844271,
      41146667466863,
      41146667270255,
      41146667368559,
      41146667401327,
      41146667925615,
      41146667827311,
      41146667729007,
      41146400866415
    ];
    

      if (skipErrorVariants.includes(variantId)) {
      // Skip error handling for specific variants
      $(item).removeClass('error');
      $error.html("");
    } else {
    if (variantId === 40982200647791 ||
          variantId === 40982200680559 ||
          variantId === 40982200713327 ||
          variantId === 40982200746095 ||
          variantId === 40982200778863 ||
          variantId === 40982200811631 ||
          variantId === 40982200844399 ||
          variantId === 40982200877167 ||
          variantId === 40982201401455 ||
          variantId === 40982201434223 ||
          variantId === 40982201466991 ||
          variantId === 40982201499759 ||
          variantId === 40982201532527 ||
          variantId === 40982201565295 ||
          variantId === 40982201598063 ||
          variantId === 40982201630831 ||
          variantId === 40982201663599 ||
          variantId === 40982201696367 ||
          variantId === 40982201729135 ||
          variantId === 40982184820847 ||
          variantId === 40982184853615 ||
          variantId === 40982184886383 ||
          variantId === 40982184919151 ||
          variantId === 40982184951919 ||
          variantId === 40982184984687 ||
          variantId === 40982185017455 ||
          variantId === 40982185050223 ||
          variantId === 41055654740079 ||
          variantId === 41055654772847 ||
           variantId == 41094274351215 ||
           variantId == 41094274383983 ||
           variantId == 41094274416751 ||
           variantId == 41094274449519 ||
          variantId === 41055654707311 ||
          variantId === 41112044503151 ||
          variantId === 41112072552559 ||
          variantId === 41112045191279 ||
          variantId === 41112064131183 ||
          variantId === 41112058134639 ||
          variantId === 41224867053679 ||
          variantId === 41224867184751 ||
          variantId === 41224867479663 ||
          variantId === 41224867545199 ||
          variantId === 41167849848943 ||
          variantId === 41167853387887 ||
          variantId === 41167856042095 ||
          variantId === 41167857090671 ||
          variantId === 41167858925679 ||
          variantId == 41550730559599 ||
         variantId == 42039124918383 ||
         variantId == 42039124951151 ||
         variantId == 42039124983919 ||
         variantId == 42039125016687 
       ) {
        interval = 2;
      } else if (variantId === 40982200615023 ||
                 variantId === 40982183346287 ||
                 variantId === 51618205008244 ||
                 variantId === 51618205041012 ||
                 variantId === 51618205073780 ||
                 variantId === 51618199929204 ||
                 variantId === 51618199961972 ||
                 variantId === 51618199994740
                ) {
        interval = 5; 
      }
    
    var message = {
      invalid_quantity: 'Invalid amount.',
      out_of_stock: 'Only ' + max + ' amount in stock.',
      need_bulk: `Sold in multiples of ${interval}`,
    }

    if (quantity <= 0) {
      $(this).addClass('error');
      $error.html(message.invalid_quantity);
      return;
    } else if (quantity < min || quantity > max) {
      $(this).addClass('error');
      $error.html(message.out_of_stock);
      return;
    } else if (isBulk && quantity % interval !== 0 ) {
      $(this).addClass('error');
      $error.html(message.need_bulk);
      return;
    } else {
      $(this).removeClass('error');
      $error.html("");
    }

    theme.cart.changeItem(key, quantity).then(function (cart) {
      var $item = $(document.getElementById("cart-price_" + key));
      var $productItem = $item.closest('.product-item');
      theme.cart.updateQuanity(key, quantity);
      theme.cart.updateBetterAsPairMessage($productItem, quantity);
//       theme.cart.updateFreeShippingMinAmount();
      $('.cart-item__count').html(cart.item_count);
    });
  }});
});

theme.QtySelector = (function() {
  var classes = {
    input: '.js-qty__num',
    plus: '.js-qty__adjust--plus',
    minus: '.js-qty__adjust--minus'
  };

  function QtySelector($el, options) {
    this.$wrapper = $el;
    this.$originalInput = $el.find('input[type="number"]');
    this.minValue = this.$originalInput.attr('min') || 1;

    var defaults = {
      namespace: null
    };

    this.options = $.extend(defaults, options);

    this.source = $('#JsQty').html();
    this.template = Handlebars.compile(this.source);

    var quantities = {
      current: this._getOriginalQty(),
      add: this._getOriginalQty() + 1,
      minus: this._getOriginalQty() - 1
    };

    this.data = {
      key: this._getProductKey(),
      itemQty: quantities.current,
      itemAdd: quantities.add,
      itemMinus: quantities.minus,
      inputName: this._getInputName(),
      inputId: this._getId()
    }

    // Append new quantity selector then remove original
    this.$originalInput.after(this.template(this.data)).remove();
    this.$input = this.$wrapper.find(classes.input);
    this.$plus = this.$wrapper.find(classes.plus);
    this.$minus = this.$wrapper.find(classes.minus);

    this.initEventListeners();
  };

  QtySelector.prototype = $.extend({}, QtySelector.prototype, {
    _getProductKey: function() {
      return this.$originalInput.data('id') || null;
    },

    _getOriginalQty: function() {
      return parseInt(this.$originalInput.val());
    },

    _getInputName: function() {
      return this.$originalInput.attr('name');
    },

    _getId: function() {
      return this.$originalInput.attr('id');
    },

    initEventListeners: function() {
      this.$plus.on('click', function() {
        var qty = this.validateQty(this.$input.val());
        this.addQty(qty);
      }.bind(this));

      this.$minus.on('click', function() {
        var qty = this.validateQty(this.$input.val());
        this.subtractQty(qty);
      }.bind(this));

      this.$input.on('change', function() {
        var qty = this.validateQty(this.$input.val());
        this.changeQty(qty);
      }.bind(this));
    },

    addQty: function(number) {
      var qty = number + 1;
      this.changeQty(qty);
    },

    subtractQty: function(number) {
      var qty = number - 1;
      if (qty <= this.minValue) {
        qty = this.minValue;
      }
      this.changeQty(qty);
    },

    changeQty: function(qty) {
      this.$input.val(qty);
      $('body').trigger('qty' + this.options.namespace, [this.data.key, qty]);
    },

    validateQty: function(number) {
      if((parseFloat(number) == parseInt(number)) && !isNaN(number)) {
        // We have a valid number!
      } else {
        // Not a number. Default to 1.
        number = 1;
      }
      return parseInt(number);
    }
  });

  return QtySelector;
})();

theme.CartDrawer = (function() {
  var config = {
    namespace: '.ajaxcart'
  };

  var selectors = {
    drawer: '#CartDrawer',
    container: '#CartContainer',
    template: '#CartTemplate',
    fixedFooter: '.drawer__footer--fixed',
    fixedInnerContent: '.drawer__inner--has-fixed-footer',
    cartHeader: '.drawer__fixed-header',
    cartBody: '.jw-cart-items',
    cartBubble: '.cart-link__bubble',
    cartItemCount: '.cart-item__count'
  };

  function CartDrawer() {
    this.status = {
      loaded: false,
      loading: false
    };

    this.qtySelectors = [];

    this.drawer = new theme.Drawers('CartDrawer', 'cart');

    // Prep handlebars template
    var source = $(selectors.template).html();
    this.template = Handlebars.compile(source);

    // Build cart on page load so it's ready in the drawer
    theme.cart.getCart().then(this.buildCart.bind(this));

    this.initEventListeners();
  };

  CartDrawer.prototype = $.extend({}, CartDrawer.prototype, {
    initEventListeners: function() {
      $('body').on('updateCart' + config.namespace, this.initQtySelectors.bind(this));
      $('body').on('updateCart' + config.namespace, this.sizeFooter.bind(this));
      $('body').on('updateCart' + config.namespace, this.updateCartNotification.bind(this));
      $('body').on('drawerOpen.CartDrawer', this.sizeFooter.bind(this));

      $(window).on('resize' + config.namespace, $.debounce(150, this.sizeFooter.bind(this)));

      $('body').on('added.ajaxProduct', function() {
        theme.cart.getCart().then(function(cart) {
          this.buildCart(cart, true);
        }.bind(this));
      }.bind(this));
    },

    buildCart: function(cart, openDrawer) {
      this.loading(true);
      this.emptyCart();

      if (cart.item_count === 0) {
        $(selectors.container).append('<p class="appear-animation appear-delay-3">' + theme.strings.cartEmpty +'</p>');
        $(selectors.cartItemCount).html(0);
      } else {
        var items = [];
        var item = {};
        var data = {};
        var animation_row = 1;

        $.each(cart.items, function(index, product) {

          if (!theme.settings.lastProduct)
            return;
          
          if (theme.settings.lastProduct.variant_id !== product.variant_id)
            return;

          var prodImg;
          if (product.image !== null) {
            prodImg = product.image.replace(/(\.[^.]*)$/, "_180x$1");
          } else {
            prodImg = '//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif';
          }

          if (product.properties !== null) {
            $.each(product.properties, function(key, value) {
              if (key.charAt(0) === '_' || !value) {
                 delete product.properties[key];
               }
            });
          }

          animation_row+=2;

          item = {
            key: product.key,
            url: product.url,
            img: prodImg,
            animationRow: animation_row,
            name: product.product_title,
            variation: product.variant_title,
            properties: product.properties,
            itemQty: product.quantity,
            price: theme.Currency.formatMoney(product.price, theme.settings.moneyFormat),
            priceNet: product.price,
            discountedPrice: theme.Currency.formatMoney((product.price - (product.total_discount/product.quantity)), theme.settings.moneyFormat),
            discountedPriceNet: (product.price - (product.total_discount/product.quantity)),
            discounts: product.discounts,
            discountsApplied: product.price === (product.price - product.total_discount) ? false : true,
            vendor: product.vendor
          };

          items.push(item);
        });

        animation_row+=2;

        data = {
          items: items,
          note: cart.note,
          lastAnimationRow: animation_row,
          totalPrice: theme.Currency.formatMoney(cart.total_price, theme.settings.moneyFormat),
          totalPriceNet: cart.total_price,
          totalCartDiscount: cart.total_discount === 0 ? 0 : theme.strings.cartSavings.replace('[savings]', theme.Currency.formatMoney(cart.total_discount, theme.settings.moneyFormat))
        };

        $(selectors.container).append(this.template(data));
      }

      this.status.loaded = true;
      this.loading(false);

      if ($('body').hasClass('currencies-enabled')) {
        // Disable ajax refreshing?
        //theme.currencySwitcher.ajaxrefresh();
      }

      $('body').trigger('updateCart' + config.namespace, cart);

      if (window.Shopify && Shopify.StorefrontExpressButtons) {
        Shopify.StorefrontExpressButtons.initialize();

        // Resize footer after arbitrary delay for buttons to load
        setTimeout(function() {
          this.sizeFooter();
        }.bind(this), 800);
      }

      // If specifically asked, open the cart drawer (only happens after product added from form)
      if (openDrawer === true) {
        this.drawer.open();

        // Scroll To Top after open a drawer
        if ($(window).width() >= 768) {
          $('html, body').animate({
            scrollTop: 0
          }, 500);
        }
      }
    },

    initQtySelectors: function() {
      this.qtySelectors = [];

      $(selectors.container).find('.js-qty').each(function(index, el) {
        var selector = new theme.QtySelector($(el), {
          namespace: '.cart-drawer'
        });
        this.qtySelectors.push(selector);
      }.bind(this));

      $('body').on('qty.cart-drawer', this.updateItem.bind(this));
    },

    updateItem: function(evt, key, qty) {
      if (this.status.loading) {
        return;
      }

      this.loading(true);

      theme.cart.changeItem(key, qty)
        .then(function(cart) {
          this.updateSuccess(cart);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.updateError(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          this.loading(false);
        }.bind(this));
    },

    loading: function(state) {
      this.status.loading = state;

      if (state) {
        $(selectors.container).addClass('is-loading');
      } else {
        $(selectors.container).removeClass('is-loading');
      }
    },

    emptyCart: function() {
      $(selectors.container).empty();
    },

    updateSuccess: function(cart) {
      this.buildCart(cart)
    },

    updateError: function(XMLHttpRequest) {
      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);
      }
    },

    // Update elements after cart is updated
    sizeFooter: function() {
      // Stop if our drawer doesn't have a fixed footer
      if (!$(selectors.drawer).hasClass('drawer--has-fixed-footer')) {
        return;
      }

      // Elements are reprinted regularly so selectors are not cached
      var $cartDrawer = $(selectors.drawer).removeAttr('style');
      var $cartHeader = $(selectors.drawer).find(selectors.cartHeader).removeAttr('style');
      var $cartBody = $(selectors.drawer).find(selectors.cartBody).removeAttr('style');
      var $cartFooter = $(selectors.drawer).find(selectors.fixedFooter).removeAttr('style');
      var $cartInner = $(selectors.drawer).find(selectors.fixedInnerContent).removeAttr('style');
      var cartHeaderHeight = $cartHeader.outerHeight();
      var cartBodyHeight = $cartBody.outerHeight();
      var cartFooterHeight = $cartFooter.outerHeight();

      $cartInner.css('bottom', cartFooterHeight);
      $cartFooter.css('height', cartFooterHeight);

      if ($(window).width() < 768) {
        $cartDrawer.css('height', cartHeaderHeight + cartBodyHeight + cartFooterHeight);
      }
    },

    updateCartNotification: function(evt, cart) {
      if (cart.items.length > 0) {
        $(selectors.cartBubble).addClass('cart-link__bubble--visible');
      } else {
        $(selectors.cartBubble).removeClass('cart-link__bubble--visible');
      }

      var item_count = 0;
      $.each(cart.items, function(index, product) {
        item_count += product.quantity;
      });
      $(selectors.cartItemCount).html(item_count);
    }
  });

  return CartDrawer;
})();

theme.AjaxProduct = (function() {
  var status = {
    loading: false
  };

  function ProductForm($form) {
    this.$form = $form;
    this.$addToCart = this.$form.find('.add-to-cart');
    this.$quantity = this.$form.find('.product__quantity--input');
    this.$error = this.$form.find('.cp-correction');

    if (this.$form.length) {
      this.$form.on('submit', this.addItemFromForm.bind(this));
      this.$quantity.on('input change paste keyup', this.validateForm.bind(this));
    }
  };

  ProductForm.prototype = $.extend({}, ProductForm.prototype, {
    addItemFromForm: function(evt, callback) {
      evt.preventDefault();

      if (this.validate() !== '') {
        this.$quantity.addClass('error');
        this.$error.html(this.validate());
        return;
      } else {
        this.$quantity.removeClass('error');
        this.$error.html("");
      }

      if (status.loading) {
        console.warn('already adding item to cart | bail');
        return;
      }

      // Loading indicator on add to cart button
      this.$addToCart.addClass('btn--loading');

      status.loading = true;

      var data = this.$form.serialize();

      theme.cart.addItemFromForm(data)
        .then(function(product) {
          this.success(product);
        }.bind(this))
        .catch(function(XMLHttpRequest) {
          this.error(XMLHttpRequest)
        }.bind(this))
        .always(function() {
          status.loading = false;
          this.$addToCart.removeClass('btn--loading');
        }.bind(this));
    },

    validate: function() {
      var quantity = this.$quantity.val();
      var isBulk = this.$quantity.data('bulk');
      var message = {
        empty: 'Please enter a value',
        unvalid: 'Sold in multiples of 10'
      };

      if (quantity === '' || parseFloat(quantity) < 1 )
        return message.empty;

      if (isBulk && parseFloat(quantity) % 10 !== 0)
        return message.unvalid;

      return '';
    },

    validateForm: function() {
      if (this.validate() !== '') {
        this.$quantity.addClass('error');
        this.$error.html(this.validate());
      } else {
        this.$quantity.removeClass('error');
        this.$error.html("");
      }
    },

    success: function(product) {
      this.$form.find('.errors').remove();
      theme.settings.lastProduct = product;
      $('body').trigger('added.ajaxProduct');
    },

    error: function(XMLHttpRequest) {
      this.$form.find('.errors').remove();

      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        console.warn(XMLHttpRequest.responseJSON.description);

        this.$form.prepend('<div class="errors text-center">' + XMLHttpRequest.responseJSON.description + '</div>');
      }
    }
  });

  return ProductForm;
})();


theme.AjaxProductV2 = (function() {
  let status = {
    loading: false,
    products: []
  };

  let selectors = {
    variantItem: '.variant-item',
    variantError: '.cp-variant-error',
    qtyWrapper: '.qty-wrapper',
    qtySelector: '.qty-selector',
    itemQty: '.js-qty__input',
    itemAdd: '.js-qty__adjust--plus',
    itemMinus: '.js-qty__adjust--minus',
    addToCart: '.add-to-cart',
    itemSubTotal: '.item-sub-total',
    formSubTotal: '.form-sub-total',
    subForm: '.bulk-sub-form',
    formError: '.cp-form-error',
    lowQuantityWarning: '.low-inventory-warning',
    lowInventoryWarningMessage: '.low-inventory-warning-message',
  };

  function ProductForm($form) {
    //console.log("ProductForm Called By: " + ProductForm.caller);
    this.$form = $form;
    this.$itemQty = this.$form.find(selectors.itemQty);
    this.$itemAdd = this.$form.find(selectors.itemAdd);
    this.$itemMinus = this.$form.find(selectors.itemMinus);
    this.$addToCart = this.$form.find(selectors.addToCart);
    this.$subTotal = this.$form.find(selectors.formSubTotal);
    this.$error = this.$form.find(selectors.formError);
    this.$lowQuantityWarning = this.$form.find(selectors.lowQuantityWarning);

    if (this.$form.length) {
      this.$addToCart.unbind('click').bind('click', this.handleAddToCart.bind(this));
      this.$itemQty.on('input change paste keyup', this.handleChangeQty.bind(this));
      this.$itemAdd.on('click', this.handleAddItem.bind(this));
      this.$itemMinus.on('click', this.handleSubtractItem.bind(this));
    }
    
    if (!this.$form.data('use-total-quantity')) {
    	this.init();
    } else {
      if (this.$form.data('product-available')){
        this.updateNotifyMe('Global');
      } else {
        this.showProductNotifyMe(this.$form, 'Global');
      }
      
      this.updateLowQuantity();
    }
    
    this.updateStatus();
  }

  ProductForm.prototype = $.extend({}, ProductForm.prototype, {
    _updateCart: function(product) {
      let self = this;
      return new Promise(resolve => {
        try {
          CartJS.addItem(product.id, product.quantity, {}, {
            // Define a success callback to display a success message.
            "success": function(data, textStatus, jqXHR) {
              resolve('resolved');
            },

            // Define an error callback to display an error message.
            "error": function(jqXHR, textStatus, errorThrown) {
              self.error(jqXHR);
              resolve('failed');
            }
          });
        } catch (e) {
          resolve('failed');
        }
      })
    },
  
    init: function() {
      //console.log("Init Called By: " + ProductForm.prototype.init.caller);
      let productId = this.$form.data('product-id');
      //console.log("Product ID:" + productId);
      
      $.ajax({
        url        : theme.settings.apiBase + `/product/${productId}/inventory-level`,
        method     : "GET",
        dataType   : "json",
        contentType: "application/json",
        cache      : false,
      }).done((response) => {
        //console.log("Ajax Done")
        //console.log(response)
        if (response.status === 'success' && response.inventory_levels && response.inventory_levels.length > 0) {
          this.updateAvailability(this.$form, response.inventory_levels);
           //console.log("inventory!", response.inventory_levels)
        }
      }).fail((error) => {
        console.log(error);
      });
    },

    updateAvailability: function($form, inventoryLevels) {
      //console.log("Update Availablity Called By: " + ProductForm.prototype.updateAvailability.caller);
      let shippingCountry = $form.data('shipping-country');
      console.log("Shipping Country = " + shippingCountry)
      let isEuropeDistribution = shippingCountry !== '' ? theme.settings.euDistributionCountries.includes(shippingCountry) : theme.settings.euDistributionCountries.includes(theme.base.ipInfo.country);
      //console.log("ship from europe: " + isEuropeDistribution);
      let totalQty = 0;
      //console.log("Variant IDS: " + $form.data('product-variant_ids'));
      //console.log($(selectors.variantItem));

      Array.prototype.forEach.call($(selectors.variantItem), function (item) {
        let $variantItem = $(item);
        //console.log($variantItem)
        let variantId = $variantItem.data('variant-id').toString();
        let productId = $variantItem.closest('[data-product-id]').data('product-id');
  
        let quantity = 0;

        //console.log(inventoryLevels)
        inventoryLevels.forEach((inventoryLevel) => {
          //do not play with the In-person Event inventory
          if (inventoryLevel.location_id == "61100032111")
              return;
          //if (inventoryLevel.location_id == "6349193327")
            //  console.log("MARKHAM INVENTORY")
          //if (inventoryLevel.location_id == "35962519663")
            //  console.log("UK INVENTORY")
          //console.log("inventory level for var: " + inventoryLevel.variant_id + " is: " + inventoryLevel.available);
          //console.log("first check :: " + inventoryLevel.variant_id !== variantId)
          if (inventoryLevel.variant_id !== variantId)
            return;
          //console.log(inventoryLevel)

          if ((isEuropeDistribution && !theme.settings.euDistributionCountries.includes(inventoryLevel.country_code)) ||
              (!isEuropeDistribution && theme.settings.euDistributionCountries.includes(inventoryLevel.country_code)))
            return;

          //console.log("Available Inventory for: " + inventoryLevel.variant_id + " is: " + inventoryLevel.available)
          //console.log("Old Quantity: " + quantity);
         // console.log("Inventory to add: " + inventoryLevel.available);
          let qty = quantity + inventoryLevel.available;
          //console.log("Proposed New Quantity" + qty);
          quantity += inventoryLevel.available;
          //console.log("new quantity: " + quantity);
        });

        let $qtyWrapper = $('#qty-wrapper-' + variantId);
        let $qtyInput = $('#updates_' + variantId);
        let currentCartQuantity = $qtyInput.data('cart-quantity');
        let withoutCartQuantity = quantity;
        
        if (currentCartQuantity) {
         	withoutCartQuantity -= currentCartQuantity;
        }

       // Removed the 'not-available' for specific variants for 12G TITANIUM LABRET POST - THREADED
        if (variantId == '41094274351215') {
          $qtyWrapper.removeClass('not-available');
        } else if (variantId == '41111898357871') {
           $qtyWrapper.removeClass('not-available');
        } else if (variantId == '41102172717167') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '41094274383983') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '41094274416751') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '41094274449519') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52324385554804') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52324379296116') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52324396826996') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52324355244404') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52324409311604') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52324300587380') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52091654111604') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52073119351156') {
            $qtyWrapper.removeClass('not-available');
          // Prong-Set Gem 3 Claws - Threadless
        } else if (variantId == '52073119351156') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52073119842676') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52073122398580') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52073123840372') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52080684204404') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52082667979124') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52080694296948') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52073123840372') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '51641907282292') {
            $qtyWrapper.removeClass('not-available');

        

         // Prong-Set Gem 4 Claws - Threadless          
        } else if (variantId == '52073125970292') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52073130000756') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52073131475316') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52073133015412') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52080689643892') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52960503529844') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52960503562612') {
            $qtyWrapper.removeClass('not-available');
        } else if (variantId == '52960503595380') {
            $qtyWrapper.removeClass('not-available');     

        } else if (productId == '4388021370991') {
        $qtyWrapper.removeClass('not-available'); 
        // } else if (inventoryLevel.location_id == "35962519663" && variantId == '52989768728948') {
        //      $qtyWrapper.removeClass('not-available');          
        } else if (quantity <= 0) {
          // Update Quantity Controller
          // $qtyWrapper.addClass('not-available');
        } else {
          $qtyInput.attr('max', withoutCartQuantity);
          $qtyInput.attr('data-max', withoutCartQuantity);
        }
      });
      
      inventoryLevels.forEach((inventoryLevel) => {
        if ((isEuropeDistribution && !theme.settings.euDistributionCountries.includes(inventoryLevel.country_code)) ||
              (!isEuropeDistribution && theme.settings.euDistributionCountries.includes(inventoryLevel.country_code)))
            return;
        
        totalQty += inventoryLevel.available;
      });
      
      let location = isEuropeDistribution ? 'UK' : 'Markham';
      
      if (totalQty <= 0){
        this.showProductNotifyMe($form, location);
      } else {
        this.updateNotifyMe(location);
      }
      
      this.updateLowQuantity();
    },
      
    showProductNotifyMe: function(form, location) {
      //Update product notify form
      let variantWrapper = $('#product-action-wrapper-' + form.data('product-id'));
        
      let $addToCartWrapper = variantWrapper.find('.add-to-cart-wrapper');
      $addToCartWrapper.removeClass('is-visible');
        
      let $notifyFormWrapper = variantWrapper.find('.notify-form-wrapper');
      $notifyFormWrapper.addClass('is-visible');
      
      let $notifyForm = $notifyFormWrapper.find('.notify-form');
      $notifyForm.data('variant-ids', form.data('product-variant_ids'));
      $notifyForm.data('location', location);
    },
    
    updateLowQuantity: function() {
      Array.prototype.forEach.call($(selectors.variantItem), function (item) {
        let $variantItem = $(item);
        let variantId = $variantItem.data('variant-id').toString();
        let $parent = $('#low-inventory-warning-' + variantId);
        let $qtyInput = $('#updates_' + variantId);
        let quantity = $qtyInput.attr('data-max');
      	let $error = $parent.find(selectors.lowInventoryWarningMessage);
//         let isBulk = $itemQty.data('bulk');
        

          if (quantity <= 10 && quantity > 0) {
            $parent.addClass('is-visible');
            $error.html('Only ' + quantity + ' left in stock - order soon');
          }

      });
    },
    
    updateNotifyMe: function(location) {
      Array.prototype.forEach.call($(selectors.subForm), function (item) {
        let $subForm = $(item);
        let $notifyFormWrapper = $subForm.find('.jw-notify-form');
        let $notifyForm = $notifyFormWrapper.find('.notify-form');
        var soldOutVariants = [];
        
        Array.prototype.forEach.call($subForm.find(selectors.variantItem), function (variantItem) {
          let $variantItem = $(variantItem);
          let variantId = $variantItem.data('variant-id').toString();
          let $qtyInput = $('#updates_' + variantId);
          let quantity = $qtyInput.attr('data-max');

          if (quantity <= 0) {
            soldOutVariants.push(variantId);
          }
        });
        
        if (soldOutVariants.length > 0) {
          $notifyFormWrapper.addClass('has-sold-out-variant');
          $notifyForm.data('variant-ids', soldOutVariants);
          $notifyForm.data('location', location);
        }
      });
    },

    updateStatus: function($itemQty = null) {
      let $parent = $itemQty ? $itemQty.closest(selectors.variantItem) : null;
      let itemSubtotal = 0;
      let subTotal = 0;
      let products = [];

      Array.prototype.forEach.call(this.$form.find(selectors.variantItem), function (item) {
        if (!$(item).find(selectors.itemQty).length)
          return;

        let quantity = Number($(item).find(selectors.itemQty).val());
        let price = Number($(item).find(selectors.itemQty).attr('data-price'));
        let variantId = Number($(item).find(selectors.itemQty).data('variant-id'));

        subTotal += quantity * price;
        if (quantity > 0) {
          products.push({
            "quantity": quantity,
            "id": variantId
          })
        }

        if ($parent && ($(item).data('category') === $parent.data('category'))) {
          itemSubtotal += quantity * price;
        }
      });

      // update item sub total
      if ($itemQty) {
        this.updateItemSubTotal($itemQty, itemSubtotal);
      }

      // update form sub total
      this.updateSubTotal(subTotal);

      // update status for products object
      status.products = products;
    },

    updateItemSubTotal: function($itemQty, price) {
      let $itemSubTotal = $itemQty.closest(selectors.subForm).find(selectors.itemSubTotal);
      let currentCurrency = $itemSubTotal.attr('data-shop-currency');
      let subTotal = Currency.formatMoney(price, Currency[Currency.format][currentCurrency]);
      $itemSubTotal.html(subTotal);
      $itemSubTotal.attr('data-currency-origin', price);
    },

    updateSubTotal: function(price) {
      let currentCurrency = this.$subTotal.attr('data-shop-currency');
      let defaultCurrency = $('#CurrencyData').data('default-currency');
      const currencyToUse = currentCurrency || defaultCurrency
      let subTotal = Currency.formatMoney(price, Currency[Currency.format][currencyToUse]);
      this.$subTotal.html(subTotal);
      this.$subTotal.attr('data-currency-origin', price);
    },

    handleErrorChange: function($itemQty, error) {
      let $parent = $itemQty.closest(selectors.variantItem);
      let $error = $parent.find(selectors.variantError);

      if (!error) {
        $parent.removeClass('has-error');
        $error.html('');

        // init form error
        this.$form.removeClass('has-error');
        this.$error.html('');
      } else {
        $parent.addClass('has-error');
        $error.html(error);
      }
    },

    addItemsFromForm: async function(products) {
      try {
        let response = true;
        await Promise.all(products.map(async (product) => {
          let result = await this._updateCart(product);
          if (result === 'failed')
            response = false;
        }));

        return response;
      } catch (e) {
        console.log('err', e);
        return false;
      }
    },

    handleAddToCart: function() {
      let self = this;

      if (status.loading)
        return;

      // refresh form before submit to get fresh information
      this.updateStatus();

      let $errors = this.$form.find(selectors.variantItem + '.has-error')
      if ($errors.length > 0)
        return;

      if (!status.products.length) {
        this.$form.addClass('has-error');
        this.$error.html('Please select at least one product')
        return;
      }

      status.loading = true;
      this.$addToCart.addClass('btn--loading');

      this.addItemsFromForm(status.products)
        .then(function (response) {
          if (response)
            self.success();
        })
        .catch(function(XMLHttpRequest) {
          self.error(XMLHttpRequest)
        })
        .finally(function () {
          status.loading = false;
          self.$addToCart.removeClass('btn--loading');
        });
    },

    handleChangeQty: function(e) {
      let $itemQty = $(e.target);
      let quantity = Number($itemQty.val());
      let min = $itemQty.data('min');
      let max = $itemQty.data('max');
      let isBulk = $itemQty.data('bulk');
      let error = null;
      let interval = $itemQty.data('interval') ? $itemQty.data('interval') : 1;
      let variantId = $itemQty.data('variant-id');

      if (variantId === 40982200647791 ||
          variantId === 40982200680559 ||
          variantId === 40982200713327 ||
          variantId === 40982200746095 ||
          variantId === 40982200778863 ||
          variantId === 40982200811631 ||
          variantId === 40982200844399 ||
          variantId === 40982200877167 ||
          variantId === 40982201401455 ||
          variantId === 40982201434223 ||
          variantId === 40982201466991 ||
          variantId === 40982201499759 ||
          variantId === 40982201532527 ||
          variantId === 40982201565295 ||
          variantId === 40982201598063 ||
          variantId === 40982201630831 ||
          variantId === 40982201663599 ||
          variantId === 40982201696367 ||
          variantId === 40982201729135 ||
          variantId === 40982184820847 ||
          variantId === 40982184853615 ||
          variantId === 40982184886383 ||
          variantId === 40982184919151 ||
          variantId === 40982184951919 ||
          variantId === 40982184984687 ||
          variantId === 40982185017455 ||
          variantId == 41094274351215 ||
          variantId == 41094274383983 ||
          variantId == 41094274416751 ||
          variantId == 41094274449519 ||
          variantId === 40982185050223 ||
          variantId === 41167849848943 ||
          variantId === 41167853387887 ||
          variantId === 41167856042095 ||
          variantId === 41167857090671 ||
          variantId === 41167858925679 ||
          variantId === 41550730559599 ||
           variantId == 42039124918383 ||
           variantId == 42039124951151 ||
           variantId == 42039124983919 ||
           variantId == 42039125016687 
         ) {
        interval = 2;
      } else if (variantId === 40982200615023 ||
                 variantId === 40982183346287 ||
                 variantId === 51618205008244 ||
                 variantId === 51618205041012 ||
                 variantId === 51618205073780 ||
                 variantId === 51618199929204 ||
                 variantId === 51618199961972 ||
                 variantId === 51618199994740
                ) {
        interval = 5; 
        }
      if (quantity === 0)
        $itemQty.addClass('is-zero');
      else
        $itemQty.removeClass('is-zero');

      if (quantity > max) {
        error = 'Only ' + max + ' amount in stock.';
      } else if (quantity < interval) {
        error = 'Invalid Amount';
      } else if (isBulk && quantity % interval !== 0) {
        error = `Sold in multiples of ${interval}`;
      } else if (quantity % interval !== 0) {
       	error = 'Sold in multiples of ' + interval; 
      }

      this.handleErrorChange($itemQty, error);

      if (!error) {
        this.updateStatus($itemQty);
      }
    },

    handleAddItem: function(e) {
      let $itemQty = $(e.target).closest(selectors.qtySelector).find(selectors.itemQty);
      let max = $itemQty.data('max');
      let isBulk = $itemQty.data('bulk');
      let minSku = $itemQty.data('min-sku');
      let interval = $itemQty.data('interval') ? $itemQty.data('interval') : 1;
      let variantId = $itemQty.data('variant-id');

      if (variantId === 40982200647791 ||
          variantId === 40982200680559 ||
          variantId === 40982200713327 ||
          variantId === 40982200746095 ||
          variantId === 40982200778863 ||
          variantId === 40982200811631 ||
          variantId === 40982200844399 ||
          variantId === 40982200877167 ||
          variantId === 40982201401455 ||
          variantId === 40982201434223 ||
          variantId === 40982201466991 ||
          variantId === 40982201499759 ||
          variantId === 40982201532527 ||
          variantId === 40982201565295 ||
          variantId === 40982201598063 ||
          variantId === 40982201630831 ||
          variantId === 40982201663599 ||
          variantId === 40982201696367 ||
          variantId === 40982201729135 ||
          variantId === 40982184820847 ||
          variantId === 40982184853615 ||
          variantId === 40982184886383 ||
          variantId === 40982184919151 ||
          variantId === 40982184951919 ||
          variantId === 40982184984687 ||
          variantId === 40982185017455 ||
           variantId == 41094274351215 ||
           variantId == 41094274383983 ||
           variantId == 41094274416751 ||
           variantId == 41094274449519 ||
          variantId === 40982185050223 ||
          variantId === 41167849848943 ||
          variantId === 41167853387887 ||
          variantId === 41167856042095 ||
          variantId === 41167857090671 ||
          variantId === 41167858925679 ||
          variantId === 41550730559599 ||
         variantId == 42039124918383 ||
         variantId == 42039124951151 ||
         variantId == 42039124983919 ||
         variantId == 42039125016687   
         ) {
        interval = 2;
    } else if (variantId === 40982200615023 ||
               variantId === 40982183346287 ||
               variantId === 51618205008244 ||
               variantId === 51618205041012 ||
               variantId === 51618205073780 ||
               variantId === 51618199929204 ||
               variantId === 51618199961972 ||
               variantId === 51618199994740
              ) {
      interval = 5; 
       }
      let error = null;

      let quantity = isBulk ? 
          Math.floor(Number($itemQty.val()) / interval) * interval + interval : 
          Number($itemQty.val()) + interval;

      if (quantity < interval)
        quantity = interval

      if (quantity > 0)
        $itemQty.removeClass('is-zero')

      if (quantity > max)
        return;

      if (isBulk && quantity % interval !== 0) {
        error = `Sold in multiples of ${interval}`;
      }

      $itemQty.val(quantity);

      this.handleErrorChange($itemQty, error);
      if (!error) {
        this.updateStatus($itemQty);
      }
    },

    handleSubtractItem: function(e) {
      let $itemQty = $(e.target).closest(selectors.qtySelector).find(selectors.itemQty);
      let min = $itemQty.data('min');
      let max = $itemQty.data('max');
      let isBulk = $itemQty.data('bulk');
      let minSku = $itemQty.data('min-sku');
      let interval = $itemQty.data('interval') ? $itemQty.data('interval') : 1;
      let error = null;
      let variantId = $itemQty.data('variant-id');

      if (variantId === 40982200647791 ||
          variantId === 40982200680559 ||
          variantId === 40982200713327 ||
          variantId === 40982200746095 ||
          variantId === 40982200778863 ||
          variantId === 40982200811631 ||
          variantId === 40982200844399 ||
          variantId === 40982200877167 ||
          variantId === 40982201401455 ||
          variantId === 40982201434223 ||
          variantId === 40982201466991 ||
          variantId === 40982201499759 ||
          variantId === 40982201532527 ||
          variantId === 40982201565295 ||
          variantId === 40982201598063 ||
          variantId === 40982201630831 ||
          variantId === 40982201663599 ||
          variantId === 40982201696367 ||
          variantId === 40982201729135 ||
          variantId === 40982184820847 ||
          variantId === 40982184853615 ||
          variantId === 40982184886383 ||
          variantId === 40982184919151 ||
          variantId === 40982184951919 ||
          variantId === 40982184984687 ||
          variantId === 40982185017455 ||
          variantId == 41094274351215 ||
           variantId == 41094274383983 ||
           variantId == 41094274416751 ||
           variantId == 41094274449519 ||
          variantId === 40982185050223 ||
          variantId === 41167849848943 ||
          variantId === 41167853387887 ||
          variantId === 41167856042095 ||
          variantId === 41167857090671 ||
          variantId === 41167858925679 ||
          variantId === 41550730559599 ||
           variantId == 42039124918383 ||
           variantId == 42039124951151 ||
           variantId == 42039124983919 ||
           variantId == 42039125016687 
         ) {
        interval = 2;
      } else if (variantId === 40982200615023 ||
                 variantId === 40982183346287 ||
                 variantId === 51618205008244 ||
                 variantId === 51618205041012 ||
                 variantId === 51618205073780 ||
                 variantId === 51618199929204 ||
                 variantId === 51618199961972 ||
                 variantId === 51618199994740
                ) {
        interval = 5; 
      }
      
      let quantity = isBulk ? 
          Math.ceil(Number($itemQty.val()) / interval) * interval - interval :  
          Number($itemQty.val()) - interval;
      
      if(quantity < interval)
        quantity = 0;

      if (quantity <= 0 || quantity < minSku)
        $itemQty.addClass('is-zero')

      if (quantity < min)
        return;

      if (isBulk && quantity % interval !== 0) {
        error = `Sold in multiples of ${interval}`;
      }

      if (quantity > max) {
        error = 'Only ' + max + ' amount in stock.';
      }

      $itemQty.val(quantity);

      this.handleErrorChange($itemQty, error);
      if (!error) {
        this.updateStatus($itemQty);
      }
    },

    success: function() {
      // last product for cart drawer - should be updated for bulk order functionality
      theme.settings.lastProduct = {
        "variant_id": status.products[0].id
      };
      $('body').trigger('added.ajaxProduct');
    },

    error: function(XMLHttpRequest) {
      if (XMLHttpRequest.responseJSON && XMLHttpRequest.responseJSON.description) {
        this.$form.addClass('has-error');
        this.$error.html(XMLHttpRequest.responseJSON.description);
        console.warn(XMLHttpRequest.responseJSON.description);
      }
    }
  });

  return ProductForm;
})();

theme.NotifyForm = (function() {
  let status = {
    loading: false,
    completed: false,
    products: []
  };

  let selectors = {
    btnActivateForm: '.btn-activate-form',
    btnSubmitForm: '.btn-submit-form',
    email: '.notify-email',
    formBody: '.form-body',
    formNotification: '.form-notification',
    formError: '.cp-form-error',
  };

  function NotifyForm($form) {
    this.$form = $form;
    this.$btnActivateForm = this.$form.find(selectors.btnActivateForm);
    this.$btnSubmitForm = this.$form.find(selectors.btnSubmitForm);
    this.$formBody = this.$form.find(selectors.formBody);
    this.$formNotification = this.$form.find(selectors.formNotification);
    this.$email = this.$form.find(selectors.email);
    this.$error = this.$form.find(selectors.formError);
    this.completed = false;

    if (this.$form.length) {
      this.$email.on('input change paste keyup', this.handleChangeEmail.bind(this));
      this.$email.bind("enterKey", this.handleSubmitForm.bind(this));
      this.$btnActivateForm.on('click', this.handleActivateForm.bind(this));
      this.$btnSubmitForm.on('click', this.handleSubmitForm.bind(this));
    }
  }

  NotifyForm.prototype = $.extend({}, NotifyForm.prototype, {
    handleChangeEmail: function(e) {
      if(e.keyCode === 13) {
        this.handleSubmitForm();
        return;
      }

      if (!this.$form.hasClass('has-error'))
        return;

      this.validateForm();
    },

    handleActivateForm: function(e) {
      this.$btnActivateForm.remove();
      this.$formBody.removeClass('d-none');
    },

    handleSubmitForm: function(e) {
      if (status.loading || this.completed)
        return;

      if (!this.validateForm())
        return;

      let email = this.$email.val();
      let product = null;

      // Get variant ids for sold out items
      let variantIds = this.$form.data('variant-ids');
      variantIds = variantIds.toString().split(',');
      if (!variantIds.length) {
        this.error("Something went wrong. Please try again later");
        return;
      }

      // Get product object
      let productJson = 'ProductJson-' + this.$form.data('section-id');
      if ($('#' + productJson).html()) {
        let productJsonObj = JSON.parse(document.getElementById(productJson).innerHTML);
        product = {
          product_id: productJsonObj.id,
          variant_ids: variantIds,
          product_handle: productJsonObj.handle,
          product_title: productJsonObj.title,
          product_price: this.getPrice(productJsonObj.price),
          product_type: productJsonObj.type,
          product_vendor: productJsonObj.vendor,
          product_image: 'https:' + productJsonObj.featured_image,
          location: this.$form.data('location')
        }
      }

      if (!product) {
        this.error("Something went wrong. Please try again later");
        return;
      }

      let config = {
        url        : theme.settings.apiBase + "/notify",
        method     : "POST",
        dataType   : "json",
        contentType: "application/json",
        cache      : false,
        data       : JSON.stringify({
          email   : email,
          ...product,
        })
      };

      this.loading(true);

      $.ajax(config)
        .done((data) => {
          this.success();
          this.loading(false);
        }).fail((error) => {
          if (error.responseJSON && error.responseJSON.message && error.status === 409) {
            // disable error message for duplication - user experience
            // this.error(error.responseJSON.message);
            this.success();
            this.loading(false);
          } else {
            this.error("Something went wrong. Please try again later");
          }
          this.loading(false);
        });
    },

    getPrice: function(cent) {
      let price = (cent / 100.0).toFixed(0);
      let currency =  $('#CurrencyData').data('shop-currency');

      // Special case when the currencies are updated
      if (Shopify && Shopify.currency)
        currency = Shopify.currency.active;

      switch (currency) {
        case 'USD':
          price = '$' + price + ' USD';
          break;
        case 'CAD':
          price = '$' + price + ' CAD';
          break;
        case 'AUD':
          price = '$' + price + ' AUD';
          break;
        case 'EUR':
          price = '€' + price;
          break;
        case 'GBP':
          price = '£' + price;
          break;
        case 'ARS':
          price = '$' + price + ' ARS';
          break;
        case 'CLP':
          price = '$' + price + ' CLP';
          break;
        case 'BRL':
          price = 'R$ ' + price;
          break;
        default:
          price = '$' + price + ' USD';
          break;
      }

      return price;
    },

    validateForm: function() {
      let email = this.$email.val();

      if (!email || email === '') {
        this.error('Please enter an email.');
        return false;
      }

      if (!this.validateEmail(email)) {
        this.error('Please enter a valid email.');
        return false;
      }

      this.clear();

      return true;
    },

    validateEmail: function(email) {
      let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    },

    loading: function(loading) {
      if (loading) {
        status.loading = true;
        this.$btnSubmitForm.addClass('btn--loading');
      } else {
        status.loading = false;
        this.$btnSubmitForm.removeClass('btn--loading');
      }
    },

    clear: function() {
      this.$form.removeClass('has-error');
      this.$error.html('');
    },

    success: function() {
      this.completed = true;
      this.$btnSubmitForm.remove();
      this.$formNotification.removeClass('d-none')
    },

    error: function(message) {
      this.$form.addClass('has-error');
      this.$error.html(message);
    }
  });

  return NotifyForm;
})();

theme.CustomOrderForm = (function () {
  var status = {
    loading: false
  };

  var selectors = {
    swiperContainer : '.swiper-container',
    swiperContainerEarCurationGallery : '.swiper-container-ear-curation-gallery',
    swiperButtonNext: '.swiper-button-next',
    swiperButtonPrev: '.swiper-button-prev',
    customOrderConfirm: '.confirm-success',
    customOrderError: '.confirm-error',
    errorMsg: '.error-msg',
    invalidMsg: '.invalid-msg',
    errorGroupMsg: '.sp-error-group',
    customOrderContent: '.custom-order-content',
    btnSubmit: '.btn-submit',
    blindScreen: '.blind-screen',
    loadingSpinner: '<span class="spinner-border"></span>',
    formGroup: '.form-group',
    submit: 'SUBMIT',
    input: 'input',
    textarea: 'textarea',
    fullName: '.custom-order-full-name',
    email: '.custom-order-email',
    spend: '.custom-order-spend',
    yellowGold: '.custom-order-yellow-gold',
    whiteGold: '.custom-order-white-gold',
    roseGold: '.custom-order-rose-gold',
    goldEnds: '.custom-order-gold-ends',
    gemEnds: '.custom-order-gem-ends',
    ringEnds: '.custom-order-ring-ends',
    preferRings: '.custom-order-prefer-rings',
    sizeRings: '.custom-order-size-rings',
    pieces: '.custom-order-pieces',
    avoidPieces: '.custom-order-avoid-pieces',
    clientelle: '.custom-order-clientelle',
    totalGold: '.custom-order-total-gold',
    totalEnds: '.custom-order-total-ends',
  }

  function CustomOrderForm($form) {
    this.$form = $form;
    if (!this.$form.length)
      return;

    this.$swiper = null;

    if ($(window).width() < 768) {
      this.$swiperContainer = this.$form.find(selectors.swiperContainer);
      this.$swiperContainerEarCurationGallery = this.$form.find(selectors.swiper-container-ear-curation-gallery);
      this.$swiperButtonNext = this.$form.find(selectors.swiperButtonNext);
      this.$formGroup = this.$form.find(selectors.formGroup);
      this.$errorGroup = this.$form.find(selectors.errorGroupMsg);
    }

    this.$fullName = this.$form.find(selectors.fullName);
    this.$email = this.$form.find(selectors.email);
    this.$spend = this.$form.find(selectors.spend);
    this.$yellowGold = this.$form.find(selectors.yellowGold);
    this.$whiteGold = this.$form.find(selectors.whiteGold);
    this.$roseGold = this.$form.find(selectors.roseGold);
    this.$goldEnds = this.$form.find(selectors.goldEnds);
    this.$gemEnds = this.$form.find(selectors.gemEnds);
    this.$ringEnds = this.$form.find(selectors.ringEnds);
    this.$preferRings = this.$form.find(selectors.preferRings);
    this.$sizeRings = this.$form.find(selectors.sizeRings);
    this.$pieces = this.$form.find(selectors.pieces);
    this.$avoidPieces = this.$form.find(selectors.avoidPieces);
    this.$clientelle = this.$form.find(selectors.clientelle);
    this.$totalGold = this.$form.find(selectors.totalGold);
    this.$totalEnds = this.$form.find(selectors.totalEnds);

    this.$confirm = this.$form.find(selectors.customOrderConfirm);
    this.$error = this.$form.find(selectors.customOrderError);
    this.$customOrderContent = this.$form.find(selectors.customOrderContent);

    this.$btnSubmit = this.$form.find(selectors.btnSubmit);
    this.$blindScreen = $(selectors.blindScreen);

    // if ($(window).width() < 768 && !this.$swiperContainer.length)
    //   return;

    if (this.$form.length) {
      this.$fullName.unbind('change').bind('change', this.handleChangeInput.bind(this));
      this.$email.unbind('change').bind('change', this.handleChangeEmail.bind(this));
      this.$spend.unbind('change').bind('change', this.handleChangeSpend.bind(this));
      this.$yellowGold.unbind('change').bind('change', this.handleChangePercent.bind(this));
      this.$whiteGold.unbind('change').bind('change', this.handleChangePercent.bind(this));
      this.$roseGold.unbind('change').bind('change', this.handleChangePercent.bind(this));
      this.$goldEnds.unbind('change').bind('change', this.handleChangePercent.bind(this));
      this.$gemEnds.unbind('change').bind('change', this.handleChangePercent.bind(this));
      this.$ringEnds.unbind('change').bind('change', this.handleChangePercent.bind(this));
      this.$btnSubmit.unbind('click').bind('click', this.submit.bind(this));
    }

    if ($(window).width() < 768) {
      this.$swiperContainer = this.$form.find(selectors.swiperContainer);
      this.$swiperButtonNext = this.$form.find(selectors.swiperButtonNext);
      this.$formGroup = this.$form.find(selectors.formGroup);

      this.$swiperButtonNext.unbind('click').bind('click', this.moveSlide.bind(this));

      this.$swiper = new Swiper (selectors.swiperContainer, {
        autoHeight: true,
        allowTouchMove: false,
        simulateTouch: false,
        loop: false,
        speed: 300
      });
    }
    
     if ($(window).width() < 768) {
      this.$swiperContainerEarCurationGallery = this.$form.find(selectors.swiperContainerEarCurationGallery);
      this.$swiperButtonNext = this.$form.find(selectors.swiperButtonNext);
      this.$formGroup = this.$form.find(selectors.formGroup);

      this.$swiperButtonNext.unbind('click').bind('click', this.moveSlide.bind(this));

      this.$swiper = new Swiper (selectors.swiperContainerEarCurationGallery, {
        autoHeight: true,
        allowTouchMove: false,
        simulateTouch: false,
        loop: false,
        speed: 300
      });
    }

  }

  CustomOrderForm.prototype = $.extend({}, CustomOrderForm.prototype, {
    handleChangeInput: function(e) {
      const $parent = $(e.target).closest(selectors.input);
      const $error = $(e.target).next(selectors.errorMsg);
      const answer = $(e.target).val();

      if (!answer || answer === "") {
        $parent.addClass('empty');
        $error.addClass('d-block');
      } else {
        $parent.removeClass('empty');
        $error.removeClass('d-block');
      }

      if ($(window).width() < 768) {
        this.$swiper.updateAutoHeight();
      }
    },

    handleChangeEmail: function(e) {
      const $parent = $(e.target).closest(selectors.input);
      const $error = $(e.target).next(selectors.errorMsg);
      const $invalid = $(e.target).next().next(selectors.invalidMsg);
      const answer = $(e.target).val();
      const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

      if (!answer || answer === "") {
        $parent.addClass('empty');
        $parent.removeClass('invalid');
        $error.addClass('d-block');
        $invalid.removeClass('d-block');
      } else if (!regex.test(answer)) {
        $parent.removeClass('empty');
        $parent.addClass('invalid');
        $error.removeClass('d-block');
        $invalid.addClass('d-block');
      } else {
        $parent.removeClass('empty');
        $parent.removeClass('invalid');
        $error.removeClass('d-block');
        $invalid.removeClass('d-block');
      }

      if ($(window).width() < 768) {
        this.$swiper.updateAutoHeight();
      }
    },

    handleChangeSpend: function(e) {
      const $parent = $(e.target).closest(selectors.input);
      const answer = $(e.target).val();
      const $error = $(e.target).next(selectors.errorMsg);
      const $invalid = $(e.target).next().next(selectors.invalidMsg);

      if (!answer || answer === "") {
        $parent.addClass('empty');
        $parent.removeClass('invalid');
        $error.addClass('d-block');
        $invalid.removeClass('d-block');
      } else if (!Number.isFinite(Number(answer))) {
        $parent.removeClass('empty');
        $parent.addClass('invalid');
        $error.removeClass('d-block');
        $invalid.addClass('d-block');
      } else {
        $parent.removeClass('empty');
        $parent.removeClass('invalid');
        $error.removeClass('d-block');
        $invalid.removeClass('d-block');
      }

      if ($(window).width() < 768) {
        this.$swiper.updateAutoHeight();
      }
    },

    handleChangePercent: function(e) {
      if ($(window).width() < 768) {
        this.$swiper.updateAutoHeight();
        const yellowGold = this.$yellowGold.val();
        const whiteGold = this.$whiteGold.val();
        const roseGold = this.$roseGold.val();
        const gemEnds = this.$gemEnds.val();
        const goldEnds = this.$goldEnds.val();
        const ringEnds = this.$ringEnds.val();

        if (!Number.isFinite(Number(yellowGold)) || !Number.isFinite(Number(whiteGold)) || !Number.isFinite(Number(roseGold)) ||
            !Number.isFinite(Number(gemEnds)) || !Number.isFinite(Number(goldEnds)) || !Number.isFinite(Number(ringEnds)) ||
            Number(yellowGold) > 100 || Number(whiteGold) > 100 || Number(roseGold) > 100 || Number(gemEnds) > 100 || Number(goldEnds) > 100 || Number(ringEnds) > 100) {
          this.$errorGroup.children(selectors.errorMsg).removeClass('d-block');
          this.$errorGroup.children(selectors.invalidMsg).addClass('d-block');
        } else {
          this.$errorGroup.children(selectors.errorMsg).removeClass('d-block');
          this.$errorGroup.children(selectors.invalidMsg).removeClass('d-block');
        }
      }

      const $parent = $(e.target).closest(selectors.input);
      const answer = $(e.target).val();
      const $errorGroup = $(e.target).parent().next();
      const $error = $(e.target).parent().next().children(selectors.errorMsg);
      const $invalid = $(e.target).parent().next().children(selectors.invalidMsg);
      
	  this.handleChangeTotal();

      if (!answer || answer === "") {
        $parent.addClass('empty');
        $parent.removeClass('invalid');
        $error.addClass('d-block');
        $invalid.removeClass('d-block');
        $errorGroup.removeClass('d-none');
      } else if (!Number.isFinite(Number(answer)) || Number(answer) > 100) {
        $parent.removeClass('empty');
        $parent.addClass('invalid');
        $error.removeClass('d-block');
        $invalid.addClass('d-block');
        $errorGroup.removeClass('d-none');
      } else {
        $parent.removeClass('empty');
        $parent.removeClass('invalid');
        $error.removeClass('d-block');
        $invalid.removeClass('d-block');
        $errorGroup.addClass('d-none');
      }

      if ($(window).width() < 768) {
        this.$swiper.updateAutoHeight();
      }
    },
    
    handleChangeTotal : function () {
      let totalGold = Number(this.$totalGold.val());
      const yellowGold = Number(this.$yellowGold.val());
      const whiteGold = Number(this.$whiteGold.val());
      const roseGold = Number(this.$roseGold.val());
      
      let totalEnds = Number(this.$totalEnds.val());
      const gemEnds = Number(this.$gemEnds.val());
      const goldEnds = Number(this.$goldEnds.val());
      const ringEnds = Number(this.$ringEnds.val());
      
      const $errorGroup = this.$totalGold.parent().next();
      const $errorHigh = this.$totalGold.parent().next().children(selectors.errorMsg);
      const $errorLow = this.$totalGold.parent().next().children(selectors.invalidMsg);
      
      const $errorGroupEnds = this.$totalEnds.parent().next();
      const $errorHighEnds = this.$totalEnds.parent().next().children(selectors.errorMsg);
      const $errorLowEnds = this.$totalEnds.parent().next().children(selectors.invalidMsg);
      
      totalGold = yellowGold + whiteGold + roseGold;
      totalEnds = gemEnds + goldEnds + ringEnds;
      console.log("total gold", totalGold );
      console.log("total ends", totalEnds);
      this.$totalGold.val(totalGold);
      this.$totalEnds.val(totalEnds);
      
      if (totalGold > 100) {
        $errorHigh.addClass('d-block');
        $errorLow.removeClass('d-block');
        $errorGroup.removeClass('d-none');
      } else if (totalGold < 100) {
        $errorHigh.removeClass('d-block');
        $errorLow.addClass('d-block');
        $errorGroup.removeClass('d-none');
      } else {
        $errorHigh.removeClass('d-block');
        $errorLow.removeClass('d-block');
        $errorGroup.addClass('d-none');
      }
      
      if (totalEnds > 100) {
        $errorHighEnds.addClass('d-block');
        $errorLowEnds.removeClass('d-block');
        $errorGroupEnds.removeClass('d-none');
      } else if (totalEnds < 100) {
        $errorHighEnds.removeClass('d-block');
        $errorLowEnds.addClass('d-block');
        $errorGroupEnds.removeClass('d-none');
      } else {
        $errorHighEnds.removeClass('d-block');
        $errorLowEnds.removeClass('d-block');
        $errorGroupEnds.addClass('d-none');
      }
    },

    handleChangeText: function(e) {
      const $parent = $(e.target).closest(selectors.textarea);
      const answer = $(e.target).val();
      const $error = $(e.target).next(selectors.errorMsg);

      if (!answer || answer === "") {
        $parent.addClass('empty');
        $error.addClass('d-block');
      } else {
        $parent.removeClass('empty');
        $error.removeClass('d-block');
      }

      if ($(window).width() < 768) {
        this.$swiper.updateAutoHeight();
      }
    },

    validateForm: function(e) {
      let isValid = true;

      //validate Full Name
      if (!this.$fullName.val() || this.$fullName.val() === "") {
        this.$fullName.closest(selectors.input).addClass('empty');
        this.$fullName.next(selectors.errorMsg).addClass('d-block');
        isValid = false;
      } else {
        this.$fullName.closest(selectors.input).removeClass('empty');
        this.$fullName.next(selectors.errorMsg).removeClass('d-block');
      }

      //validate Email
      const emailRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!this.$email.val() || this.$email.val() === "") {
        this.$email.closest(selectors.input).addClass('empty');
        this.$email.next(selectors.errorMsg).addClass('d-block');
        isValid = false;
      } else if ((!emailRegex.test(this.$email.val()))) {
        this.$email.closest(selectors.input).removeClass('empty');
        this.$email.closest(selectors.input).addClass('invalid');
        this.$email.next(selectors.errorMsg).removeClass('d-block');
        this.$email.next().next(selectors.invalidMsg).addClass('d-block');
        isValid = false;
      } else {
        this.$email.closest(selectors.input).removeClass('empty');
        this.$email.closest(selectors.input).removeClass('invalid');
        this.$email.next(selectors.errorMsg).removeClass('d-block');
        this.$email.next().next(selectors.invalidMsg).removeClass('d-block');
      }

      //validate Spend
      if (!this.$spend.val() || this.$spend.val() === "") {
        this.$spend.closest(selectors.input).addClass('empty');
        this.$spend.next(selectors.errorMsg).addClass('d-block');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$spend.val()))) {
        this.$spend.closest(selectors.input).removeClass('empty');
        this.$spend.closest(selectors.input).addClass('invalid');
        this.$spend.next(selectors.errorMsg).removeClass('d-block');
        this.$spend.next().next(selectors.invalidMsg).addClass('d-block');
        isValid = false;
      }
      else {
        this.$spend.closest(selectors.input).removeClass('empty');
        this.$spend.closest(selectors.input).removeClass('invalid');
        this.$spend.next(selectors.errorMsg).removeClass('d-block');
        this.$spend.next().next(selectors.invalidMsg).removeClass('d-block');
      }

      //validate yellowGoldPercentage
      if (!this.$yellowGold.val() || this.$yellowGold.val() === "") {
        this.$yellowGold.closest(selectors.input).addClass('empty');
        this.$yellowGold.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$yellowGold.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$yellowGold.val())) || Number(this.$yellowGold.val()) > 100) {
        this.$yellowGold.closest(selectors.input).removeClass('empty');
        this.$yellowGold.closest(selectors.input).addClass('invalid');
        this.$yellowGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$yellowGold.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$yellowGold.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$yellowGold.closest(selectors.input).removeClass('empty');
        this.$yellowGold.closest(selectors.input).removeClass('invalid');
        this.$yellowGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$yellowGold.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$yellowGold.parent().next().addClass('d-none');
      }

      //validate whiteGoldPercentage
      if (!this.$whiteGold.val() || this.$whiteGold.val() === "") {
        this.$whiteGold.closest(selectors.input).addClass('empty');
        this.$whiteGold.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$whiteGold.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$whiteGold.val())) || Number(this.$whiteGold.val()) > 100) {
        this.$whiteGold.closest(selectors.input).removeClass('empty');
        this.$whiteGold.closest(selectors.input).addClass('invalid');
        this.$whiteGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$whiteGold.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$whiteGold.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$whiteGold.closest(selectors.input).removeClass('empty');
        this.$whiteGold.closest(selectors.input).removeClass('invalid');
        this.$whiteGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$whiteGold.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$whiteGold.parent().next().addClass('d-none');
      }

      //validate roseGoldPercentage
      if (!this.$roseGold.val() || this.$roseGold.val() === "") {
        this.$roseGold.closest(selectors.input).addClass('empty');
        this.$roseGold.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$roseGold.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$roseGold.val())) || Number(this.$roseGold.val()) > 100) {
        this.$roseGold.closest(selectors.input).removeClass('empty');
        this.$roseGold.closest(selectors.input).addClass('invalid');
        this.$roseGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$roseGold.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$roseGold.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$roseGold.closest(selectors.input).removeClass('empty');
        this.$roseGold.closest(selectors.input).removeClass('invalid');
        this.$roseGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$roseGold.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$roseGold.parent().next().addClass('d-none');
      }

      //validate goldEndsPercentage
      if (!this.$goldEnds.val() || this.$goldEnds.val() === "") {
        this.$goldEnds.closest(selectors.input).addClass('empty');
        this.$goldEnds.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$goldEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$goldEnds.val())) || Number(this.$goldEnds.val()) > 100) {
        this.$goldEnds.closest(selectors.input).removeClass('empty');
        this.$goldEnds.closest(selectors.input).addClass('invalid');
        this.$goldEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$goldEnds.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$goldEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$goldEnds.closest(selectors.input).removeClass('empty');
        this.$goldEnds.closest(selectors.input).removeClass('invalid');
        this.$goldEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$goldEnds.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$goldEnds.parent().next().addClass('d-none');
      }
      
      //validate totalGoldPercentage and totalEndsPercentage
      if (Number(this.$totalGold.val()) !== 100 || Number(this.$totalEnds.val()) !== 100 ) {
      	isValid = false;
      }

      //validate gemEndsPercentage
      if (!this.$gemEnds.val() || this.$gemEnds.val() === "") {
        this.$gemEnds.closest(selectors.input).addClass('empty');
        this.$gemEnds.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$gemEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$gemEnds.val())) || Number(this.$gemEnds.val()) > 100) {
        this.$gemEnds.closest(selectors.input).removeClass('empty');
        this.$gemEnds.closest(selectors.input).addClass('invalid');
        this.$gemEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$gemEnds.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$gemEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$gemEnds.closest(selectors.input).removeClass('empty');
        this.$gemEnds.closest(selectors.input).removeClass('invalid');
        this.$gemEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$gemEnds.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$gemEnds.parent().next().addClass('d-none');
      }

      //validate ringEndsPercentage
      if (!this.$ringEnds.val() || this.$ringEnds.val() === "") {
        this.$ringEnds.closest(selectors.input).addClass('empty');
        this.$ringEnds.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$ringEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$ringEnds.val())) || Number(this.$ringEnds.val()) > 100) {
        this.$ringEnds.closest(selectors.input).removeClass('empty');
        this.$ringEnds.closest(selectors.input).addClass('invalid');
        this.$ringEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$ringEnds.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$ringEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$ringEnds.closest(selectors.input).removeClass('empty');
        this.$ringEnds.closest(selectors.input).removeClass('invalid');
        this.$ringEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$ringEnds.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$ringEnds.parent().next().addClass('d-none');
      }

      // Find a first dom element in error status, scroll to that element if validation is failed
      if (!isValid && $(window).width() >= 768) {
        const invalidGroups = this.$form.find(selectors.input + ".empty", selectors.input + ".invalid");
        let topPos = 100000;
        for (let i = 0; i < invalidGroups.length; i ++) {
          let tmpPos = $(invalidGroups[i]).offset().top;
          if (tmpPos < topPos)
            topPos = tmpPos;
        }
        if (topPos === 100000) topPos = 0;
        else topPos -= 100;
        window.scrollTo({
          top: topPos,
          behavior: "smooth"
        });
      }

      return isValid;
    },

    captureOrderInfo: function(e) {
      const fullName = this.$form.find(selectors.fullName).val();
      const email = this.$form.find(selectors.email).val();
      const spend = this.$form.find(selectors.spend).val();
      const yellowGold = this.$form.find(selectors.yellowGold).val();
      const whiteGold = this.$form.find(selectors.whiteGold).val();
      const roseGold = this.$form.find(selectors.roseGold).val();
      const goldEnds = this.$form.find(selectors.goldEnds).val();
      const gemEnds = this.$form.find(selectors.gemEnds).val();
      const ringEnds = this.$form.find(selectors.ringEnds).val();
      const preferRings = this.$form.find(selectors.preferRings + " input:checked").val();
      let sizeRingsArr = [];
      this.$form.find(selectors.sizeRings + " input:checked").each(function (index) {
        sizeRingsArr.push($(this).val());
      });
      const sizeRings = sizeRingsArr.toString();
      const pieces = this.$form.find(selectors.pieces).val();
      const avoidPieces = this.$form.find(selectors.avoidPieces).val();
      const clientelle = this.$form.find(selectors.clientelle).val();

      const info = {
        full_name: fullName,
        email: email,
        spend_expectation: spend,
        yellow_gold_percentage: yellowGold,
        white_gold_percentage: whiteGold,
        rose_gold_percentage: roseGold,
        gold_ends_percentage: goldEnds,
        gem_ends_percentage: gemEnds,
        gold_rings_percentage: ringEnds,
        ring_type: preferRings,
        ring_sizes: sizeRings,
        idea_pieces: pieces,
        idea_avoid_pieces: avoidPieces,
        idea_clientelle: clientelle
      }

      return info;
    },

    initScrollPosition: function() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },

    scrollToSuccessMsg: function() {
      var scrollTop = $('.btn-submit-desktop').offset().top - $(window).height() / 2;
      window.scrollTo({
        top: scrollTop,
        behavior: "smooth"
      });
    },

    moveSlide: function(e) {
      const swiper = this.$swiper;
      const index = swiper.activeIndex;
      switch (index) {
        case 0:
          swiper.slideNext();
          this.initScrollPosition();
          break;
        case 1:
          const firstAnswer = this.validateFirstSlideForm();
          if (firstAnswer) {
            swiper.slideNext();
            this.initScrollPosition();
          }
          break;
        case 2:
          const secondAnswer = this.validateSecondSlideForm();
          if (secondAnswer) {
            swiper.slideNext();
            this.initScrollPosition();
          }
          break;
        case 3:
          swiper.slideNext();
          this.initScrollPosition();
          break;
        case 4:
        default:
          break;
      }
    },

    validateFirstSlideForm: function(e) {
      let isValid = true;

      //validate Full Name
      if (!this.$fullName.val() || this.$fullName.val() === "") {
        this.$fullName.closest(selectors.input).addClass('empty');
        this.$fullName.next(selectors.errorMsg).addClass('d-block');
        isValid = false;
      } else {
        this.$fullName.closest(selectors.input).removeClass('empty');
        this.$fullName.next(selectors.errorMsg).removeClass('d-block');
      }

      //validate Email
      const emailRegex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!this.$email.val() || this.$email.val() === "") {
        this.$email.closest(selectors.input).addClass('empty');
        this.$email.next(selectors.errorMsg).addClass('d-block');
        isValid = false;
      } else if ((!emailRegex.test(this.$email.val()))) {
        this.$email.closest(selectors.input).removeClass('empty');
        this.$email.closest(selectors.input).addClass('invalid');
        this.$email.next(selectors.errorMsg).removeClass('d-block');
        this.$email.next().next(selectors.invalidMsg).addClass('d-block');
        isValid = false;
      } else {
        this.$email.closest(selectors.input).removeClass('empty');
        this.$email.closest(selectors.input).removeClass('invalid');
        this.$email.next(selectors.errorMsg).removeClass('d-block');
        this.$email.next().next(selectors.invalidMsg).removeClass('d-block');
      }

      //validate Spend
      if (!this.$spend.val() || this.$spend.val() === "") {
        this.$spend.closest(selectors.input).addClass('empty');
        this.$spend.next(selectors.errorMsg).addClass('d-block');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$spend.val()))) {
        this.$spend.closest(selectors.input).removeClass('empty');
        this.$spend.closest(selectors.input).addClass('invalid');
        this.$spend.next(selectors.errorMsg).removeClass('d-block');
        this.$spend.next().next(selectors.invalidMsg).addClass('d-block');
        isValid = false;
      }
      else {
        this.$spend.closest(selectors.input).removeClass('empty');
        this.$spend.closest(selectors.input).removeClass('invalid');
        this.$spend.next(selectors.errorMsg).removeClass('d-block');
        this.$spend.next().next(selectors.invalidMsg).removeClass('d-block');
      }

      this.$swiper.updateAutoHeight();

      // Find a first dom element in error status, scroll to that element if validation is failed
      if (!isValid && $(window).width() >= 768) {
        const invalidGroups = this.$form.find(selectors.input + ".empty", selectors.input + ".invalid");
        let topPos = 100000;
        for (let i = 0; i < invalidGroups.length; i ++) {
          var tmpPos = $(invalidGroups[i]).offset().top;
          if (tmpPos < topPos)
            topPos = tmpPos;
        }
        if (topPos === 100000) topPos = 0;
        else topPos -= 100;
        window.scrollTo({
          top: topPos,
          behavior: "smooth"
        });
      }

      return isValid;
    },

    validateSecondSlideForm: function(e) {
      let isValid = true;

      if (!this.$yellowGold.val() || this.$yellowGold.val() === "" || !this.$whiteGold.val() || this.$whiteGold.val() === "" || !this.$roseGold.val() || this.$roseGold.val() === ""
          ||!this.$goldEnds.val() || this.$goldEnds.val() === "" || !this.$gemEnds.val() || this.$gemEnds.val() === "" || !this.$ringEnds.val() || this.$ringEnds.val() === "") {
        this.$errorGroup.children(selectors.errorMsg).addClass('d-block');
      } else if (!Number.isFinite(Number(this.$yellowGold.val())) || Number(this.$yellowGold.val()) > 100 ||
          !Number.isFinite(Number(this.$whiteGold.val())) || Number(this.$whiteGold.val()) > 100 ||
          !Number.isFinite(Number(this.$roseGold.val())) || Number(this.$roseGold.val()) > 100 ||
          !Number.isFinite(Number(this.$goldEnds.val())) || Number(this.$goldEnds.val()) > 100 ||
          !Number.isFinite(Number(this.$gemEnds.val())) || Number(this.$gemEnds.val()) > 100 ||
          !Number.isFinite(Number(this.$ringEnds.val())) || Number(this.$ringEnds.val()) > 100) {
        this.$errorGroup.children(selectors.errorMsg).removeClass('d-block');
        this.$errorGroup.children(selectors.invalidMsg).addClass('d-block');
      } else {
        this.$errorGroup.children(selectors.errorMsg).removeClass('d-block');
        this.$errorGroup.children(selectors.invalidMsg).removeClass('d-block');
      }

      //validate yellowGoldPercentage
      if (!this.$yellowGold.val() || this.$yellowGold.val() === "") {
        this.$yellowGold.closest(selectors.input).addClass('empty');
        this.$yellowGold.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$yellowGold.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$yellowGold.val())) || Number(this.$yellowGold.val()) > 100) {
        this.$yellowGold.closest(selectors.input).removeClass('empty');
        this.$yellowGold.closest(selectors.input).addClass('invalid');
        this.$yellowGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$yellowGold.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$yellowGold.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$yellowGold.closest(selectors.input).removeClass('empty');
        this.$yellowGold.closest(selectors.input).removeClass('invalid');
        this.$yellowGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$yellowGold.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$yellowGold.parent().next().addClass('d-none');
      }

      //validate whiteGoldPercentage
      if (!this.$whiteGold.val() || this.$whiteGold.val() === "") {
        this.$whiteGold.closest(selectors.input).addClass('empty');
        this.$whiteGold.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$whiteGold.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$whiteGold.val())) || Number(this.$whiteGold.val()) > 100) {
        this.$whiteGold.closest(selectors.input).removeClass('empty');
        this.$whiteGold.closest(selectors.input).addClass('invalid');
        this.$whiteGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$whiteGold.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$whiteGold.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$whiteGold.closest(selectors.input).removeClass('empty');
        this.$whiteGold.closest(selectors.input).removeClass('invalid');
        this.$whiteGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$whiteGold.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$whiteGold.parent().next().addClass('d-none');
      }

      //validate roseGoldPercentage
      if (!this.$roseGold.val() || this.$roseGold.val() === "") {
        this.$roseGold.closest(selectors.input).addClass('empty');
        this.$roseGold.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$roseGold.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$roseGold.val())) || Number(this.$roseGold.val()) > 100) {
        this.$roseGold.closest(selectors.input).removeClass('empty');
        this.$roseGold.closest(selectors.input).addClass('invalid');
        this.$roseGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$roseGold.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$roseGold.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$roseGold.closest(selectors.input).removeClass('empty');
        this.$roseGold.closest(selectors.input).removeClass('invalid');
        this.$roseGold.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$roseGold.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$roseGold.parent().next().addClass('d-none');
      }
      
      //validate totalGoldPercentage
      if (Number(this.$totalGold.val()) !== 100) {
        this.$totalGold.closest(selectors.input).addClass('invalid');
      	isValid = false;
      } else {
      	this.$totalGold.closest(selectors.input).removeClass('invalid');
      }
      //validate totalEndsPercentage
      if (Number(this.$totalEnds.val()) !== 100 ) {
        this.$totalEnds.closest(selectors.input).addClass('invalid');
      	isValid = false;
      } else {
      	this.$totalEnds.closest(selectors.input).removeClass('invalid');
      }

      //validate goldEndsPercentage
      if (!this.$goldEnds.val() || this.$goldEnds.val() === "") {
        this.$goldEnds.closest(selectors.input).addClass('empty');
        this.$goldEnds.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$goldEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$goldEnds.val())) || Number(this.$goldEnds.val()) > 100) {
        this.$goldEnds.closest(selectors.input).removeClass('empty');
        this.$goldEnds.closest(selectors.input).addClass('invalid');
        this.$goldEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$goldEnds.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$goldEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$goldEnds.closest(selectors.input).removeClass('empty');
        this.$goldEnds.closest(selectors.input).removeClass('invalid');
        this.$goldEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$goldEnds.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$goldEnds.parent().next().addClass('d-none');
      }

      //validate gemEndsPercentage
      if (!this.$gemEnds.val() || this.$gemEnds.val() === "") {
        this.$gemEnds.closest(selectors.input).addClass('empty');
        this.$gemEnds.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$gemEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$gemEnds.val())) || Number(this.$gemEnds.val()) > 100) {
        this.$gemEnds.closest(selectors.input).removeClass('empty');
        this.$gemEnds.closest(selectors.input).addClass('invalid');
        this.$gemEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$gemEnds.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$gemEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$gemEnds.closest(selectors.input).removeClass('empty');
        this.$gemEnds.closest(selectors.input).removeClass('invalid');
        this.$gemEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$gemEnds.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$gemEnds.parent().next().addClass('d-none');
      }

      //validate ringEndsPercentage
      if (!this.$ringEnds.val() || this.$ringEnds.val() === "") {
        this.$ringEnds.closest(selectors.input).addClass('empty');
        this.$ringEnds.parent().next().children(selectors.errorMsg).addClass('d-block');
        this.$ringEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else if (!Number.isFinite(Number(this.$ringEnds.val())) || Number(this.$ringEnds.val()) > 100) {
        this.$ringEnds.closest(selectors.input).removeClass('empty');
        this.$ringEnds.closest(selectors.input).addClass('invalid');
        this.$ringEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$ringEnds.parent().next().children(selectors.invalidMsg).addClass('d-block');
        this.$ringEnds.parent().next().removeClass('d-none');
        isValid = false;
      } else {
        this.$ringEnds.closest(selectors.input).removeClass('empty');
        this.$ringEnds.closest(selectors.input).removeClass('invalid');
        this.$ringEnds.parent().next().children(selectors.errorMsg).removeClass('d-block');
        this.$ringEnds.parent().next().children(selectors.invalidMsg).removeClass('d-block');
        this.$ringEnds.parent().next().addClass('d-none');
      }

      this.$swiper.updateAutoHeight();

      // Find a first dom element in error status, scroll to that element if validation is failed
      if (!isValid && $(window).width() >= 768) {
        const invalidGroups = this.$form.find(selectors.input + ".empty", selectors.input + ".invalid");
        let topPos = 100000;
        for (let i = 0; i < invalidGroups.length; i ++) {
          var tmpPos = $(invalidGroups[i]).offset().top;
          if (tmpPos < topPos)
            topPos = tmpPos;
        }
        if (topPos === 100000) topPos = 0;
        else topPos -= 100;
        window.scrollTo({
          top: topPos,
          behavior: "smooth"
        });
      }

      return isValid;
    },

    validateFourthSlideForm: function(e) {
      let isValid = true;

      //validate pieces
      if (!this.$pieces.val() || this.$pieces.val() === "") {
        this.$pieces.closest(selectors.textarea).addClass('empty');
        this.$pieces.next(selectors.errorMsg).addClass('d-block');
        isValid = false;
      } else {
        this.$pieces.closest(selectors.textarea).removeClass('empty');
        this.$pieces.next(selectors.invalidMsg).removeClass('d-block');
      }

      //validate clientelle
      if (!this.$clientelle.val() || this.$clientelle.val() === "") {
        this.$clientelle.closest(selectors.textarea).addClass('empty');
        this.$clientelle.next(selectors.errorMsg).addClass('d-block');
        isValid = false;
      } else {
        this.$clientelle.closest(selectors.textarea).removeClass('empty');
        this.$clientelle.next(selectors.errorMsg).removeClass('d-block');
      }

      this.$swiper.updateAutoHeight();

      // Find a first dom element in error status, scroll to that element if validation is failed
      if (!isValid && $(window).width() >= 768) {
        const invalidGroups = this.$form.find(selectors.input + ".empty", selectors.input + ".invalid");
        let topPos = 100000;
        for (let i = 0; i < invalidGroups.length; i ++) {
          var tmpPos = $(invalidGroups[i]).offset().top;
          if (tmpPos < topPos)
            topPos = tmpPos;
        }
        if (topPos === 100000) topPos = 0;
        else topPos -= 100;
        window.scrollTo({
          top: topPos,
          behavior: "smooth"
        });
      }

      return isValid;
    },

    submit: function (e) {
      e.preventDefault();

      if (status.loading)
        return;

      if (!this.validateForm())
        return;

      const self = this;
      const answers = self.captureOrderInfo();

      status.loading = true;
      self.$btnSubmit.addClass('btn--loading');
      self.$blindScreen.fadeIn();

      // submit form
      $.ajax({
        url         : theme.settings.apiBase + "/custom-order",
        method      : "POST",
        dataType    : "json",
        contentType : "application/json",
        cache       : false,
        data        : JSON.stringify(answers),
        beforeSend  : function( xhr ) {
          status.loading = true;
          self.$btnSubmit.addClass('btn--loading');
          self.$blindScreen.fadeIn();
        },
      }).done((data) => {
        if (data.status === 'success') {
          self.success();
        } else {
          self.error(0);
        }
      }).fail((error) => {
        self.error(error);
        console.log(error);
      });
    },

    success: function() {
      status.loading = false;
      if ($(window).width() < 768) {
        this.$customOrderContent.hide();
        this.initScrollPosition();
      } else {
        this.scrollToSuccessMsg();
      }
      this.$btnSubmit.removeClass('btn--loading');
      this.$confirm.addClass('d-block');
      this.$blindScreen.fadeOut();
    },

    error: function(err) {
      status.loading = false;
      this.$btnSubmit.removeClass('btn--loading');
      this.$confirm.removeClass('d-block');
      this.$error.addClass('d-block');
      this.$blindScreen.fadeOut();
      if ($(window).width() < 768) {
        this.$swiper.updateAutoHeight();
      }
    }
  })

  return CustomOrderForm;
})();

theme.collapsibles = (function() {

  var selectors = {
    trigger: '.collapsible-trigger',
    module: '.collapsible-content',
    moduleInner: '.collapsible-content__inner'
  };

  var classes = {
    hide: 'hide',
    open: 'is-open',
    autoHeight: 'collapsible--auto-height'
  };

  var isTransitioning = false;

  function init() {
    $(selectors.trigger).each(function() {
      var $el = $(this);
      var state = $el.hasClass(classes.open);
      $el.attr('aria-expanded', state);
    });

    // Event listeners (hack for modals)
    $('body, .modal__inner').on('click', selectors.trigger, function() {
      if (isTransitioning) {
        return;
      }

      isTransitioning = true;

      var $el = $(this);
      var isOpen = $el.hasClass(classes.open);
      var moduleId = $el.attr('aria-controls');
      var $module = $('#' + moduleId);
      var height = $module.find(selectors.moduleInner).outerHeight();
      var isAutoHeight = $el.hasClass(classes.autoHeight);

      // If isAutoHeight, set the height to 0 just after setting the actual height
      // so the closing animation works nicely
      if (isOpen && isAutoHeight) {
        setTimeout(function() {
          height = 0;
          setTransitionHeight($module, height, isOpen, isAutoHeight);
        }, 0);
      }

      if (isOpen && !isAutoHeight) {
        height = 0;
      }

      $el
        .attr('aria-expanded', !isOpen)
        .toggleClass(classes.open, !isOpen);

      setTransitionHeight($module, height, isOpen, isAutoHeight);
    });
  }

  function setTransitionHeight($module, height, isOpen, isAutoHeight) {
    $module
      .removeClass(classes.hide)
      .prepareTransition()
      .css('height', height)
      .toggleClass(classes.open, !isOpen);

    if (!isOpen && isAutoHeight) {
      var o = $module;
      window.setTimeout(function() {
        o.css('height','auto');
        isTransitioning = false;
      }, 500);
    } else {
      isTransitioning = false;
    }
  }

  return {
    init: init
  };
})();

theme.toggleNav = (function() {

  var selectors = {
    trigger: '.nav-title',
    module: '.nav-content'
  };

  var classes = {
    hide: 'hide',
    open: 'is-open',
    parentNode: 'mobile-nav__link--parent',
    childNode: 'mobile-nav__link--child'
  };

  var isTransitioning = false;

  function init() {
    $(selectors.trigger).each(function() {
      var $el = $(this);
      var state = $el.hasClass(classes.open);
      $el.attr('aria-expanded', state);
    });

    // Event listeners (hack for modals)
    $('body, .modal__inner').on('click', selectors.trigger, function() {

      var $el = $(this);

      if ($el.hasClass(classes.parentNode)) {
        var $otherParents = $("." + classes.parentNode);
        $otherParents.each(function () {
          if ($el.attr('aria-controls') === $(this).attr('aria-controls')) {
            toggleNav($el);
          } else {
            toggleNav($(this), true);
          }
        });
      }

      if ($el.hasClass(classes.childNode)) {
        var $otherChilds = $("." + classes.childNode);
        $otherChilds.each(function () {
          if ($el.attr('aria-controls') === $(this).attr('aria-controls')) {
            toggleNav($el);
          } else {
            // Disable auto toggle for child nodes
            // toggleNav($(this), true);
          }
        });
      }
    });
  }

  function toggleNav($el, isOther = false) {
    var isOpen = $el.hasClass(classes.open);
    var moduleId = $el.attr('aria-controls');
    var $module = $('#' + moduleId);
    var height = $module.find(selectors.moduleInner).outerHeight();
    var isAutoHeight = $el.hasClass(classes.autoHeight);

    if (isOther) {
      if (!isOpen) {
        return;
      } else {
        isOpen = true;
      }
    }

    $module.slideToggle(300);

    $el
      .attr('aria-expanded', !isOpen)
      .toggleClass(classes.open, !isOpen);
  }

  return {
    init: init
  };
})();

theme.headerNav = (function() {

  var $parent = $(document.documentElement).add('body');
  var $page = $('#MainContent');
  var selectors = {
    wrapper: '.header-wrapper',
    siteHeader: '.site-header',
    searchBtn: '.js-search-header',
    closeSearch: '.js-search-header-close',
    searchContainer: '.site-header__search-container',
    logoContainer: '.site-header__logo',
    logo: '.site-header__logo img',
    navigation: '.site-navigation',
    navContainerWithLogo: '.header-item--logo',
    navItems: '.site-nav__item',
    navLinks: '.site-nav__link',
    navLinksWithDropdown: '.site-nav__link--has-dropdown',
    navDropdownLinks: '.site-nav__dropdown-link--second-level'
  };

  var classes = {
    hasDropdownClass: 'site-nav--has-dropdown',
    hasSubDropdownClass: 'site-nav__deep-dropdown-trigger',
    dropdownActive: 'is-focused'
  };

  var config = {
    namespace: '.siteNav',
    wrapperOverlayed: false,
    overlayedClass: 'is-light',
    stickyEnabled: false,
    stickyActive: false,
    stickyClass: 'site-header--stuck',
    openTransitionClass: 'site-header--opening',
    lastScroll: 0
  };

  // Elements used in resize functions, defined in init
  var $window;
  var $navContainerWithLogo;
  var $logoContainer;
  var $nav;
  var $wrapper;
  var $siteHeader;

  function init() {
    $window = $(window);
    $navContainerWithLogo = $(selectors.navContainerWithLogo);
    $logoContainer = $(selectors.logoContainer);
    $nav = $(selectors.navigation);
    $wrapper = $(selectors.wrapper);
    $siteHeader = $(selectors.siteHeader);

    config.stickyEnabled = $siteHeader.data('sticky');
    if (config.stickyEnabled) {
      config.wrapperOverlayed = $wrapper.hasClass(config.overlayedClass);
      stickyHeader();
    }

    accessibleDropdowns();
    searchDrawer();

    $window.on('load' + config.namespace, resizeLogo);
    $window.on('resize' + config.namespace, $.debounce(150, resizeLogo));
  }

  function unload() {
    $(window).off(config.namespace);
    $(selectors.searchBtn).off(config.namespace);
    $(selectors.closeSearch).off(config.namespace);
    $parent.off(config.namespace);
    $(selectors.navLinks).off(config.namespace);
    $(selectors.navDropdownLinks).off(config.namespace);
  }

  function searchDrawer() {
    $(selectors.searchBtn).on('click' + config.namespace, function(evt) {
      evt.preventDefault();
      openSearchDrawer();
    });

    $(selectors.closeSearch).on('click' + config.namespace, function() {
      closeSearchDrawer();
    });
  }

  function openSearchDrawer() {
    $(selectors.searchContainer).addClass('is-active');
    $parent.addClass('js-drawer-open js-drawer-open--search');

    slate.a11y.trapFocus({
      $container: $(selectors.searchContainer),
      namespace: 'header_search',
      $elementToFocus: $(selectors.searchContainer).find('input')
    });

    // If sticky is enabled, scroll to top on mobile when close to it
    // so you don't get an invisible search box
    if (theme.config.bpSmall && config.stickyEnabled && config.lastScroll < 300) {
      window.scrollTo(0,0);
    }

    // Bind events
    slate.a11y.lockMobileScrolling(config.namespace);

    // Clicking out of container closes it
    $page.on('click' + config.namespace, function () {
      closeSearchDrawer();
      return false;
    });

    $parent.on('keyup' + config.namespace, function(evt) {
      if (evt.keyCode === 27) {
        closeSearchDrawer();
      }
    });
  }

  function closeSearchDrawer() {
    // deselect any focused form elements
    $(document.activeElement).trigger('blur');

    $parent.removeClass('js-drawer-open js-drawer-open--search').off(config.namespace);
    $(selectors.searchContainer).removeClass('is-active');

    slate.a11y.removeTrapFocus({
      $container: $(selectors.searchContainer),
      namespace: 'header_search'
    });

    slate.a11y.unlockMobileScrolling(config.namespace);
    $page.off('click' + config.namespace);
    $parent.off('keyup' + config.namespace);
  }

  function resizeLogo() {
    // Using .each() as there can be a reversed logo too
    $(selectors.logo).each(function() {
      var $el = $(this),
          logoWidthOnScreen = $el.width(),
          containerWidth = $el.closest('.grid__item').width();
      // If image exceeds container, let's make it smaller
      if (logoWidthOnScreen > containerWidth) {
        $el.css('maxWidth', containerWidth);
      }
      else {
        $el.removeAttr('style');
      }
    });
  }

  function accessibleDropdowns() {
    var hasActiveDropdown = false;
    var hasActiveSubDropdown = false;
    var closeOnClickActive = false;

    // Touch devices open dropdown on first click, navigate to link on second
    if (theme.config.isTouch) {
      $(selectors.navLinksWithDropdown).on('touchend' + config.namespace, function(evt) {
        var $el = $(this);
        var $parentItem = $el.parent();
        if (!$parentItem.hasClass(classes.dropdownActive)) {
          evt.preventDefault();
          closeDropdowns();
          openFirstLevelDropdown($el);
        } else {
          window.location.replace($el.attr('href'));
        }
      });

      $(selectors.navDropdownLinks).on('touchend' + config.namespace, function(evt) {
        var $el = $(this);
        var $parentItem = $el.parent();

        // Open third level menu or go to link based on active state
        if ($parentItem.hasClass(classes.hasSubDropdownClass)) {
          if (!$parentItem.hasClass(classes.dropdownActive)) {
            evt.preventDefault();
            closeThirdLevelDropdown();
            openSecondLevelDropdown($el);
          } else {
            window.location.replace($el.attr('href'));
          }
        } else {
          // No third level nav, go to link
          window.location.replace($el.attr('href'));
        }
      });
    }

    // Open/hide top level dropdowns
    $(selectors.navLinks).on('focusin mouseover' + config.namespace, function() {
      if (hasActiveDropdown) {
        closeSecondLevelDropdown();
      }

      if (hasActiveSubDropdown) {
        closeThirdLevelDropdown();
      }

      openFirstLevelDropdown($(this));
    });

    // Force remove focus on sitenav links because focus sometimes gets stuck
    $(selectors.navLinks).on('mouseleave' + config.namespace, function() {
      closeDropdowns();
    });

    // Open/hide sub level dropdowns
    $(selectors.navDropdownLinks).on('focusin' + config.namespace, function() {
      closeThirdLevelDropdown();
      openSecondLevelDropdown($(this), true);
    });

    // Private dropdown methods
    function openFirstLevelDropdown($el) {
      var $parentItem = $el.parent();
      if ($parentItem.hasClass(classes.hasDropdownClass)) {
        $parentItem.addClass(classes.dropdownActive);
        hasActiveDropdown = true;
      }

      if (!theme.config.isTouch) {
        if (!closeOnClickActive) {
          var eventType = theme.config.isTouch ? 'touchend' : 'click';
          closeOnClickActive = true;
          $('body').on(eventType + config.namespace, function() {
            closeDropdowns();
            $('body').off(config.namespace);
            closeOnClickActive = false;
          });
        }
      }
    }

    function openSecondLevelDropdown($el, skipCheck) {
      var $parentItem = $el.parent();
      if ($parentItem.hasClass(classes.hasSubDropdownClass) || skipCheck) {
        $parentItem.addClass(classes.dropdownActive);
        hasActiveSubDropdown = true;
      }
    }

    function closeDropdowns() {
      closeSecondLevelDropdown();
      closeThirdLevelDropdown();
    }

    function closeSecondLevelDropdown() {
      $(selectors.navItems).removeClass(classes.dropdownActive);
    }

    function closeThirdLevelDropdown() {
      $(selectors.navDropdownLinks).parent().removeClass(classes.dropdownActive);
    }
  }

  function stickyHeader() {
    config.lastScroll = 0;
    $siteHeader.wrap('<div class="site-header-sticky"></div>');

    stickyHeaderHeight();
    $window.on('resize' + config.namespace, $.debounce(50, stickyHeaderHeight));
    $window.on('scroll' + config.namespace, $.throttle(15, stickyHeaderScroll));

    // This gets messed up in the editor, so here's a fix
    if (Shopify && Shopify.designMode) {
      setTimeout(function() {
        stickyHeaderHeight();
      }, 250);
    }
  }

  function stickyHeaderHeight() {
    var $stickyHeader = $('.site-header-sticky').css('height', $siteHeader.outerHeight(true));
  }

  function stickyHeaderScroll() {
    var scroll = $window.scrollTop();
    var threshold = 250;

    if (scroll > threshold) {
      if (config.stickyActive) {
        return;
      }

      config.stickyActive = true;

      $siteHeader.addClass(config.stickyClass);
      if (config.wrapperOverlayed) {
        $wrapper.removeClass(config.overlayedClass);
      }

      // Add open transition class after element is set to fixed
      // so CSS animation is applied correctly
      setTimeout(function() {
        $siteHeader.addClass(config.openTransitionClass);
      }, 100);
    } else {
      if (!config.stickyActive) {
        return;
      }

      config.stickyActive = false;

      $siteHeader.removeClass(config.openTransitionClass).removeClass(config.stickyClass);
      if (config.wrapperOverlayed) {
        $wrapper.addClass(config.overlayedClass);
      }
    }

    config.lastScroll = scroll;
  }

  return {
    init: init,
    unload: unload
  };
})();

theme.articleImages = (function() {

  var cache = {};

  function init() {
    cache.$rteImages = $('.rte--indented-images');

    if (!cache.$rteImages.length) {
      return;
    }

    $(window).on('load', setImages);
  }

  function setImages() {
    cache.$rteImages.find('img').each(function() {
      var $el = $(this);
      var attr = $el.attr('style');

      // Check if undefined or float: none
      if (!attr || attr == 'float: none;') {
        // Remove grid-breaking styles if image isn't wider than parent
        if ($el.width() < cache.$rteImages.width()) {
          $el.addClass('rte__no-indent');
        }
      }
    });
  }

  return {
    init: init
  };
})();

theme.backButton = (function() {

  function init() {
    if (!document.referrer || !$('.return-link').length || !window.history.length) {
      return;
    }

    //$('.return-link').on('click', backHistory);
  }

  function backHistory() {
    var referrerDomain = urlDomain(document.referrer);
    var shopDomain = urlDomain(document.url);

    if (shopDomain === referrerDomain) {
      history.back();
      return false;
    }
  }

  function urlDomain(url) {
    var    a      = document.createElement('a');
           a.href = url;
    return a.hostname;
  }

  return {
    init: init
  };
})();

theme.Slideshow = (function() {
  this.$slideshow = null;

  var classes = {
    next: 'is-next',
    init: 'is-init',
    header: 'header-wrapper',
    wrapper: 'slideshow-wrapper',
    slideshow: 'slideshow',
    currentSlide: 'slick-current',
    pauseButton: 'slideshow__pause',
    isPaused: 'is-paused'
  };

  function slideshow(el, args) {
    this.$slideshow = $(el);
    this.$wrapper = this.$slideshow.closest('.' + classes.wrapper);
    this.$pause = this.$wrapper.find('.' + classes.pauseButton);

    this.settings = {
      accessibility: true,
      arrows: args.arrows ? true : false,
      dots: args.dots ? true : false,
      draggable: true,
      touchThreshold: 5,
      pauseonHover: false,
      autoplay: this.$slideshow.data('autoplay'),
      autoplaySpeed: this.$slideshow.data('speed')
    };

    this.$slideshow.on('init', this.init.bind(this));

    this.$slideshow.slick(this.settings);

    this.$pause.on('click', this._togglePause.bind(this));
  }

  slideshow.prototype = $.extend({}, slideshow.prototype, {
    init: function(event, obj) {
      this.$slideshowList = obj.$list;
      this.$slickDots = obj.$dots;
      this.$allSlides = obj.$slides;
      this.slideCount = obj.slideCount;

      this.$slideshow.addClass(classes.init);
      this._a11y();
      this._clonedLazyloading();
    },
    destroy: function() {
      this.$slideshow.slick('unslick');
    },

    // Playback
    _play: function() {
      this.$slideshow.slick('slickPause');
      $(classes.pauseButton).addClass('is-paused');
    },
    _pause: function() {
      this.$slideshow.slick('slickPlay');
      $(classes.pauseButton).removeClass('is-paused');
    },
    _togglePause: function() {
      var slideshowSelector = this._getSlideshowId(this.$pause);
      if (this.$pause.hasClass(classes.isPaused)) {
        this.$pause.removeClass(classes.isPaused);
        $(slideshowSelector).slick('slickPlay');
      } else {
        this.$pause.addClass(classes.isPaused);
        $(slideshowSelector).slick('slickPause');
      }
    },

    // Helpers
    _getSlideshowId: function($el) {
      return '#Slideshow-' + $el.data('id');
    },
    _activeSlide: function() {
      return this.$slideshow.find('.slick-active');
    },
    _currentSlide: function() {
      return this.$slideshow.find('.slick-current');
    },
    _nextSlide: function(index) {
      return this.$slideshow.find('.slideshow__slide[data-slick-index="' + index + '"]');
    },

    // a11y fixes
    _a11y: function() {
      var $list = this.$slideshowList;
      var autoplay = this.settings.autoplay;

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused
      // pause slideshow and set aria-live
      $(classes.wrapper).on('focusin', function(evt) {
        if (!$(classes.wrapper).has(evt.target).length) {
          return;
        }

        $list.attr('aria-live', 'polite');
        if (autoplay) {
          this._pause();
        }
      }.bind(this));

      // Resume autoplay
      $(classes.wrapper).on('focusout', function(evt) {
        if (!$(classes.wrapper).has(evt.target).length) {
          return;
        }

        $list.removeAttr('aria-live');
        if (autoplay) {
          this._play();
        }
      }.bind(this));
    },

    // Make sure lazyloading works on cloned slides
    _clonedLazyloading: function() {
      var $slideshow = this.$slideshow;

      $slideshow.find('.slick-slide').each(function(index, el) {
        var $slide = $(el);
        if ($slide.hasClass('slick-cloned')) {
          var slideId = $slide.data('id');
          var $slideImg = $slide.find('.hero__image').removeClass('lazyloading').addClass('lazyloaded');

          // Get inline style attribute from non-cloned slide with arbitrary timeout
          // so the image is loaded
          setTimeout(function() {
            var loadedImageStyle = $slideshow.find('.slideshow__slide--' + slideId + ':not(.slick-cloned) .hero__image').attr('style');

            if (loadedImageStyle) {
              $slideImg.attr('style', loadedImageStyle);
            }

          }, this.settings.autoplaySpeed / 1.5);

        }
      }.bind(this));
    }
  });

  return slideshow;
})();

theme.announcementBar = (function() {
  var selectors = {
    announcementBar: '.announcement',
    announcementText: '.announcement__text',
    announcementClose: '.announcement__close',
    productMainPhoto: '.product-image-main',
  };

  var classes = {
    opening: 'announcement--opening',
    closed: 'announcement--closed'
  };

  var config = {
    namespace: '.announcementBar'
  };

  function init() {
    if (!$(selectors.announcementClose).length) {
      return;
    }

    if (theme.config.hasSessionStorage && sessionStorage[announcementBarText()] !== 'hidden') {
      window.setTimeout(function() {
        announcementBarShow();
      }, 2000);
    }

    // Probably in the editor, so show it anyway
    if (!theme.config.hasSessionStorage) {
      window.setTimeout(function() {
        announcementBarShow();
      }, 2000);
    }

    $(selectors.announcementClose).on('click', function(evt) {
      evt.preventDefault();
      announcementBarClose();
    });

    $(window).on('resize' + config.namespace, $.debounce(150, announcementBarHeight));
  }

  function unload() {
    $(window).off(config.namespace);
  }

  function announcementBarShow() {
    $(selectors.announcementBar).removeClass(classes.closed);
    if ($(selectors.productMainPhoto).length > 0)
      $(selectors.productMainPhoto).addClass('announcement-bar-opened');
    announcementBarHeight();
  }

  function announcementBarHeight() {
    var barHeight = $(selectors.announcementText).outerHeight(true);
    barHeight = 120;
    $(selectors.announcementBar).addClass(classes.opening).prepareTransition().css({maxHeight: barHeight});
    $(selectors.announcementClose).css({maxHeight: barHeight});
  }

  function announcementBarClose() {
    if (theme.config.hasSessionStorage) {
      sessionStorage.setItem(announcementBarText(), 'hidden');
    }

    var barHeight = $(selectors.announcementBar).height();

    $(selectors.announcementBar).addClass(classes.closed);
  }

  function announcementBarText() {
    return $(selectors.announcementText).data('text');
  }

  return {
    init: init,
    unload: unload
  };
})();

theme.currencySwitcher = (function() {

  var selectors = {
    dataDiv: '#CurrencyData',
    picker: '.currency-input',
    flag: '.currency-flag'
  };

  var data = {};

  async function init() {
    var $dataDiv = $(selectors.dataDiv);

    if (!$dataDiv.length) {
      return;
    }

    $primaryPicker = $('#CurrencyPicker-header');
    $drawerPicker = $('#CurrencyPicker-drawer');

    // Keep all currency pickers in sync
    $primaryPicker.on('change', function() {
      $drawerPicker.val($(this).val());
    });

    $drawerPicker.on('change', function() {
      $primaryPicker.val($(this).val());
    });

    var cookieCurrency = Currency.cookie.read();
    var shopCurrency = $dataDiv.data('shop-currency');
    var defaultCurrency = $dataDiv.data('default-currency');

    if (cookieCurrency == null) {
      var location = await checkLocation();
      switch (location) {
        case 'CA':
          defaultCurrency = 'CAD';
          break;
        case 'EU':
          defaultCurrency = 'EUR';
          break;
        case 'GB':
          defaultCurrency = 'GBP';
          break;
        case 'AU':
          defaultCurrency = 'AUD';
          break;
        case 'AR':
          defaultCurrency = 'ARS';
          break;
        case 'CL':
          defaultCurrency = 'CLP';
          break;
        case 'BR':
          defaultCurrency = 'BRL';
          break;
        default:
          defaultCurrency = 'USD';
          break;
      }
    }

    data = {
      currency: shopCurrency,
      default: defaultCurrency,
      format: $dataDiv.data('format'),
      moneyFormat: $dataDiv.data('money-format'),
      moneyCurrencyFormat: $dataDiv.data('money-currency-format')
    };

    Currency.format = data.format;

    // Rely on the shop's currency format, not Shopify defaults (in case merchant changes it)
    // Currency.money_format[data.currency] = data.moneyFormat;
    // Currency.money_with_currency_format[data.currency] = data.moneyCurrencyFormat;

    // Fix for customer account page
    $('span.money span.money').each(function() {
      //$(this).parents('span.money').removeClass('money');
    });

    // Save current price
    $('span.money').each(function() {
      //$(this).attr('data-currency-' + data.currency, $(this).html());
    });

    checkCookie(cookieCurrency);
    refreshClass(Currency.currentCurrency);

    //$(selectors.picker).val(Currency.currentCurrency).on('change', refresh);
  }

//   function refresh() {
//     var newCurrency = $(selectors.picker).val();
//     Currency.convertAll(Currency.currentCurrency, newCurrency);
//     theme.cart.updateCurrency(newCurrency);
//     refreshClass(newCurrency);
//   }

//   function ajaxrefresh() {
//     var newCurrency = $(selectors.picker).val();
//     // Ajax cart always returns shop's currency, not what theme settings defines
//     Currency.convertAll(Currency.currentCurrency, newCurrency);
//     theme.cart.updateCurrency(newCurrency);
//     refreshClass(newCurrency);
//   }

  function checkCookie(cookieCurrency) {
    if (cookieCurrency == null) {
      Currency.currentCurrency = data.default;
      Currency.convertAll(data.currency, data.default);
      //theme.cart.updateCurrency(data.default);
    } else if ($(selectors.picker).length && $(selectors.picker).find('option[value=' + cookieCurrency + ']').length === 0) {
      // If the cookie value does not correspond to any value in the currency dropdown
      Currency.currentCurrency = data.currency;
      Currency.cookie.write(data.currency);
    } else if (cookieCurrency === data.currency) {
      Currency.currentCurrency = data.currency;
    } else {
      Currency.convertAll(data.currency, cookieCurrency);
      //theme.cart.updateCurrency(cookieCurrency);
    }
  }

  function checkLocation() {
    let ipInfo = theme.base.ipInfo;

    if (!ipInfo || typeof (ipInfo) !== 'object')
      return null;

    if (!ipInfo.country)
      return null;

    let countryCode = ipInfo.country;
    if (countryCode !== 'GB' && ipInfo.timezone && ipInfo.timezone.includes('Europe'))
      countryCode = 'EU';

    return countryCode;
  }

  function refreshClass(newCurrency) {
    $(selectors.flag).removeClass().addClass('currency-flag currency-' + newCurrency);
  }

  return {
    init: init,
//     refresh: refresh,
//     ajaxrefresh: ajaxrefresh
  };
})();

theme.initQuickShop = function(reinit) {
  var ids = [];
  var $buttons = $('.quick-product__btn');

  $buttons.each(function() {
    var id = $(this).data('product-id');
    var modalId = 'QuickShopModal-' + id;
    var name = 'quick-modal-' + id;

    // If another identical modal exists, remove duplicates
    if (ids.indexOf(id) > -1) {
      $('.modal--quick-shop[data-product-id="'+ id +'"]').each(function(i) {
        if (i > 0) {
          $(this).remove();
        }
      });
      return;
    }

    new theme.Modals(modalId, name);
    ids.push(id);
  });
};

theme.initSearchModal = function(reinit) {
  new theme.Modals('SearchModal', 'search-modal');
};

theme.initSortModal = function(reinit) {
  new theme.Modals('SortModal', 'sort-modal');
};

theme.initSupportMenuModal = function(reinit) {
  new theme.Modals('SupportMenuModal', 'support-menu-modal');
};

theme.videoModal = function() {
  var videoModalPlayer = null;
  var videoOptions = {
    width: 1280,
    height: 720,
    playerVars: {
      autohide: 0,
      autoplay: 1,
      branding: 0,
      cc_load_policy: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    }
  };

  var selectors = {
    triggers: 'a[href*="youtube.com/watch"], a[href*="youtu.be/"]'
  };

  if (!$(selectors.triggers).length) {
    return;
  }

  var modal = new theme.Modals('VideoModal', 'video-modal', {
    closeOffContentClick: true,
    solid: true
  });

  $(selectors.triggers).on('click', triggerYouTubeModal);

  function triggerYouTubeModal(evt) {
    evt.preventDefault();
    window.loadYouTube();

    if (theme.config.youTubeReady) {
      startVideoOnClick(evt);
    } else {
      $('body').on('youTubeReady', function() {
        startVideoOnClick(evt);
      });
    }
  }

  function startVideoOnClick(evt) {
    var $el = $(evt.target);

    // get video ID from URL
    var videoId = getYoutubeVideoId($el.attr('href'));

    var args = $.extend({}, videoOptions, {
      videoId: videoId
    });

    // Disable plays inline on mobile
    args.playerVars.playsinline = theme.config.bpSmall ? 0 : 1;

    var videoModalPlayer = new YT.Player('VideoHolder', args);
    modal.open();

    $('body').on('modalClose.VideoModal', function() {
      // Slight timeout so it is destroyed after the modal closes
      setTimeout(function() {
        videoModalPlayer.destroy();
      }, 500); // modal close css transition
    });
  }

  function getYoutubeVideoId(url) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length==11)? match[7] : false;
  }
};



theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submitted
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });

      if ($('#AddressAddress1New').length > 0) {
        new AddressAutocomplete('#AddressAddress1New', function (result) {
          console.log(result);
        });
      }

      if ($('#AddressAddress2New').length > 0) {
        new AddressAutocomplete('#AddressAddress2New', function (result) {
          console.log(result);
        });
      }
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;
      var addressSelector1 = '#AddressAddress1_' + formId;
      var addressSelector2 = '#AddressAddress2_' + formId;

      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });

      if ($(addressSelector1).length > 0) {
        new AddressAutocomplete(addressSelector1, function (result) {
          console.log(result);
        });
      }

      if ($(addressSelector2).length > 0) {
        new AddressAutocomplete(addressSelector2, function (result) {
          console.log(result);
        });
      }
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerRegisterForm() {
    var $newRegisterForm = $('#CustomerRegisterForm');

    if (!$newRegisterForm.length) {
      return;
    }

    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });

      if ($('#AddressAddress1New').length > 0) {
        new AddressAutocomplete('#AddressAddress1New', function (result) {
          console.log(result);
        });
      }

      if ($('#AddressAddress2New').length > 0) {
        new AddressAutocomplete('#AddressAddress2New', function (result) {
          console.log(result);
        });
      }
    }
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerUpdateForm() {
    var $customerUpdateForm = $('#CustomerUpdateForm');

    if (!$customerUpdateForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });

      if ($('#AddressAddress1New').length > 0) {
        new AddressAutocomplete('#AddressAddress1New', function (result) {
          console.log(result);
        });
      }

      if ($('#AddressAddress2New').length > 0) {
        new AddressAutocomplete('#AddressAddress2New', function (result) {
          console.log(result);
        });
      }
    }
  }

  /**
   *
   *  Fetch customer information / Fill out the fields
   *
   */
  function fetchCustomerInfo() {
    if (!theme.settings.customerEmail || theme.settings.customerEmail === "")
      return;

    if (theme.base.customer)
      return;

    $.ajax({
      url        : theme.settings.apiBase + "/account/get",
      method     : "POST",
      dataType   : "json",
      contentType: "application/json",
      cache      : false,
      data       : JSON.stringify({
        email: theme.settings.customerEmail
      })
    }).done((data) => {
      if (data.account) {
        theme.base.customer = data.account;
        updateAccountPage();
        updateAccountEditPage();
      }
    }).fail((error) => {
      console.log(error, "test");
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *
   *  Update account page based on the collected information
   *
   */
  function updateAccountPage() {
    if (!theme.base.customer)
      return;

    if (!theme.base.customer.shop_name || !theme.base.customer.shop_email)
      return;

    var $wrapper = $("#CustomerDetail");
    if (!$wrapper.length)
      return;

    $wrapper.find("h2").html(theme.base.customer.shop_name);
    $wrapper.find("#ContactEmail").html(theme.base.customer.shop_email);
    document.getElementById("ContactEmail").href="mailto:" + theme.base.customer.shop_email;
    $wrapper.removeClass("d-none");
  }

  /**
   *
   *  Update account page based on the collected information
   *
   */
  function updateAccountEditPage() {
    if (!theme.base.customer)
      return;

    var $wrapper = $("#CustomerUpdateForm");
    if (!$wrapper.length)
      return;

    $wrapper.find("#UpdateFirstName").val(theme.base.customer.first_name);
    $wrapper.find("#UpdateLastName").val(theme.base.customer.last_name);
    $wrapper.find("#UpdateEmail").val(theme.base.customer.email);
    $wrapper.find("#UpdateInstagram").val(theme.base.customer.instagram);
    $wrapper.find("#ShopName").val(theme.base.customer.shop_name);
    $wrapper.find("#ShopAddress").val(theme.base.customer.shop_address);
    $wrapper.find("#ShopCityName").val(theme.base.customer.shop_city);
    $wrapper.find("#ShopPostalCode").val(theme.base.customer.shop_postal_code);
    $wrapper.find("#UpdatePhone").val(theme.base.customer.shop_phone);
    $wrapper.find("#ShopEmail").val(theme.base.customer.shop_email);
    $wrapper.find("#ShopWebsite").val(theme.base.customer.shop_website);
    $wrapper.find("#ShopInstagram").val(theme.base.customer.shop_instagram);

    if (!theme.base.customer.shop_province) {
      $wrapper.find("#AddressProvinceContainerNew").attr("style", "display:none");
    } else {
      $wrapper.find("#AddressProvinceContainerNew").attr("style", "display:block");
      selectElement("AddressProvinceNew", theme.base.customer.shop_province);
    }

    selectElement("AddressCountryNew", theme.base.customer.shop_country);
  }

  function selectElement(id, valueToSelect) {
    let element = document.getElementById(id);
    element.value = valueToSelect;
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
      customerRegisterForm();
      customerUpdateForm();
      fetchCustomerInfo();
    }
  };
})();

$('#localization_form select').on('change', function(evt) {
  evt.target.closest('#localization_form').submit();
});

theme.Product = (function() {

  var classes = {
    onSale: 'on-sale',
    disabled: 'disabled',
    isModal: 'is-modal',
    loading: 'loading',
    loaded: 'loaded',
    interactable: 'video-interactable',
    zoomInit: 'photo-zoom-init'
  };

  var selectors = {
    productVideo: '.product__video',
    videoParent: '.product__video-wrapper',
    currentSlide: '.slick-current',
    zoomImage: '.photo-zoom-link__initial'
  };

  var youtubeReady;
  var videos = {};
  var youtubePlayers = [];
  var youtubeVideoOptions = {
    height: '480',
    width: '850',
    playerVars :{
      autohide: 0,
      autoplay: 1,
      branding: 0,
      cc_load_policy: 0,
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    },
    events: {
      onReady: onVideoPlayerReady,
      onStateChange: onVideoStateChange
    }
  };

  var vimeoReady;
  var vimeoPlayers = [];
  var vimeoVideoOptions = {
    byline: false,
    title: false,
    portrait: false,
    loop: true
  };

  function onVideoPlayerReady(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    youtubePlayers[playerId] = evt.target; // update stored player
    var player = youtubePlayers[playerId];

    setParentAsLoading($player);

    if (videos[playerId].style === 'muted') {
      youtubePlayers[playerId].mute().playVideo().pauseVideo();
    } else {
      setParentAsLoaded($player);
    }

    // If first slide or only photo, start video
    if ($player.closest(selectors.currentSlide).length || $player.data('image-count') === 1) {
      youtubePlayers[playerId].playVideo();
      initCheckVisibility(playerId);
    }
  }

  function initCheckVisibility(playerId) {
    // Add out of view pausing
    videoVisibilityCheck(playerId);
    $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
  }

  function videoVisibilityCheck(id) {
    var playerId;

    if (typeof id === 'string') {
      playerId = id;
    } else {
      // Data comes in as part of the scroll event
      playerId = id.data.id;
    }

    if (theme.isElementVisible($('#' + playerId))) {
      if (videos[playerId] && videos[playerId].style === 'unmuted') {
        return;
      }
      playVisibleVideo(playerId);
    } else {
      pauseHiddenVideo(playerId);
    }
  }

  function playVisibleVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
      youtubePlayers[id].playVideo();
    }
  }

  function pauseHiddenVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
      youtubePlayers[id].pauseVideo();
    }
  }

  function onVideoStateChange(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    var player = youtubePlayers[playerId];

    switch (evt.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (videos[playerId].attemptedToPlay) {
          setParentAsLoaded($player);
          setVideoToBeInteractedWith($player);
        }
        break;
      case 0: // ended
        player.playVideo();
        break;
      case 1: // playing
        setParentAsLoaded($player);
        break;
      case 3: // buffering
        videos[playerId].attemptedToPlay = true;
        break;
    }
  }

  function setParentAsLoading($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.loading);
  }

  function setParentAsLoaded($el) {
    $el
      .closest(selectors.videoParent)
      .removeClass(classes.loading)
      .addClass(classes.loaded);
  }

  function setVideoToBeInteractedWith($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.interactable);
  }

  function Product(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');

    this.inModal = $container.closest('.modal').length;
    this.$modal;

    this.settings = {
      enableHistoryState: $container.data('enable-history-state') || false,
      namespace: '.product-' + sectionId,
      zoom: $container.data('image-zoom') || false,
      inventory: $container.data('inventory') || false,
      modalInit: false,
      lazyLoadModalContent: $container.data('lazyload-content') || false,
      slickInitialized: false,
      hasImages: true,
      hasMultipleImages: false,
      imageSize: '620x'
    };

    // Overwrite some settings when loaded in modal
    if (this.inModal) {
      this.settings.enableHistoryState = false;
      this.settings.namespace = '.product-' + sectionId + '-modal';
      this.$modal = $('#QuickShopModal-' + sectionId);
    }

    this.selectors = {
      productJson: 'ProductJson-' + sectionId,

      video: 'ProductVideo-' + sectionId,
      photoThumbs: '.product__thumb-' + sectionId,
      thumbSlider: '#ProductThumbs-' + sectionId,
      mainSlider: '#ProductPhotos-' + sectionId,
      productImageMain: '.product-image-main--' + sectionId,

      priceWrapper: '.product__price-wrap-' + sectionId,
      price0: '#ProductPrice-' + sectionId,
      price: '.product__price-' + sectionId,
      comparePrice: '#ComparePrice-' + sectionId,
      priceA11y: '#PriceA11y-' + sectionId,
      comparePriceA11y: '#ComparePriceA11y-' + sectionId,
      sku: '#Sku-' + sectionId,
      inventory: '#ProductInventory-' + sectionId,
      quantity: '#Quantity-' + sectionId,

      addToCart: '#AddToCart-' + sectionId,
      addToCartText: '#AddToCartText-' + sectionId,

      originalSelectorId: '#ProductSelect-' + sectionId,
      singleOptionSelector: '.variant__input-' + sectionId,
      variantColorSwatch: '.variant__input--color-swatch-' + sectionId,

      modalFormHolder: '#ProductFormHolder-' + sectionId,
      formContainer: '#AddToCartForm-' + sectionId,

      bulkForm: '.bulk-form',
      notifyForm: '.notify-form',
    };

    if (!$('#' + this.selectors.productJson).html()) {
      return;
    }

    this.productObject = JSON.parse(document.getElementById(this.selectors.productJson).innerHTML);

    this.$mainSlider = $(this.selectors.mainSlider);
    this.$thumbSlider = $(this.selectors.thumbSlider);
    this.$firstProductImage = this.$mainSlider.find('img').first();

    if (!this.$firstProductImage.length) {
      this.settings.hasImages = false;
    }

    this.init();
  }

  Product.prototype = $.extend({}, Product.prototype, {
    init: function() {
      if (this.inModal) {
        this.$container.addClass(classes.isModal);
        $('body').on('modalOpen.QuickShopModal-' + this.sectionId, this.openModalProduct.bind(this));
        $('body').on('modalClose.QuickShopModal-' + this.sectionId, this.closeModalProduct.bind(this));
      }

      if (!this.inModal) {
        this.stringOverrides();
        this.formSetup();
        this.productSetup();

        this.checkIfVideos();
        this.createImageCarousels();
      }
    },

    formSetup: function() {
      this.initQtySelector();
      this.initAjaxProductForm();
      this.initVariants();
    },

    productSetup: function() {
      this.setImageSizes();
      this.initImageSwitch();
    },

    stringOverrides: function() {
      theme.productStrings = theme.productStrings || {};
      $.extend(theme.strings, theme.productStrings);
    },

    setImageSizes: function() {
      if (!this.settings.hasImages) {
        return;
      }

      // Get srcset image src, works on most modern browsers
      // otherwise defaults to settings.imageSize
      var currentImage = this.$firstProductImage[0].currentSrc;

      if (currentImage) {
        this.settings.imageSize = theme.Images.imageSize(currentImage);
      }

      if (this.settings.zoom) {
        this.settings.imageZoomSize = theme.Images.imageSize(this.$firstProductImage.parent().data('zoom-size'));
      }
    },

    initVariants: function() {
      var options = {
        $container: this.$container,
        enableHistoryState: this.settings.enableHistoryState,
        singleOptionSelector: this.selectors.singleOptionSelector,
        originalSelectorId: this.selectors.originalSelectorId,
        product: this.productObject
      };

      if ($(this.selectors.variantColorSwatch).length) {
        $(this.selectors.variantColorSwatch).on('change', function(evt) {
          var $el = $(evt.currentTarget);
          var color = $el.data('color-name');
          var index = $el.data('color-index');
          this.updateColorName(color, index);
        }.bind(this));
      }

      this.variants = new slate.Variants(options);
      this.$container.on('variantChange' + this.settings.namespace, this.updateCartButton.bind(this));
      this.$container.on('variantImageChange' + this.settings.namespace, this.updateVariantImage.bind(this));
      this.$container.on('variantPriceChange' + this.settings.namespace, this.updatePrice.bind(this));
      this.$container.on('variantChange' + this.settings.namespace, this.updateQuantitySelector.bind(this));
      if ($(this.selectors.sku).length) {
        this.$container.on('variantSKUChange' + this.settings.namespace, this.updateSku.bind(this));
      }
      if (this.settings.inventory) {
        this.$container.on('variantChange' + this.settings.namespace, this.updateInventory.bind(this));
      }
    },

    // Variant change functions
    updateColorName: function(color, index) {
      // Updates on radio button change, not variant.js
      $('#VariantColorLabel-' + this.sectionId + '-' + index).text(color);
    },

    updateCartButton: function(evt) {
      var variant = evt.variant;

      if (variant) {
        if (variant.available) {
          // Available, enable the submit button and change text
          $(this.selectors.addToCart).removeClass(classes.disabled).prop('disabled', false);
          $(this.selectors.addToCartText).html(theme.strings.addToCart);
        } else {
          // Sold out, disable the submit button and change text
          $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
          $(this.selectors.addToCartText).html(theme.strings.soldOut);
        }
      } else {
        // The variant doesn't exist, disable submit button
        $(this.selectors.addToCart).addClass(classes.disabled).prop('disabled', true);
        $(this.selectors.addToCartText).html(theme.strings.unavailable);
      }
    },

    updatePrice: function(evt) {
      var variant = evt.variant;

      if (variant) {
        // Regular price
        var oldCurrency = $(this.selectors.price).attr('data-shop-currency');
        var newCurrency = $(this.selectors.price).attr('data-currency');
        var quantity = $(this.selectors.price).hasClass('sub-total') ? $(this.selectors.quantity).val() : 1;
        var price = Currency.convert(variant.price, oldCurrency, newCurrency);

        $(this.selectors.price).html(Currency.formatMoney(price, Currency[Currency.format][newCurrency])).show();
        $(this.selectors.price + ".sub-total").html(Currency.formatMoney(price * quantity, Currency[Currency.format][newCurrency])).show();
        $(this.selectors.quantity).attr('data-price', price);

        // Sale price, if necessary
        if (variant.compare_at_price > variant.price) {
          var compare_at_price = Currency.convert(variant.compare_at_price, oldCurrency, newCurrency);
          $(this.selectors.comparePrice).html(Currency.formatMoney(compare_at_price, Currency[Currency.format][newCurrency]));
          $(this.selectors.priceWrapper).removeClass('hide');
          $(this.selectors.price).addClass(classes.onSale);
          $(this.selectors.comparePriceA11y).attr('aria-hidden', 'false');
          $(this.selectors.priceA11y).attr('aria-hidden', 'false');
        } else {
          $(this.selectors.priceWrapper).addClass('hide');
          $(this.selectors.price).removeClass(classes.onSale);
          $(this.selectors.comparePriceA11y).attr('aria-hidden', 'true');
          $(this.selectors.priceA11y).attr('aria-hidden', 'true');
        }

        if ($('body').hasClass('currencies-enabled')) {
          // Disable ajax refreshing?
          // theme.currencySwitcher.ajaxrefresh();
        }
      }
    },

    updateSku: function(evt) {
      var variant = evt.variant;
      var newSku = '';

      if (variant) {
        if (variant.sku) {
          newSku = variant.sku;
        }

        $(this.selectors.sku).html(newSku);
      }
    },

    updateInventory: function(evt) {
      var variant = evt.variant;
      var showInventory = false;
      var quantity = 0;
      var $inventoryLabel = $(this.selectors.inventory);

      if (variant && variant.inventory_management === 'shopify') {
        showInventory = true;
        quantity = window.inventories[this.sectionId][variant.id];

        if (quantity === 0) {
          showInventory = false;
        }
      }

      if (!showInventory) {
        $inventoryLabel.addClass('hide');
      } else {
        $inventoryLabel
          .removeClass('hide')
          .text(theme.strings.stockLabel.replace('[count]', quantity));
      }
    },

    updateQuantitySelector: function(evt) {
      var variant = evt.variant;
      var showQuantity = false;
      var quantity = 0;
      var $quantityLabel = $("label[for='"+this.selectors.quantity.substr(1)+"']");
      var $quantitySelector = $(this.selectors.quantity);

      if (variant && variant.inventory_management === 'shopify') {
        showQuantity = true;
        quantity = window.inventories[this.sectionId][variant.id];

        if (quantity === 0) {
          showQuantity = false;
        }
      }

      if (!showQuantity) {
        $quantityLabel.addClass('hide');
        $quantitySelector.addClass('hide');
      } else {
        $quantityLabel.removeClass('hide');
        $quantitySelector.empty();
        var amount = quantity > theme.settings.maxAmount ? theme.settings.maxAmount : quantity;
        for (var i = 1; i <= amount; i++) {
          $quantitySelector
            .append($("<option></option>")
              .attr("value",i)
              .text(i));
        }
        $quantitySelector
          .removeClass('hide');
      }
    },

    updateVariantImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);
      var zoomSizedImgUrl;

      if (this.settings.zoom) {
        zoomSizedImgUrl = theme.Images.getSizedImageUrl(variant.featured_image.src, this.settings.imageZoomSize);
      }

      var $newImage = $('.product__thumb[data-id="' + variant.featured_image.id + '"]');
      var imageIndex = this._slideIndex($newImage.closest('.product__thumb-item'));

      // If there is no index, slider is not initalized
      if (typeof imageIndex === 'undefined') {
        return;
      }

      // console.log('slick go to : ' + imageIndex);
      this.$mainSlider.slick('slickGoTo', imageIndex);
    },

    // Image/thumbnail toggling
    initImageSwitch: function() {
      if (!$(this.selectors.photoThumbs).length) {
        return;
      }

      var self = this;

      $(this.selectors.photoThumbs).on('click', function(evt) {
        evt.preventDefault();
      });
    },

    checkIfVideos: function() {
      var $productVideos = this.$mainSlider.find(selectors.productVideo);

      // Stop if there are 0 videos
      if (!$productVideos.length) {
        return false;
      }

      var videoTypes = [];

      $productVideos.each(function() {
        var type = $(this).data('video-type');

        if (videoTypes.indexOf(type) < 0) {
          videoTypes.push(type);
        }
      });

      // Load YouTube API if not already loaded
      if (videoTypes.indexOf('youtube') > -1) {
        if (!theme.config.youTubeReady) {
          window.loadYouTube();
          $('body').on('youTubeReady' + this.settings.namespace, function() {
            this.loadYoutubeVideos($productVideos);
          }.bind(this));
        } else {
          this.loadYoutubeVideos($productVideos);
        }
      }

      // Load Vimeo API if not already loaded
      if (videoTypes.indexOf('vimeo') > -1) {
        if (!vimeoReady) {
          window.loadVimeo();
          $('body').on('vimeoReady' + this.settings.namespace, function() {
            this.loadVimeoVideos($productVideos);
          }.bind(this))
        } else {
          this.loadVimeoVideos($productVideos);
        }
      }

      // Add mp4 video players
      if (videoTypes.indexOf('mp4') > -1) {
        this.loadMp4Videos($productVideos);
      }

      return videoTypes;
    },

    loadMp4Videos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'mp4') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('video-id');

        videos[this.id] = {
          type: 'mp4',
          divId: id,
          style: $el.data('video-style')
        };
      });
    },

    loadVimeoVideos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'vimeo') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('video-id');

        videos[this.id] = {
          type: 'vimeo',
          divId: id,
          id: videoId,
          style: $el.data('video-style'),
          width: $el.data('video-width'),
          height: $el.data('video-height')
        };
      });

      // Create a new player for each Vimeo video
      for (var key in videos) {
        if (videos[key].type != 'vimeo') {
          continue;
        }

        var args = $.extend({}, vimeoVideoOptions, videos[key]);
        vimeoPlayers[key] = new Vimeo.Player(videos[key].divId, args);
      }

      vimeoReady = true;
    },

    autoplayVimeoVideo: function(id) {
      // Do not autoplay on mobile though
      if (!theme.config.bpSmall) {
        this.requestToPlayVimeoVideo(id);
      } else {
        // Set as loaded on mobile so you can see the image
        var $player = $('#' + id);
        setParentAsLoaded($player);
      }
    },

    requestToPlayVimeoVideo: function(id) {
      // The slider may initialize and attempt to play the video before
      // the API is even ready, because it sucks.

      var $player = $('#' + id);
      setParentAsLoading($player);

      if (!vimeoReady) {
        // Wait for the trigger, then play it
        $('body').on('vimeoReady' + this.settings.namespace, function() {
          this.playVimeoVideo(id);
        }.bind(this))
        return;
      }

      this.playVimeoVideo(id);
    },

    playVimeoVideo: function(id) {
      vimeoPlayers[id].play();

      if (videos[id].style === 'muted') {
        vimeoPlayers[id].setVolume(0);
      }

      var $player = $('#' + id);
      setParentAsLoaded($player);
    },

    stopVimeoVideo: function(id) {
      if (!theme.config.vimeoReady) {
        return;
      }

      if (id) {
        vimeoPlayers[id].pause();
      } else {
        for (key in vimeoPlayers) {
          if (typeof vimeoPlayers[key].pause === 'function') {
            vimeoPlayers[key].pause();
          }
        }
      }
    },

    loadYoutubeVideos: function($videos) {
      $videos.each(function() {
        var $el = $(this);
        if ($el.data('video-type') != 'youtube') {
          return;
        }

        var id = $el.attr('id');
        var videoId = $el.data('youtube-id');

        videos[this.id] = {
          type: 'youtube',
          id: id,
          videoId: videoId,
          style: $el.data('video-style'),
          width: $el.data('video-width'),
          height: $el.data('video-height'),
          attemptedToPlay: false
        };
      });

      // Create a player for each YouTube video
      for (var key in videos) {
        if (videos[key].type === 'youtube') {
          if (videos.hasOwnProperty(key)) {
            var args = $.extend({}, youtubeVideoOptions, videos[key]);

            if (args.style === 'muted') {
              // default youtubeVideoOptions, no need to change anything
            } else {
              args.playerVars.controls = 1;
              args.playerVars.autoplay = 0;
            }

            youtubePlayers[key] = new YT.Player(key, args);
          }
        }
      }

      youtubeReady = true;
    },

    requestToPlayYoutubeVideo: function(id, forcePlay) {
      if (!theme.config.youTubeReady) {
        return;
      }

      var $player = $('#' + id);
      setParentAsLoading($player);

      // If video is requested too soon, player might not be ready.
      // Set arbitrary timeout to request it again in a second
      if (typeof youtubePlayers[id].playVideo != 'function') {
        var o = this;
        setTimeout(function() {
          o.playYoutubeVideo(id, forcePlay);
        }, 1000);
        return;
      }

      this.playYoutubeVideo(id, forcePlay);
    },

    playYoutubeVideo: function (id, forcePlay) {
      var $player = $('#' + id);
      setParentAsLoaded($player);
      if (typeof youtubePlayers[id].playVideo === 'function') {
        youtubePlayers[id].playVideo();
      }

      // forcePlay is sent as true from beforeSlideChange so the visibility
      // check isn't fooled by the next slide positioning
      if (!forcePlay) {
        initCheckVisibility(id);
      }
    },

    stopYoutubeVideo: function(id) {
      if (!theme.config.youTubeReady) {
        return;
      }

      if (id && youtubePlayers[id]) {
        if (typeof youtubePlayers[id].pauseVideo === 'function') {
          youtubePlayers[id].pauseVideo();
        }
        $(window).off('scroll.' + id);
      } else {
        for (key in youtubePlayers) {
          if (typeof youtubePlayers[key].pauseVideo === 'function') {
            youtubePlayers[key].pauseVideo();
            $(window).off('scroll.' + key);
          }
        }
      }
    },

    playMp4Video: function(id) {
      var $player = $('#' + id);
      setParentAsLoaded($player);

      $player[0].play();
    },

    stopMp4Video: function(id) {
      if (id) {
        $('#' + id)[0].pause();
      } else {
        // loop through all mp4 videos to stop them
        for (var key in videos) {
          if (videos[key].type === 'mp4') {
            var player = $('#' + videos[key].divId)[0];
            if (typeof player.pause === 'function') {
              player.pause();
            }
          }
        }
      }
    },

    // Init zoom for each image in the main carousel
    initZoom: function($image) {
      var largeImage = $image.parent().data('zoom-size');
      $image.parent()
      .on('click', function(evt) {
        evt.preventDefault();
      })
      .zoom({
        on: 'click',
        url: largeImage,
        duration: 180,
        touch: false,
        onZoomIn: function() {
          $(this).addClass('photo-zoom-linked');
        },
        onZoomOut: function() {
          $(this).removeClass('photo-zoom-linked');
        }
      });
    },

    createImageCarousels: function() {
      if (!this.$thumbSlider.length || $(this.selectors.photoThumbs).length < 2) {
        // Single product image. Init video if it exists
        var $video = $(this.selectors.productImageMain).find(selectors.productVideo);
        if ($video.length) {
          this.initVideo($video);
        }

        // Init zoom since the carousel won't do it
        if (this.settings.zoom) {
          this.initZoom($(this.selectors.productImageMain).find(selectors.zoomImage));
        }

        return;
      }

      this.settings.hasMultipleImages = true;

      // Set starting slide (for both sliders)
      var $activeSlide = this.$mainSlider.find('.starting-slide');
      var startIndex = this._slideIndex($activeSlide);

      // Lame way to prevent duplicate event listeners
      this.$mainSlider.off('init');
      this.$mainSlider.off('beforeChange');
      this.$mainSlider.on('init', this.mainSlideInit.bind(this));
      this.$mainSlider.on('beforeChange', this.beforeSlideChange.bind(this));

      var thumbnailsVertical = this.$thumbSlider.data('position') === 'beside' ? true : false;

      this.$mainSlider.slick({
        adaptiveHeight: thumbnailsVertical ? false : true,
        asNavFor: this.selectors.thumbSlider,
        infinite: false,
        arrows: false,
        dots: true,
        initialSlide: startIndex
      });

      this.$thumbSlider.slick({
        asNavFor: this.selectors.mainSlider,
        slidesToShow: thumbnailsVertical ? 3 : 5,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        vertical: thumbnailsVertical,
        verticalSwiping: thumbnailsVertical,
        focusOnSelect: true,
        infinite: false,
        customHeightMatching: thumbnailsVertical,
        customSlideAdvancement: true,
        initialSlide: startIndex,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
              arrows: false,
              centerMode: true,
              centerPadding: 0,
              vertical: false,
              customSlideAdvancement: false,
              infinite: true
            }
          }
        ]
      });

      // Too many thumbnails can cause the AOS calculations to be off
      // so refresh that when the slider is ready
      if (AOS) {
        AOS.refresh();
      }

      this.settings.slickInitialized = true;
    },

    destroyImageCarousels: function() {
      if (!this.settings.slickInitialized) {
        return;
      }

      if (this.$mainSlider) {
        this.$mainSlider.slick('unslick');
      }

      if (this.$thumbSlider) {
        this.$thumbSlider.slick('unslick');
      }

      this.settings.slickInitialized = false;
    },

    mainSlideInit: function(event, slick) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find(selectors.currentSlide);
      var $video = $currentSlide.find(selectors.productVideo);

      if (!$video.length) {
        return;
      }

      this.initVideo($video);
    },

    initVideo: function($video) {
      var videoType = $video.data('video-type');
      var divId = $video.attr('id');

      if (videoType === 'mp4' && videos[divId].style === 'muted') {
        this.playMp4Video(divId);
      }

      if (videoType === 'youtube') {
        if (youtubeReady && videos[divId].style === 'muted') {
          this.requestToPlayYoutubeVideo(divId);
        }
      }

      if (videoType === 'vimeo') {
        if (vimeoReady && videos[divId].styles === 'muted') {
          // Because the vimeo API might not be ready, this autoplay check
          // is handled elsewhere
          this.autoplayVimeoVideo(divId);
        }
      }

      // Hacky way to trigger resetting the slider layout in modals
      if (this.inModal) {
        this.resizeSlides();
      }
    },

    getVideoType: function($video) {
      return $video.data('video-type');
    },

    getVideoId: function($video) {
      return $video.attr('id');
    },

    beforeSlideChange: function(event, slick, currentSlide, nextSlide) {
      var $slider = slick.$slider;
      var $currentSlide = $slider.find(selectors.currentSlide);
      var $prevVideo = $currentSlide.find('.product__video');
      var $nextSlide = $slider.find('.slick-slide[data-slick-index="' + nextSlide + '"]');
      var $nextVideo = $nextSlide.find('.product__video');

      // Pause any existing slide video
      if (currentSlide !== nextSlide && $prevVideo.length) {
        var prevVideoType = this.getVideoType($prevVideo);
        var prevVideoId = this.getVideoId($prevVideo);

        if (prevVideoId) {
          if (prevVideoType === 'youtube') {
            this.stopYoutubeVideo(prevVideoId);
          }

          if (prevVideoType === 'mp4') {
            this.stopMp4Video(prevVideoId);
          }

          if (prevVideoType === 'vimeo') {
            this.stopVimeoVideo(prevVideoId);
          }
        }
      }

      // Prep next slide video
      if ($nextVideo.length) {
        var nextVideoType = this.getVideoType($nextVideo);
        var nextVideoId = this.getVideoId($nextVideo);

        // Prep Vimeo with a backup in case the API isn't ready
        if (nextVideoId && nextVideoType === 'vimeo') {
          if (vimeoReady) {
            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
              this.autoplayVimeoVideo(nextVideoId);
            }
          } else {
            $('body').on('vimeoReady' + this.settings.namespace, function() {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.autoplayVimeoVideo(nextVideoId);
              }
            }.bind(this))
          }
        }

        // Prep YouTube with a backup in case API isn't ready
        if (nextVideoId && nextVideoType === 'youtube') {
          if (youtubeReady) {
            if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
              this.requestToPlayYoutubeVideo(nextVideoId, true);
            }
          } else {
            $('body').on('youTubeReady' + this.settings.namespace, function() {
              if (videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
                this.requestToPlayYoutubeVideo(nextVideoId, true);
              }
            }.bind(this))
          }
        }

        // Autoplay muted MP4 videos
        if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style === 'muted') {
          if (nextVideoType === 'mp4') {
            this.playMp4Video(nextVideoId);
          }
        }

        // Set unmuted videos to loaded state
        if (nextVideoId && videos[nextVideoId] && videos[nextVideoId].style != 'muted') {
          setParentAsLoaded($('#' + nextVideoId));
        }
      }

      // Layload zoom image
      if (this.settings.zoom) {
        if ($nextSlide.hasClass(classes.zoomInit)) {
          return;
        }
        var $image = $nextSlide.addClass(classes.zoomInit).find('img').addClass('lazyload');
        this.initZoom($image);
      }
    },

    resizeSlides: function() {
      if (!this.settings.hasMultipleImages) {
        return;
      }

      $(window).trigger('resize');
      setTimeout(function() {
        this.$mainSlider.slick('setPosition');
        this.$thumbSlider.slick('setPosition');
      }.bind(this), 500); // same timing as modal open transition
    },

    _slideIndex: function($el) {
      return $el.data('index');
    },

    // Ajax cart and qty
    initQtySelector: function() {
      this.$container.find('.js-qty').each(function() {
        new theme.QtySelector($(this), {
          namespace: '.product'
        });
      });
    },

    initAjaxProductForm: function() {
      if (theme.settings.cartType === 'drawer') {
        new theme.AjaxProduct($(this.selectors.formContainer));
      }

      // Init Ajax Product Form V2
      Array.prototype.forEach.call($(this.selectors.bulkForm), function (item) {
        new theme.AjaxProductV2($(item));
      });

      // Init Notify-me Form
      Array.prototype.forEach.call($(this.selectors.notifyForm), function (item) {
        new theme.NotifyForm($(item));
      });
    },

    openModalProduct: function() {
      if (!this.settings.modalInit) {
        var $formHolder = $(this.selectors.modalFormHolder);
        var url = $formHolder.data('url');

        $formHolder.load(url + ' #AddToCartForm-' + this.sectionId, function() {
          this.formSetup();
          if (Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }.bind(this));

        this.productSetup();
        this.loadModalContent();
        this.createImageCarousels();
        this.settings.modalInit = true;
      }

      this.resizeSlides();
    },

    closeModalProduct: function() {
      this.stopYoutubeVideo();
      this.stopVimeoVideo();
      this.stopMp4Video();
    },

    loadModalContent: function() {
      // Load videos if they exist
      var videoTypes = this.checkIfVideos();

      // Lazyload mp4 videos similar to images
      if (videoTypes && videoTypes.indexOf('mp4') > -1) {
        this.$modal.find('.product__video[data-video-type="mp4"]').each(function(i, video) {
          var $el = $(video);
          var src = $el.data('video-src');
          var source = document.createElement('source');
          source.setAttribute('src', src);
          $el.append(source);
        }.bind(this));
      }
    },

    onUnload: function() {
      this.$container.off(this.settings.namespace);
      $('body').off(this.settings.namespace);
      this.destroyImageCarousels();
    }
  });

  return Product;
})();

theme.Swatch = (function() {
  var selectors = {
    swatchPicker: '.swatch-picker',
    swatchContent: '.swatch-content'
  };

  function Swatch($parent) {
    this.$parent = $parent;
    this.$picker = this.$parent.find(selectors.swatchPicker);
    this.$activeContent = this.$parent.find(selectors.swatchContent + ':not(.sold-out)');

    this.settings = {
      nCurrentTab: this.$activeContent.data('index'),
      nPrevTab: this.$activeContent.data('index')
    };

    if (this.$parent.length) {
      this.$picker.on('click', this.updateSwatch.bind(this));
    }
  }

  Swatch.prototype = $.extend({}, Swatch.prototype, {
    updateSwatch: function(e) {
      var $picker = $(e.target);

      if ($picker.hasClass('active'))
        return;

      this.$picker.removeClass('active');
      $picker.addClass('active');

      this.settings.nPrevTab = this.settings.nCurrentTab;
      this.settings.nCurrentTab = $picker.data('index');

      this.$parent.find(selectors.swatchContent + '[data-index="' + this.settings.nPrevTab + '"]').hide();
      this.$parent.find(selectors.swatchContent + '[data-index="' + this.settings.nCurrentTab + '"]').fadeIn('fast');
    }
  });

  return Swatch;
})();

theme.ThumbLoads = (function() {
  var selectors = {
    btnDownload: '.btn-download',
  };

  function ThumbLoads($parent) {
    this.$parent = $parent;
    this.$img = this.$parent.find('img')[0];
    this.$canvas = document.createElement('canvas');
    this.$btnDownload = this.$parent.find(selectors.btnDownload);

    if (this.$parent.length) {
      this.$btnDownload.on('click', this.download.bind(this));
    }
  }

  ThumbLoads.prototype = $.extend({}, ThumbLoads.prototype, {
    download: function() {
      this.resolveCanvasDimensions();
      this.processImage();
    },

    downloadBlob: function(blob, filename) {
      // Create an object URL for the blob object
      const url = URL.createObjectURL(blob);

      // Create a new anchor element
      const a = document.createElement('a');

      // Set the href and download attributes for the anchor element
      a.href = url;
      a.download = this.$parent.data('title') || 'download';

      // Click handler that releases the object URL after the element has been clicked
      // This is required for one-off downloads of the blob content
      const clickHandler = function() {
        setTimeout(() => {
          // Release the object URL
          URL.revokeObjectURL(url);

          // Remove the event listener from the anchor element
          this.removeEventListener('click', clickHandler);

          // Remove the anchor element from the DOM
          (this.remove && (this.remove(), 1)) ||
          (this.parentNode && this.parentNode.removeChild(this));
        }, 150)
      };

      // Programmatically trigger a click on the anchor element
      a.click();
    },

    resolveCanvasDimensions: function() {
      const { width, height } = window.getComputedStyle(this.$img);

      this.$canvas.width = +parseFloat(width)*2;
      this.$canvas.height = +parseFloat(height)*2;

      this.$canvas.style.width = +parseFloat(width)*2 + 'px';
      this.$canvas.style.height = +parseFloat(height)*2 + 'px';
    },

    processImage: function() {
      const ctx = this.$canvas.getContext('2d');
      const { width, height } = this.$canvas;

      ctx.drawImage(this.$img, 0, 0, width, height);

      this.$canvas.toBlob(blob => {
        this.downloadBlob(blob);
      });
    }
  });

  return ThumbLoads;
})();

theme.ProductGridItemV1 = (function() {
  function ProductGridItemV1(container) {
    this.container = container;
    
    this.init();
  }
  
  ProductGridItemV1.prototype = $.extend({}, ProductGridItemV1.prototype, {
    init: function() {
      this.$container = $(this.container);
      let onSale = this.$container.data('on-sale');
      let productTags = this.$container.data('product-tags');
      let isGlobalProduct = this.$container.data('global-product');
      let shippingCountry = this.$container.data('shipping-country');
      let isEuropeDistribution = shippingCountry !== '' ? theme.settings.euDistributionCountries.includes(shippingCountry) : theme.settings.euDistributionCountries.includes(theme.base.ipInfo.country);
      
      if (productTags) {
      	productTags = productTags.split(",");
        if ((productTags.includes('soldout-uk') && isEuropeDistribution) ||
            (productTags.includes('soldout-markham') && !isEuropeDistribution) ||
            (productTags.includes('soldout-global') && productTags.includes('use_global_quantity')) ||
            (productTags.includes('soldout-global') && isGlobalProduct)){
          this.$container.find('.grid-sold_out_message').addClass('is-visible');
          this.$container.find('.grid-product__secondary-image').removeClass('is-visible');
        } 
      } else {
        if (false) {
        	this.$container.addClass('grid-product__has-quick-shop');
        	this.$container.find('.quick-product__btn').addClass('is-visible');
        }
        
        if (onSale) {
          this.$container.find('.grid-on_sale_message').addClass('is-visible');
        }
      }
    }
  });
  
  return ProductGridItemV1;
  
})();

theme.ProductGridItem = (function() {
  function ProductGridItem(container) {
    this.container = container;
    
    this.init();
  }
  
  ProductGridItem.prototype = $.extend({}, ProductGridItem.prototype, {
    init: function() {
      this.$container = $(this.container);
      let productTags = this.$container.data('product-tags');
      let isGlobalProduct = this.$container.data('global-product');
      let shippingCountry = this.$container.data('shipping-country');
      let isEuropeDistribution = shippingCountry !== '' ? theme.settings.euDistributionCountries.includes(shippingCountry) : theme.settings.euDistributionCountries.includes(theme.base.ipInfo.country);
       // let compareAtPriceExists = this.$container.find('.visually-hidden').length > 0; 
      
      if (productTags) {
      	productTags = productTags.split(",");
        //debugging sold out stikcer not showin sometimes, delete when resolved
//         if (productTags.includes('soldout-markham')) {
//            console.log("sold out");
//         } else {
//            console.log("available");
//         }
        
        if ((productTags.includes('soldout-uk') && isEuropeDistribution) ||
            (productTags.includes('soldout-markham') && !isEuropeDistribution) ||
            (productTags.includes('soldout-global') && productTags.includes('use_global_quantity')) ||
            (productTags.includes('soldout-global') && isGlobalProduct)) {
          this.$container.find('.grid-product__tag').addClass('is-visible');
          this.$container.find('.add-to-bag_btn').css("display", "none");
        } 
        if ((productTags.includes('pricedrop')) || 
            (productTags.includes('leaving-soon'))) {
          this.$container.find('.grid-product__tag').addClass('is-visible');
          
          
        }

        //  if ((productTags.includes('comingsoon'))) {
        //   this.$container.find('.grid-product__tag').addClass('is-visible');
        //     this.$container.find('.add-to-bag_btn').css("display", "none");
        // }

        if (productTags.includes('comingsoon')) {
            this.$container.find('.grid-product__tag').addClass('is-visible');
            this.$container.find('.add-to-bag_btn').css("display", "none");
        }

         if (window.location.href.includes('best-selling-body-jewelry')) {
            if (productTags.includes('comingsoon')) {
                this.$container.find('.grid-product__tag').removeClass('is-visible');
                this.$container.find('.add-to-bag_btn').css("display", "flex");
            }
        }


        
        if ((productTags.includes('last_chance'))) {
          this.$container.find('.grid-product__tag').addClass('is-visible');
        }
      } else {
      	console.log("no product tags");
      }
    }
  });
  
  return ProductGridItem;
  
})();

theme.Cart = (function() {
  let selectors = {
    productItem: '.product-item'
  };
  
  function Cart(container) {
    this.container = container;
    this.init();
  }
  
  Cart.prototype = $.extend({}, Cart.prototype, {
    init: function() {
      let self = this;
      Array.prototype.forEach.call($(selectors.productItem), function (item) {
        let $productItem = $(item);
        let $cartItem = $productItem.closest('.cart-item');
        let productId = $cartItem.attr('data-product-id');
        let useTotalQuantity = $cartItem.attr('data-use-total-quantity') == "true";
        
        let variantId = $cartItem.data('variant-id').toString();
        let $qtyInput = $('#updates_' + variantId);
        
        theme.cart.updateBetterAsPairMessage($productItem, $qtyInput.attr('value'));
        
        if (!useTotalQuantity) {

          $.ajax({
            url        : theme.settings.apiBase + `/product/${productId}/inventory-level`,
            method     : "GET",
            dataType   : "json",
            contentType: "application/json",
            cache      : false,
          }).done((response) => {
            if (response.status === 'success' && response.inventory_levels && response.inventory_levels.length > 0) {
              self.updateAvailability($cartItem, response.inventory_levels);
               console.log("inventory!", response.inventory_levels);
            }
          }).fail((error) => {
            console.log(error);
          });
        }
      });
    },
    
    updateAvailability: function($cartItem, inventoryLevels) {
      let variantId = $cartItem.data('variant-id').toString();
      let quantity = 0;
      let shippingCountry = $cartItem.data('shipping-country');
      let isEuropeDistribution = shippingCountry !== '' ? theme.settings.euDistributionCountries.includes(shippingCountry) : theme.settings.euDistributionCountries.includes(theme.base.ipInfo.country);
      
      inventoryLevels.forEach((inventoryLevel) => {
          if (inventoryLevel.variant_id !== variantId)
            return;

          if ((isEuropeDistribution && !theme.settings.euDistributionCountries.includes(inventoryLevel.country_code)) ||
              (!isEuropeDistribution && theme.settings.euDistributionCountries.includes(inventoryLevel.country_code)))
            return;
          
          quantity += inventoryLevel.available;
        });

        // let $qtyInput = $('#updates_' + variantId);
      
        // $qtyInput.attr('max', quantity);
        // $qtyInput.attr('data-max', quantity);
    }
  });
  
  return Cart;
})();

theme.Collection = (function() {
  var classes = {
    tags: '.tags',
    activeTag: 'tag--active'
  };
  
  let selectors = {
    gridItem: '.product-grid-item',
  };

  function Collection(container) {
    this.container = container;
    this.sectionId = $(container).attr('data-section-id');
    this.namespace = '.collection-' + this.sectionId;

    var $heroImageContainer = $(container).find('.collection-hero');
    if ($heroImageContainer.length) {
      theme.loadImageSection($heroImageContainer);
    }

    // Ajax pagination
    $(window).on('popstate', function(state) {
      if (state) {
        this.getNewCollectionContent(location.href);
      }
    }.bind(this));

    this.init();
  }

  Collection.prototype = $.extend({}, Collection.prototype, {
    init: function() {
      // init is called on load and when tags are selected
      this.$container = $(this.container);
      this.sectionId = this.$container.attr('data-section-id');

      // this.sortBy();
      this.sortTags();
      this.initTagAjax();
    },

    initTagAjax: function() {
      this.$container.on('click' + this.namespace, '.tags a', function(evt) {
        evt.preventDefault();
        var $el = $(evt.currentTarget);
        var newUrl = $el.attr('href');
        $(classes.tags).find('.' + classes.activeTag).removeClass(classes.activeTag);
        $el.parent().addClass(classes.activeTag);
        history.pushState({}, '', newUrl);
        $('.grid-product').addClass('unload');
        this.getNewCollectionContent(newUrl);
      }.bind(this));
    },

    getNewCollectionContent: function(url) {
      $('#CollectionAjaxResult').load(url + ' #CollectionAjaxContent', function() {
        this.reInit();
      }.bind(this));
    },

    sortBy: function() {
      var $sortBy = $('#SortBy');

      if (!$sortBy.length) {
        return;
      }

      $sortBy.on('change', function() {
        location.href = '?sort_by=' + $(this).val();
      });
    },

    sortTags: function() {
      var $sortTags = $('#SortTags');

      if (!$sortTags.length) {
        return;
      }

      $sortTags.on('change', function() {
        location.href = $(this).val();
      });
    },

    reInit: function() {
      // Reload collection template (it can be anywhere in the sections.instance array)
      for (var i = 0; i < sections.instances.length; i++) {
        var instance = sections.instances[i];
        if (instance['type'] === 'collection-template') {
          instance.forceReload();
        }
      }

      AOS.refreshHard();

      // Reload quick shop buttons
      theme.initQuickShop(true);

      // Reload products inside each quick shop
      sections.register('product-template', theme.Product);
    },

    forceReload: function() {
      this.onUnload();
      this.init();
    },

    onUnload: function() {
      $(window).off(this.namespace);
      this.$container.off(this.namespace);
    }

  });

  return Collection;
})();

theme.HeaderSection = (function() {

  var selectors = {
    drawer: '#NavDrawer',
    filterDrawer: '#FilterDrawer',
    mobileSubNavToggle: '.mobile-nav__toggle-btn',
    hasSublist: '.mobile-nav__has-sublist'
  };

  var classes = {
    navExpanded: 'mobile-nav--expanded'
  };

  function Header(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');

    // Reload any slideshow if when the header is reloaded to make sure the
    // sticky header works as expected (it can be anywhere in the sections.instance array)
    for (var i = 0; i < sections.instances.length; i++) {
      var instance = sections.instances[i];
      if (instance['type'] === 'slideshow-section') {
        instance.forceReload();
      }
    }

    theme.currencySwitcher.init()
    this.initDrawers();
    theme.headerNav.init();
    theme.announcementBar.init();
  }

  Header.prototype = $.extend({}, Header.prototype, {
    initDrawers: function() {
      theme.NavDrawer = new theme.Drawers('NavDrawer', 'nav');
      theme.FilterDrawer = new theme.Drawers('FilterDrawer', 'filter');
      if (theme.settings.cartType === 'drawer') {
        new theme.CartDrawer();
      }

      this.drawerMenuButtons();
    },

    drawerMenuButtons: function() {
      $(selectors.drawer).find('.js-drawer-close').on('click', function(evt){
        evt.preventDefault();
        theme.NavDrawer.close();
      });

      $(selectors.filterDrawer).find('.js-drawer-close').on('click', function(evt){
        evt.preventDefault();
        theme.FilterDrawer.close();
      });

      var $mobileSubNavToggle = $(selectors.mobileSubNavToggle);

      $mobileSubNavToggle.attr('aria-expanded', 'false');
      $mobileSubNavToggle.each(function (i, el) {
        var $el = $(el);
        $el.attr('aria-controls', $el.attr('data-aria-controls'));
      });

      $mobileSubNavToggle.on('click', function() {
        var $el = $(this);
        var currentlyExpanded = $el.attr('aria-expanded');
        var toggleState = false;

        // Updated aria-expanded value based on state pre-click
        if (currentlyExpanded === 'true') {
          $el.attr('aria-expanded', 'false');
        } else {
          $el.attr('aria-expanded', 'true');
          toggleState = true;
        }

        // Toggle class that expands/collapses sublist
        $el.closest(selectors.hasSublist).toggleClass(classes.navExpanded, toggleState);
      });
    },

    onUnload: function() {
      theme.NavDrawer.close();
      theme.FilterDrawer.close();
      theme.headerNav.unload();
      theme.announcementBar.unload();
    }
  });

  return Header;

})();

theme.FeaturedContentSection = (function() {

  function FeaturedContent() {
    $('.rte').find('a:not(:has(img))').addClass('text-link');
  }

  return FeaturedContent;
})();

theme.slideshows = {};

theme.SlideshowSection = (function() {

  function SlideshowSection(container) {
    var $container = this.$container = $(container);
    var $section = $container.parent();
    var sectionId = $container.attr('data-section-id');
    var slideshow = this.slideshow = '#Slideshow-' + sectionId;

    var $imageContainer = $(container).find('.hero');
    if ($imageContainer.length) {
      theme.loadImageSection($imageContainer);
    }

    this.init();
  }

  SlideshowSection.prototype = $.extend({}, SlideshowSection.prototype, {
    init: function() {
      var args = {
        arrows: $(this.slideshow).data('arrows'),
        dots: $(this.slideshow).data('dots')
      };

      theme.slideshows[this.slideshow] = new theme.Slideshow(this.slideshow, args);
    },

    forceReload: function() {
      this.onUnload();
      this.init();
    },

    onUnload: function() {
      theme.slideshows[this.slideshow].destroy();
      delete theme.slideshows[this.slideshow];
    },

    onSelect: function() {
      $(this.slideshow).slick('slickPause');
    },

    onDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    },

    onBlockSelect: function(evt) {
      var $slideshow = $(this.slideshow);

      // Ignore the cloned version
      var $slide = $('.slideshow__slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $slideshow.slick('slickGoTo', slideIndex).slick('slickPause');
    },

    onBlockDeselect: function() {
      $(this.slideshow).slick('slickPlay');
    }
  });

  return SlideshowSection;
})();

theme.VideoSection = (function() {
  var youtubeReady;
  var videos = [];
  var youtubePlayers = [];
  var youtubeVideoOptions = {
    width: 1280,
    height: 720,
    playerVars: {
      autohide: 0,
      branding: 0,
      cc_load_policy: 0,
      controls: 0,
      fs: 0,
      iv_load_policy: 3,
      modestbranding: 1,
      playsinline: 1,
      quality: 'hd720',
      rel: 0,
      showinfo: 0,
      wmode: 'opaque'
    },
    events: {
      onReady: onVideoPlayerReady,
      onStateChange: onVideoStateChange
    }
  };

  var vimeoReady = false;
  var vimeoVideoOptions = {
    byline: false,
    title: false,
    portrait: false,
    loop: true
  };

  var selectors = {
    videoParent: '.video-parent-section'
  };

  var classes = {
    loading: 'loading',
    loaded: 'loaded',
    interactable: 'video-interactable'
  };

  function videoSection(container) {
    var $container = this.$container = $(container);
    var sectionId = this.sectionId = $container.attr('data-section-id');
    var youtubePlayerId = this.youtubePlayerId = 'YouTubeVideo-' + this.sectionId;
    this.namespace = '.' + youtubePlayerId;
    var vimeoPlayerId = this.vimeoPlayerId = 'Vimeo-' + this.sectionId;
    var $vimeoTrigger = this.$vimeoTrigger = $('#VimeoTrigger-' + this.sectionId);
    var mp4Video = 'Mp4Video-' + this.sectionId;

    var $youtubeDiv = $('#' + youtubePlayerId);
    var $vimeoDiv = $('#' + vimeoPlayerId);
    var $mp4Div = $('#' + mp4Video);

    this.vimeoPlayer = [];

    if ($youtubeDiv.length) {
      this.youtubeVideoId = $youtubeDiv.data('video-id');
      this.initYoutubeVideo();
    }

    if ($vimeoDiv.length) {
      this.vimeoVideoId = $vimeoDiv.data('video-id');
      this.initVimeoVideo();
    }

    if ($mp4Div.length) {
      setParentAsLoaded($mp4Div);

      startMp4Playback(mp4Video).then(function() {
        // Video played as expected, don't do anything
      }).catch(function(error) {
        // Video cannot be played with autoplay, so let
        // user interact with video element itself
        setVideoToBeInteractedWith($mp4Div);
      })
    }
  }

  function startMp4Playback(mp4Video) {
    return document.querySelector('#' + mp4Video).play();
  }

  function onVideoPlayerReady(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    youtubePlayers[playerId] = evt.target; // update stored player
    var player = youtubePlayers[playerId];

    setParentAsLoading($player);

    youtubePlayers[playerId].mute();

    // Remove from tabindex because YouTube iframes are annoying and you can focus
    // on the YouTube logo and it breaks
    $player.attr('tabindex', '-1');

    // Add out of view pausing
    videoVisibilityCheck(playerId);
    $(window).on('scroll.' + playerId, {id: playerId}, $.throttle(150, videoVisibilityCheck));
  }

  function videoVisibilityCheck(id) {
    var playerId;

    if (typeof id === 'string') {
      playerId = id;
    } else {
      // Data comes in as part of the scroll event
      playerId = id.data.id;
    }

    if (theme.isElementVisible($('#' + playerId))) {
      playVisibleVideo(playerId);
    } else {
      pauseHiddenVideo(playerId);
    }
  }

  function playVisibleVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].playVideo === 'function') {
      youtubePlayers[id].playVideo();
    }
  }

  function pauseHiddenVideo(id) {
    if (youtubePlayers[id] && typeof youtubePlayers[id].pauseVideo === 'function') {
      youtubePlayers[id].pauseVideo();
    }
  }

  function onVideoStateChange(evt) {
    var $player = $(evt.target.a);
    var playerId = $player.attr('id');
    var player = youtubePlayers[playerId];

    switch (evt.data) {
      case -1: // unstarted
        // Handle low power state on iOS by checking if
        // video is reset to unplayed after attempting to buffer
        if (videos[playerId].attemptedToPlay) {
          setParentAsLoaded($player);
          setVideoToBeInteractedWith($player);
        }
        break;
      case 0: // ended
        player.playVideo();
        break;
      case 1: // playing
        setParentAsLoaded($player);
        break;
      case 3: // buffering
        videos[playerId].attemptedToPlay = true;
        break;
    }
  }

  function setParentAsLoading($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.loading);
  }

  function setParentAsLoaded($el) {
    $el
      .closest(selectors.videoParent)
      .removeClass(classes.loading)
      .addClass(classes.loaded);
  }

  function setVideoToBeInteractedWith($el) {
    $el
      .closest(selectors.videoParent)
      .addClass(classes.interactable);
  }

  videoSection.prototype = $.extend({}, videoSection.prototype, {
    initYoutubeVideo: function() {
      videos[this.youtubePlayerId] = {
        id: this.youtubePlayerId,
        videoId: this.youtubeVideoId,
        type: 'youtube',
        attemptedToPlay: false
      };

      if (!youtubeReady) {
        window.loadYouTube();
        $('body').on('youTubeReady' + this.namespace, this.loadYoutubeVideo.bind(this));
      } else {
        this.loadYoutubeVideo();
      }
    },

    loadYoutubeVideo: function() {
      var args = $.extend({}, youtubeVideoOptions, videos[this.youtubePlayerId]);
      args.playerVars.controls = 0;
      youtubePlayers[this.youtubePlayerId] = new YT.Player(this.youtubePlayerId, args);

      youtubeReady = true;
    },

    initVimeoVideo: function() {
      videos[this.vimeoPlayerId] = {
        divId: this.vimeoPlayerId,
        id: this.vimeoVideoId,
        type: 'vimeo'
      };

      var $player = $('#' + this.vimeoPlayerId);
      setParentAsLoading($player);

      // Button to play video on mobile
      this.$vimeoTrigger.on('click', + this.namespace, function(evt) {
        // $(evt.currentTarget).addClass('hide');
        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
      }.bind(this));

      if (!vimeoReady) {
        window.loadVimeo();
        $('body').on('vimeoReady' + this.namespace, this.loadVimeoVideo.bind(this));
      } else {
        this.loadVimeoVideo();
      }
    },

    loadVimeoVideo: function() {
      var args = $.extend({}, vimeoVideoOptions, videos[this.vimeoPlayerId]);
      this.vimeoPlayer[this.vimeoPlayerId] = new Vimeo.Player(videos[this.vimeoPlayerId].divId, args);

      vimeoReady = true;

      // Only autoplay on larger screens
      if (!theme.config.bpSmall) {
        this.requestToPlayVimeoVideo(this.vimeoPlayerId);
      } else {
        var $player = $('#' + this.vimeoPlayerId);
        setParentAsLoaded($player);
      }
    },

    requestToPlayVimeoVideo: function(id) {
      // The slider may initialize and attempt to play the video before
      // the API is even ready, because it sucks.

      if (!vimeoReady) {
        // Wait for the trigger, then play it
        $('body').on('vimeoReady' + this.namespace, function() {
          this.playVimeoVideo(id);
        }.bind(this))
        return;
      }

      this.playVimeoVideo(id);
    },

    playVimeoVideo: function(id) {
      this.vimeoPlayer[id].play();
      this.vimeoPlayer[id].setVolume(0);

      var $player = $('#' + id);
      setParentAsLoaded($player);
    },

    onUnload: function(evt) {
      var sectionId = evt.target.id.replace('shopify-section-', '');
      var playerId = 'YouTubeVideo-' + sectionId;
      youtubePlayers[playerId].destroy();
      $(window).off('scroll' + this.namespace);
      $('body').off('vimeoReady' + this.namespace);
    }
  });

  return videoSection;
})();

theme.Testimonials = (function() {
  var slideCount = 0;
  var defaults = {
    accessibility: true,
    arrows: false,
    dots: true,
    autoplay: false,
    touchThreshold: 20,
    slidesToShow: 3,
    slidesToScroll: 3
  };

  function Testimonials(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var wrapper = this.wrapper = '.testimonials-wrapper';
    var slider = this.slider = '#Testimonials-' + sectionId;
    var $slider = $(slider);

    this.sliderActive = false;
    var mobileOptions = $.extend({}, defaults, {
      slidesToShow: 1,
      slidesToScroll: 1,
      adaptiveHeight: true
    });

    slideCount = $slider.data('count');

    // Override slidesToShow/Scroll if there are not enough blocks
    if (slideCount < defaults.slidesToShow) {
      defaults.slidesToShow = slideCount;
      defaults.slidesToScroll = slideCount;
    }

    $slider.on('init', this.a11y.bind(this));

    if (theme.config.bpSmall) {
      this.init($slider, mobileOptions);
    } else {
      this.init($slider, defaults);
    }

    $('body').on('matchSmall', function() {
      this.init($slider, mobileOptions);
    }.bind(this));

    $('body').on('matchLarge', function() {
      this.init($slider, defaults);
    }.bind(this));
  }

  Testimonials.prototype = $.extend({}, Testimonials.prototype, {
    onUnload: function() {
      $(this.slider, this.wrapper).slick('unslick');
    },

    onBlockSelect: function(evt) {
      // Ignore the cloned version
      var $slide = $('.testimonials-slide--' + evt.detail.blockId + ':not(.slick-cloned)');
      var slideIndex = $slide.data('slick-index');

      // Go to selected slide, pause autoplay
      $(this.slider, this.wrapper).slick('slickGoTo', slideIndex);
    },

    init: function(obj, args) {
      if (this.sliderActive) {
        obj.slick('unslick');
        this.sliderActive = false;
      }

      obj.slick(args);
      this.sliderActive = true;

      if (AOS) {
        AOS.refresh();
      }
    },

    a11y: function(event, obj) {
      var $list = obj.$list;
      var $wrapper = $(this.wrapper, this.$container);

      // Remove default Slick aria-live attr until slider is focused
      $list.removeAttr('aria-live');

      // When an element in the slider is focused set aria-live
      $wrapper.on('focusin', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.attr('aria-live', 'polite');
        }
      });

      // Remove aria-live
      $wrapper.on('focusout', function(evt) {
        if ($wrapper.has(evt.target).length) {
          $list.removeAttr('aria-live');
        }
      });
    }
  });

  return Testimonials;
})();

theme.Instagram = (function() {
  var defaults = {

  };

  function Instagram(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var $target = $('#Instafeed-' + sectionId);

    if (!$target.length) {
      return;
    }

    var userId = $target.data('user-id');
    var clientId = $target.data('client-id');
    var count = $target.data('count');

    var feed = this.feed = new Instafeed({
      target: $target[0],
      accessToken: clientId,
      get: 'user',
      userId: userId,
      limit: count,
      template: '<div class="grid__item small--one-half medium-up--one-fifth" data-aos="row-of-5"><div class="image-wrap"><a href="{{link}}" target="_blank" style="background-image: url({{image}}); display: block; padding-bottom: 100%; background-size: cover; background-position: center;"></a></div></div>',
      resolution: 'standard_resolution'
    });

    feed.run();
  }

  Instagram.prototype = $.extend({}, Instagram.prototype, {
    onUnload: function() {

    }
  });

  return Instagram;
})();


theme.NewsletterPopup = (function() {
  function NewsletterPopup(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.cookieName = 'newsletter-' + sectionId;

    if (!$container.length) {
      return;
    }

    this.data = {
      secondsBeforeShow: $container.data('delay-seconds'),
      daysBeforeReappear: $container.data('delay-days'),
      cookie: $.cookie(this.cookieName),
      testMode: $container.data('test-mode')
    };

    this.modal = new theme.Modals('NewsletterPopup-' + sectionId, 'newsletter-popup-modal');

    // Open modal if errors or success message exist
    if ($container.find('.errors').length || $container.find('.note--success').length) {
      this.modal.open();
    }

    // Set cookie as opened if success message
    if ($container.find('.note--success').length) {
      this.closePopup();
      return;
    }

    $('body').on('modalClose.' + $container.attr('id'), this.closePopup.bind(this));
    $('body').on('closeNewsletterPopup', this.closePopup.bind(this));

    if (!this.data.cookie || this.data.testMode) {
      this.initPopupDelay();
    }
  }

  NewsletterPopup.prototype = $.extend({}, NewsletterPopup.prototype, {
    initPopupDelay: function() {
      setTimeout(function() {
        this.modal.open();
      }.bind(this), this.data.secondsBeforeShow * 1000);
    },

    closePopup: function() {
      // Remove a cookie in case it was set in test mode
      if (this.data.testMode) {
        $.removeCookie(this.cookieName, { path: '/' });
        return;
      }

      $.cookie(this.cookieName, 'opened', { path: '/', expires: this.data.daysBeforeReappear });
    },

    onLoad: function() {
      this.modal.open();
    },

    onSelect: function() {
      this.modal.open();
    },

    onDeselect: function() {
      this.modal.close();
    },

    onUnload: function() {}
  });

  return NewsletterPopup;
})();

theme.FadingImages = (function() {

  var classes = {
    activeImage: 'active-image',
    finishedImage: 'finished-image',
    activeTitles: 'active-titles',
    finishedTitles: 'finished-titles',
    compensation: 'compensation'
  };

  function FadingImages(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    var namespace = this.namespace = '.fading-images-' + sectionId;

    if (!$container.length) {
      return;
    }

    var $imageContainer = $container.find('.fading-images');
    theme.loadImageSection($imageContainer);

    this.data = {
      isInit: false,
      interval: $container.data('interval'),
      block_count: $container.data('count'),
      finish_interval: 1000,
      timer_offset: 400,
      active_image: 1,
      active_title: 1,
      removed_compensation: false
    };

    this.selectors = {
      $allTitles: $container.find('.fading-images-overlay__titles')
    };

    this.checkVisibility();
    $(window).on('scroll' + this.namespace, $.throttle(100, this.checkVisibility.bind(this)));
  }

  FadingImages.prototype = $.extend({}, FadingImages.prototype, {
    checkVisibility: function() {
      if (this.data.isInit) {
        $(window).off('scroll' + this.namespace);
        return;
      }

      if (theme.isElementVisible(this.$container)) {
        this.startImages();
        this.startTitles();
        this.data.isInit = true;
      }
    },

    nextImage: function() {
      var $container = this.$container;

      if (!this.data.removed_compensation) {
        $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').removeClass(classes.compensation);
        this.data.removed_compensation = true;
      }

      $container
        .find('.fading-images__item[data-slide-index=' + this.data.active_image + ']')
        .removeClass(classes.activeImage)
        .addClass(classes.finishedImage);

      var target_image = this.data.active_image;
      window.setTimeout(function() {
        $container.find('.fading-images__item[data-slide-index=' + target_image + ']').removeClass(classes.finishedImage);
      }, this.data.finish_interval);

      this.data.active_image++;
      if (this.data.active_image > this.data.block_count) {
        this.data.active_image = 1;
      }

      $container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage);
    },

    nextTitle: function() {
      var $container = this.$container;
      var $allTitles = this.selectors.$allTitles;

      this.selectors.$allTitles.removeClass(classes.activeTitles).addClass(classes.finishedTitles);

      this.data.active_title++;
      if (this.data.active_title > this.data.block_count) {
        this.data.active_title = 1;
      }

      var target_title = this.data.active_title;
      window.setTimeout(function() {
        var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
        var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
        $container.find('.fading-images-overlay__title--1').text(newText1);
        $container.find('.fading-images-overlay__title--2').text(newText2);
        $allTitles.removeClass(classes.finishedTitles).addClass(classes.activeTitles);
      }, this.data.finish_interval - 200);
    },

    startImages: function() {
      // Prep and show first image
      this.$container.find('.fading-images__item[data-slide-index=' + this.data.active_image + ']').addClass(classes.activeImage).addClass(classes.compensation);

      // Begin timer
      var o = this;
      window.setTimeout(function() {
        var fading_images_timer = window.setInterval(o.nextImage.bind(o), o.data.interval);
      }, this.data.timer_offset);
    },

    startTitles: function() {
      var $container = this.$container;
      var $allTitles = this.selectors.$allTitles;
      // Prep and show first titles
      var target_title = this.data.active_title;
      window.setTimeout(function() {
        var newText1 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title1');
        var newText2 = $container.find('.fading-images__item[data-slide-index=' + target_title + ']').attr('data-slide-title2');
        $container.find('.fading-images-overlay__title--1').text(newText1);
        $container.find('.fading-images-overlay__title--2').text(newText2);
        $allTitles.addClass(classes.activeTitles);
      }, 750);

      // Begin timer
      var fading_titles_timer = window.setInterval(this.nextTitle.bind(this), this.data.interval);
    },

    onLoad: function() {
    },

    onSelect: function() {
    },

    onDeselect: function() {
    },

    onUnload: function() {
    }
  });

  return FadingImages;
})();

theme.Maps = (function() {
  var config = {
    zoom: 14
  };
  var apiStatus = null;
  var mapsToLoad = [];

  var errors = {
    addressNoResults: theme.strings.addressNoResults,
    addressQueryLimit: theme.strings.addressQueryLimit,
    addressError: theme.strings.addressError,
    authError: theme.strings.authError
  };

  var selectors = {
    section: '[data-section-type="map"]',
    map: '[data-map]',
    mapOverlay: '[data-map-overlay]'
  };

  var classes = {
    mapError: 'map-section--load-error',
    errorMsg: 'map-section__error errors text-center'
  };

  // Global function called by Google on auth errors.
  // Show an auto error message on all map instances.
  window.gm_authFailure = function() {
    if (!Shopify.designMode) {
      return;
    }

    $(selectors.section).addClass(classes.mapError);
    $(selectors.map).remove();
    $(selectors.mapOverlay).after(
      '<div class="' +
        classes.errorMsg +
        '">' +
        theme.strings.authError +
        '</div>'
    );
  };

  function Map(container) {
    this.$container = $(container);
    this.sectionId = this.$container.attr('data-section-id');
    this.namespace = '.map-' + this.sectionId;
    this.$map = this.$container.find(selectors.map);
    this.key = this.$map.data('api-key');

    if (!this.key) {
      return;
    }

    // Lazyload API
    this.checkVisibility();
    $(window).on('scroll' + this.namespace, $.throttle(50, this.checkVisibility.bind(this)));
  }

  function initAllMaps() {
    // API has loaded, load all Map instances in queue
    $.each(mapsToLoad, function(index, instance) {
      instance.createMap();
    });
  }

  function geolocate($map) {
    var deferred = $.Deferred();
    var geocoder = new google.maps.Geocoder();
    var address = $map.data('address-setting');

    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        deferred.reject(status);
      }

      deferred.resolve(results);
    });

    return deferred;
  }

  Map.prototype = $.extend({}, Map.prototype, {
    prepMapApi: function() {
      if (apiStatus === 'loaded') {
        this.createMap();
      } else {
        mapsToLoad.push(this);

        if (apiStatus !== 'loading') {
          apiStatus = 'loading';
          if (typeof window.google === 'undefined') {
            $.getScript(
              'https://maps.googleapis.com/maps/api/js?key=' + this.key
            ).then(function() {
              apiStatus = 'loaded';
              initAllMaps();
            });
          }
        }
      }
    },

    createMap: function() {
      var $map = this.$map;

      return geolocate($map)
        .then(
          function(results) {
            var mapOptions = {
              zoom: config.zoom,
              backgroundColor: 'none',
              center: results[0].geometry.location,
              draggable: false,
              clickableIcons: false,
              scrollwheel: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            };

            var map = (this.map = new google.maps.Map($map[0], mapOptions));
            var center = (this.center = map.getCenter());

            var marker = new google.maps.Marker({
              map: map,
              position: map.getCenter()
            });

            google.maps.event.addDomListener(
              window,
              'resize',
              $.debounce(250, function() {
                google.maps.event.trigger(map, 'resize');
                map.setCenter(center);
                $map.removeAttr('style');
              })
            );
          }.bind(this)
        )
        .fail(function() {
          var errorMessage;

          switch (status) {
            case 'ZERO_RESULTS':
              errorMessage = errors.addressNoResults;
              break;
            case 'OVER_QUERY_LIMIT':
              errorMessage = errors.addressQueryLimit;
              break;
            case 'REQUEST_DENIED':
              errorMessage = errors.authError;
              break;
            default:
              errorMessage = errors.addressError;
              break;
          }

          // Show errors only to merchant in the editor.
          if (Shopify.designMode) {
            $map
              .parent()
              .addClass(classes.mapError)
              .html(
                '<div class="' +
                  classes.errorMsg +
                  '">' +
                  errorMessage +
                  '</div>'
              );
          }
        });
    },

    checkVisibility: function() {
      if (theme.isElementVisible(this.$container, 600)) {
        this.prepMapApi();
        $(window).off(this.namespace);
      }
    },

    onUnload: function() {
      if (this.$map.length === 0) {
        return;
      }
      // Causes a harmless JS error when a section without an active map is reloaded
      google.maps.event.clearListeners(this.map, 'resize');
    }
  });

  return Map;
})();

theme.Blog = (function() {

  function Blog(container) {
    this.tagFilters();
  }

  Blog.prototype = $.extend({}, Blog.prototype, {
    tagFilters: function() {
      var $filterBy = $('#BlogTagFilter');

      if (!$filterBy.length) {
        return;
      }

      $filterBy.on('change', function() {
        location.href = $(this).val();
      });
    },

    onUnload: function() {

    }
  });

  return Blog;
})();

theme.Photoswipe = (function() {
  var selectors = {
    photoswipeImg: '.photoswipe__image'
  }

  function Photoswipe(container) {
    var $container = this.$container = $(container);
    var sectionId = $container.attr('data-section-id');
    this.namespace = '.photoswipe-' + this.sectionId;
    var $images = this.$images = $container.find(selectors.photoswipeImg);
    this.gallery;

    if (!$container.length) {
      return;
    }

    this.init();
  }

  Photoswipe.prototype = $.extend({}, Photoswipe.prototype, {
    init: function() {
      var haveImages = false;
      var items = [];
      var options = {};

      this.$images.each(function() {
        var haveImages = true;
        var smallSrc = $(this).prop('currentSrc') || $(this).prop('src');
        var item = {
          msrc: smallSrc,
          src: $(this).data('photoswipe-src'),
          w: $(this).data('photoswipe-width'),
          h: $(this).data('photoswipe-height'),
          el: $(this)[0]
        };

        items.push(item);
      });

      this.$images.on('click' + this.namespace, function(evt) {
        index = $(evt.currentTarget).data('index');
        this.initGallery(items, index);
      }.bind(this));
    },

    initGallery: function(items, index) {
      var pswpElement = document.querySelectorAll('.pswp')[0];

      var options = {
        history: false,
        index: index - 1,
        getThumbBoundsFn: function(index) {
          var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
          var thumbnail = items[index].el;
          var rect = thumbnail.getBoundingClientRect();
          return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
        }
      }

      this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      this.gallery.init();
    },

    onUnload: function() {
      this.$images.off('click' + this.namespace);
      this.gallery.destroy()
    }
  });

  return Photoswipe;
})();



theme.config = {
  bpSmall: false,
  hasSessionStorage: true,
  mediaQuerySmall: 'screen and (max-width: 589px)',
  mediaQueryMediumUp: 'screen and (min-width: 590px)',
  youTubeReady: false,
  vimeoReady: false,
  vimeoLoading: false,
  isTouch: ('ontouchstart' in window) || window.DocumentTouch && window.document instanceof DocumentTouch || window.navigator.maxTouchPoints || window.navigator.msMaxTouchPoints ? true : false
};

function onYouTubeIframeAPIReady() {
  theme.config.youTubeReady = true;
  $('body').trigger('youTubeReady');
}

function loadYouTube() {
  if (theme.config.youtubeReady) {
    return;
  }

  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function loadVimeo() {
  if (theme.config.vimeoLoading) {
    return;
  }

  if (!theme.config.vimeoReady) {
    theme.config.vimeoLoading = true;
    var tag = document.createElement('script');
    tag.src = "https://player.vimeo.com/api/player.js";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // Because there's no way to check for the Vimeo API being loaded
    // asynchronously, we use this terrible timeout to wait for it being ready
    checkIfVimeoIsReady()
      .then(function() {
        theme.config.vimeoReady = true;
        theme.config.vimeoLoading = false;
        $('body').trigger('vimeoReady');
      })
      .fail(function() {
        // No vimeo API to talk to
      });
  }
}

function checkIfVimeoIsReady() {
  var deferred = $.Deferred();
  var wait;
  var timeout;

  wait = setInterval(function() {
    if (!Vimeo) {
      return;
    }

    clearInterval(wait);
    clearTimeout(timeout);
    deferred.resolve();
  }, 500);

  timeout = setTimeout(function() {
    clearInterval(wait);
    deferred.reject();
  }, 4000); // subjective. test up to 8 times over 4 seconds

  return deferred;
}

theme.init = function() {
  theme.setGlobals();
  theme.pageTransitions();
  theme.initQuickShop();
  theme.initSearchModal();
  theme.initSortModal();
  theme.initSupportMenuModal();
  // theme.videoModal();
  theme.articleImages.init();
  theme.backButton.init();
  theme.customerTemplates.init();
  theme.collapsibles.init();
  theme.toggleNav.init();

  slate.rte.wrapTable();
  slate.rte.wrapVideo();

  AOS.init({
    easing: 'ease-out-quad',
    once: true,
    offset: 60,
    disableMutationObserver: true
  });
};

theme.location = {
  init: async function () {
    let ipInfo = localStorage.getItem('ip_info');
    if (!ipInfo) {
      ipInfo = await this.get();
      theme.base.ipInfo = ipInfo;
      localStorage.setItem('ip_info', JSON.stringify(ipInfo));
    } else {
      theme.base.ipInfo = JSON.parse(ipInfo);
    }

    $('body').trigger('ipInfoReady');
  },

  get: function () {
    return new Promise(resolve => {
      let location = null;
      try {
        let token = theme.settings.ipInfoToken;
        let url = "https://ipinfo.io/json";
        if (token !== '')
          url = url + "?token=" + token;
        $.get(url, function (response) {
          console.log("ipinfo::", response);
          resolve(response);
        }, "jsonp");
      } catch (e) {
        resolve(location);
      }
    });
  }
}

theme.setGlobals = function() {
  theme.config.hasSessionStorage = theme.isSessionStorageSupported();

  if (theme.config.isTouch) {
    $('body').addClass('supports-touch');
  }

  enquire.register(theme.config.mediaQuerySmall, {
    match: function() {
      theme.config.bpSmall = true;
      $('body').trigger('matchSmall');
    },
    unmatch: function() {
      theme.config.bpSmall = false;
      $('body').trigger('unmatchSmall');
    }
  });

  enquire.register(theme.config.mediaQueryMediumUp, {
    match: function() {
      $('body').trigger('matchLarge');
    },
    unmatch: function() {
      $('body').trigger('unmatchLarge');
    }
  });
};

theme.loadImageSection = function($container) {
  // Wait until images inside container have lazyloaded class
  function setAsLoaded() {
    $container.removeClass('loading loading--delayed').addClass('loaded');
  }

  function checkForLazyloadedImage() {
    return $container.find('.lazyloaded').length;
  }

  // If it has SVGs it's in the onboarding state so set as loaded
  if ($container.find('svg').length) {
    setAsLoaded();
    return;
  };

  if (checkForLazyloadedImage() > 0) {
    setAsLoaded();
    return;
  }

  var interval = setInterval(function() {
    if (checkForLazyloadedImage() > 0) {
      clearInterval(interval);
      setAsLoaded();
    }
  }, 80);
}

theme.isSessionStorageSupported = function() {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  var testKey = 'test';
  var storage = window.sessionStorage;
  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    return false;
  }
};

theme.isElementVisible = function($el, threshold) {
  var rect = $el[0].getBoundingClientRect();
  var windowHeight = window.innerHeight || document.documentElement.clientHeight;
  threshold = threshold ? threshold : 0;

  return (
    rect.bottom >= 0 &&
    rect.right >= 0 &&
    rect.top <= (windowHeight + threshold) &&
    rect.left <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

theme.pageTransitions = function() {
  if ($('body').data('transitions') == true) {

    // Hack test to fix Safari page cache issue.
    // window.onpageshow doesn't always run when navigating
    // back to the page, so the unloading class remains, leaving
    // a white page. Setting a timeout to remove that class when leaving
    // the page actually finishes running when they come back.

    //navigator.userAgent.indexOf("Darwin") Used to test if iOS app
    if (!!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/) || navigator.userAgent.indexOf("Darwin")) {
      $('a').on('click', function() {
        window.setTimeout(function() {
          $('body').removeClass('unloading');
        }, 1200);
      });
    }

    // Add disable transition class to malito, anchor, and YouTube links
    $('a[href^="mailto:"], a[href^="#"], a[target="_blank"], a[href*="youtube.com/watch"], a[href*="youtu.be/"]').each(function() {
      $(this).addClass('js-no-transition');
    });

    $('a:not(.js-no-transition)').bind('click', function(evt) {
      if (evt.metaKey) return true;
      evt.preventDefault();
      $('body').addClass('unloading');
      var src = $(this).attr('href');
      window.setTimeout(function() {
        location.href = src;
      }, 50);
    });

    $('a.mobile-nav__link').bind('click', function() {
      theme.NavDrawer.close();
      theme.FilterDrawer.close();
    });
  }
};

window.onpageshow = function(evt) {
  // Removes unload class when returning to page via history
  if (evt.persisted) {
    $('body').removeClass('unloading');
  }
};

$(document).ready(function() {
  theme.init();

  window.sections = new theme.Sections();
  sections.register('slideshow-section', theme.SlideshowSection);
  sections.register('featured-content-section', theme.FeaturedContentSection);
  sections.register('testimonials', theme.Testimonials);
  sections.register('instagram', theme.Instagram);
  sections.register('newsletter-popup', theme.NewsletterPopup);
  sections.register('fading-images', theme.FadingImages);
  sections.register('map', theme.Maps);
  sections.register('blog', theme.Blog);
  sections.register('photoswipe', theme.Photoswipe);

  $('body').on('ipInfoReady', function() {
    sections.register('header-section', theme.HeaderSection);
    sections.register('product', theme.Product);
    sections.register('product-template', theme.Product);
    sections.register('collection-template', theme.Collection);
    sections.register('cart', theme.Cart);
    sections.register('product-grid-item', theme.ProductGridItem);
    sections.register('product-grid-item-v1', theme.ProductGridItemV1);
  });
  
  theme.location.init();

  new theme.CustomOrderForm($("#custom-order-mobile-form"));
  new theme.CustomOrderForm($("#custom-order-form"));
});

// app stuff starts around here
(function () {
  var userAgentTest = navigator.userAgent.toLowerCase();
  var standalone = window.navigator.standalone,
    userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test(userAgent),
    ios = /iphone|ipod|ipad/.test(userAgent);
  inAppBrowserAgents = /FBAN|FBAV|Instagram|fban|fbav|instagram/.test(
    userAgent
  );
  //facebookCheck2 = /FBAV/.test(userAgent);
  //instagramCheck = /Instagram /.test(userAgent);

  var isNativeWv = {};
  console.log("wtf " + userAgent);
  console.log(inAppBrowserAgents);
  if (
    navigator.userAgent.indexOf("wv") > -1 ||
    navigator.userAgent.indexOf("junipurr") > -1 &&
    !inAppBrowserAgents
  ) {
    isNativeWv.test = true;
  } else if (ios) {
    if (!standalone && !safari && !inAppBrowserAgents) {
      isNativeWv.test = true;
    }
  }
  
//   console.log("iOS test: " + ios);
//   console.log("is native: ");
//   console.log(isNativeWv.test);

  
  if (isNativeWv.test) {
  //identify home-banner-v2
  //remove background image
  //replace the content with something similar to below.
  const appHeroBannerOld =`<div class="container">
      <div class="row">
        <div class="col-md-12">
          <div class="jw-copy">
            <p class="cp-tagline d-lg-none">Junipurr Jewelry</p>
            <p class="cp-tagline d-none d-lg-block">Junipurr Jewelry</p>
            <h1 class="text-center">Making Gold<br>Accessible</h1>
          </div>
          <div class="jw-image d-lg-none">
            <img src="//cdn.shopify.com/s/files/1/0022/2776/5359/files/home-banner-new_large_1_large.png?v=1603303405" class="d-lg-none" alt="">
          </div>
          <div class="jw-action text-center">
            
             <a href="/collections/best-selling-body-jewelry" class="ja-gold ja-apply" title="Sign Up Now">SHOP BESTSELLERS</a>
            
          </div>
        </div>
      </div>
    </div>`;
  const appHeroBanner = `<div class="container">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="jw-copy">
                                    <p class="cp-tagline" style="background-image: linear-gradient(247deg, #ffd685, #a36f21); font-size: 14px; font-weight: bold; line-height: 24px; letter-spacing: 3px; text-align: center; -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; text-transform: uppercase; margin-bottom: 24px;">Junipurr Jewelry</p>
                                    <p class="text-white text-uppercase text-center" style="line-height: 2.2;z-index: 2;position: relative;font-size: 17px;">
                                        The first 100 clients to make a purchase on the app get a
                                        complimentary Junipurr Jewelry wand.
                                    </p>
                                    </div>
                                    <div class="jw-image w-100" style="margin-top: -44px;margin-left:0;margin-right:0;">
                                    <img src="https://cdn.shopify.com/s/files/1/0022/2776/5359/files/WandMobile2_1_2x_4ca7fe63-412a-4551-9152-6719354e0246.png?v=1601927632" class="w-100" alt="">
                                    </div>
                                    <div class="jw-action text-center" style="margin-top: -104px">
                                    <a href="/collections/best-selling-body-jewelry" class="ja-gold ja-apply" title="Sign Up Now">SHOP BESTSELLERS</a>
                                    </div>
                                </div>
                            </div>
                        </div>`;
  const appHeroBannerV2 = `<div class="container-fluid d-none d-xl-block">
                             <div class="row">
                               <div class="jw-image">
                                 <img src="//cdn.shopify.com/s/files/1/0022/2776/5359/files/junipurr_14k-yellow-gold_Queen-Naveen_decorative-end_JJ0258-YG_0_large.png?v=1608560026" class="image-item image-item-left d-none" alt="">
                                 <img src="//cdn.shopify.com/s/files/1/0022/2776/5359/files/junipurr_14k-yellow-gold_Queen-Naveen_decorative-end_JJ0258-YG_0_large.png?v=1608560026" class="image-item image-item-right" alt="">
                               </div>
                             </div>
                           </div>
                           <div class="container">
                             <div class="row">
                               <div class="col-md-12">
                                 <div class="jw-copy">
                                   <p class="cp-tagline d-lg-none">Junipurr Jewelry</p>
                                   <p class="cp-tagline d-none d-lg-block">Junipurr Jewelry</p>
                                   <h1>Making Gold<br>Accessible</h1>
                                 </div>
                                 <div class="jw-image d-lg-none">
                                   <img src="//cdn.shopify.com/s/files/1/0022/2776/5359/files/junipurr_14k-yellow-gold_Queen-Naveen_decorative-end_JJ0258-YG_0_large.png?v=1608560026" class="d-lg-none" alt="">
                                 </div>
                                 <div class="jw-action text-center">            
                                     <a href="/collections/best-selling-body-jewelry" class="ja-gold ja-apply" title="Shop Bestsellers">Shop Bestsellers</a>            
                                 </div>
                               </div>
                             </div>
                           </div>`;

    console.log("IS AUTHENTICATED?", ShopifyAnalytics.meta.page.customerId);
    //only change the home banner if the user is in a logged in state
    if(ShopifyAnalytics.meta.page.customerId !== undefined){
      $(".home-banner-v2, .home-banner-v3").css({
        "background-image": "none",
      });
      $(".home-banner-v2, .home-banner-v3").removeClass('has-account');
      $(".home-banner-v2, .home-banner-v3").html(appHeroBannerV2);
    }
  
  //-------------------------
  const noBackBtnPages = ["/pages/categories", "/account", "/cart"];
  const currentPage = window.location.pathname;
  const isHomePage = $("body").hasClass("template-index");
  let pageTest = true;

  function checkForPage(item, index) {
    let theCheck = currentPage.indexOf(item);
    const arrayLength = noBackBtnPages.length;
    if (theCheck > -1) {
      pageTest = false;
    }
    console.log(index);
    if (arrayLength === index + 1) {
      changeMenu(pageTest);
    }
  }
  function changeMenu(test) {
    if (test === true && !isHomePage) {
      $(".navbar-left .nav-hamburger")
        .prepend(
          '<div class="native-back-btn d-inline-block" style=" position: relative; right: 10px; width: 44px; height: 44px; text-align: center;"><svg style="vertical-align: middle;" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512"><title>ionicons-v5-a</title><polyline points="244 400 100 256 244 112" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"></polyline><line x1="120" y1="256" x2="412" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"></line></svg></div>'
        );
      $(".native-back-btn").on("click", function () {
        history.back();
        //console.log('clicked');
      });
    }
  }

  noBackBtnPages.forEach(checkForPage);
}




  $(document).ready(function () {
    
    $(".announcement__text").remove();

    $(".product-image-main").css("overflow", "hidden");
    if (Object.keys(isNativeWv).length === 0) {
      (function () {
        function onTidioChatApiReady() {
          $("#tidio-chat-iframe").addClass("d-none");
          // $("#tidio-chat-iframe").remove();
        }
        if (window.tidioChatApi) {
          window.tidioChatApi.on("ready", onTidioChatApiReady);
        } else {
          document.addEventListener("tidioChat-ready", onTidioChatApiReady);
        }
      })();
    }

    if (isNativeWv.test) {
//     if (true){
    $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0,user-scalable=0"/>');
      
    var accountURL;
    var loginText;
    if(isLoggedIn){
        accountURL = "";
        loginText = "Account";
    } else {
        accountURL = "/login";
        loginText = "Login";
    }
      
      $("a.pro-team-link").click(function (event) {
        event.preventDefault();
        //var href = $(this).attr("href");
        //window.open(href, "Site", "height=200,width=200");
      });

      $(".logout-webview").removeClass("d-none");
      var spinCss =
        "<style>@keyframes rotating {to {transform: rotate(360deg);}} .rotating { -webkit-animation: rotating 1s linear infinite; -moz-animation: rotating 1s linear infinite; -ms-animation: rotating 1s linear infinite; -o-animation: rotating 1s linear infinite; animation: rotating 1s linear infinite; }</style>";
      var filterSvg =
        '<svg xmlns="http://www.w3.org/2000/svg" width="23.894" height="24" viewBox="0 0 23.894 24"> <g id="Group_26" data-name="Group 26" transform="translate(-463 -70)"> <path id="Path_11" data-name="Path 11" d="M466.383,76.767a3.387,3.387,0,0,0,3.138-2.115h16.263a1.11,1.11,0,1,0,0-2.22H469.631a3.384,3.384,0,1,0-3.248,4.335Zm0-4.652a1.269,1.269,0,1,1-1.269,1.269A1.26,1.26,0,0,1,466.383,72.115Z" fill="#fff"/> <path id="Path_12" data-name="Path 12" d="M483.511,233a3.387,3.387,0,0,0-3.138,2.115H464.11a1.11,1.11,0,0,0,0,2.22h16.153A3.384,3.384,0,1,0,483.511,233Zm0,4.652a1.269,1.269,0,1,1,1.269-1.269A1.26,1.26,0,0,1,483.511,237.652Z" transform="translate(0 -145.767)" fill="#fff"/> <path id="Path_13" data-name="Path 13" d="M486.178,153.432h-7.483a3.385,3.385,0,0,0-6.5,0H464.55a1.11,1.11,0,1,0,0,2.22h7.758a3.386,3.386,0,0,0,6.276,0h7.593a1.11,1.11,0,1,0,0-2.22Zm-10.156,2.083a1.269,1.269,0,1,1,.264-2.083.351.351,0,0,1,.03.026,1.27,1.27,0,0,1-.294,2.056Z" transform="translate(-0.393 -72.436)" fill="#fff"/> </g> </svg>';
      var filterSvgClose =
        '<svg xmlns="http://www.w3.org/2000/svg" width="15.95" height="15.95" viewBox="0 0 15.95 15.95"> <path id="Icon_ionic-md-close" data-name="Icon ionic-md-close" d="M23.473,9.118,21.879,7.523,15.5,13.9l-6.38-6.38L7.523,9.118,13.9,15.5l-6.38,6.38,1.595,1.595,6.38-6.38,6.38,6.38,1.595-1.595-6.38-6.38Z" transform="translate(-7.523 -7.523)" fill="#fff"/> </svg> ';
      var filterCss =
        "<style>.filter-closed.wv-collection-filter{bottom:-40px;} .wv-collection-filter{bottom:50px;transition:bottom .5s;}.close-filter{ position: absolute; top: -65px; right: 20px; background: black; color: white; width: 55px; height: 55px; border-radius: 100%; font-size: 26px; font-weight: 100;box-shadow: 0 0 4px rgba(0,0,0,0.5);}</style>";
      var generalCss =
          "<style>.announcement, .announcement--opening{display: none !important;} .home-android-app {display: none;} .native-back-btn:hover {background:#e5e5e5; transition:backgroud 0.3s;border-radius:5px} .native-back-btn  {position:relative;bottom:3px} .native-back-btn svg  {position:relative;top:3px} .native-footer-link:focus, .native-footer-link:active, .native-footer-link:hover { background:#e5e5e5; outline:none; transition:background 0.3s;} .main-content{ -webkit-overflow-scrolling: touch;overflow-y: scroll;} @media only screen and (min-width: 576px) {.main-content { overflow-y: auto; }} .play-store-announcement{display:none} .black-theme .native-back-btn polyline, .black-theme .native-back-btn line { stroke: white!important; } #shopify-section-collection-featured-collections { margin-bottom: 100px; } #SavedAddresses { margin-bottom: 55px; } .jw-header-section {position:-webkit-sticky;}.tidio-1i4qef3{display:none!important}.hide-on-webview-all{display:none!important;}.btn.btn--full.add-to-cart {background: black!important;color: white;}iframe#tidio-chat-iframe { position: relative; bottom: 55px!important; }.pro-team-individual .mobile-pro-team { padding-bottom: 84px; }.page-customers .accordion-section-title:not(.open) h2:after{font-size: 16px;transform: scale(.13);}.page-customers .accordion-section-title h2:after{border: none;}.page-customers .accordion-section-title h2:before { content: ''; margin-left: auto; width: 40px; height: 40px; border: 1px solid black; min-width: 40px; border-radius: 50%; position: absolute; right: 32px; }.page-custom-order { min-height: 90vh; }.jp-icon.jp-minus{font-size: 16px;transform: scale(0.13);display: block;} #NavDrawer .collapsible-trigger.is-open .jp-icon, #NavDrawer .nav-title.is-open .jp-icon {font-size: 16px;transform: scale(0.13);}.grecaptcha-badge { visibility: hidden; }.jw-cart-summary {margin-bottom: 50px;}#CartDrawer .jw-main-action {margin-bottom: 50px;}#NavDrawer .drawer__inner {margin-bottom: 50px;}.weglot-container{display:block !important;} .wg-default, .wg-default .country-selector{bottom: 56px !important;}</style>";
// add this for weglot when it works      
//      .weglot-container{
//    display: block !important;
//}

//aside.weglot_switcher.wg-drop.country-selector {
//    bottom: 50px !important;
//}
      
      //var searchNativeCss = '.native--search p, .native--search a { font-family: CircularStd, sans-serif; } .native--search .cp-label { font-size: 14px; font-weight: bold; line-height: 1.43; letter-spacing: 1.25px; text-transform: uppercase; margin-bottom: 26px; } .native--search .modal__inner { display: flex; flex-direction: column; position: absolute; top: 0; left: 0; bottom: 0; right: 0; margin: 0; } .native--search .modal__header { width: 100%; height: 120px; min-height: 120px; padding: 0 32px; border-bottom: 1px solid #ccc; display: flex; align-items: center; justify-content: center; } .native--search .modal__header h2 { font-family: GTSuperDisplay, sans-serif; font-size: 24px; font-weight: 900; text-align: center; margin: 0; } .native--search .modal__header .modal__close { font-size: 24px; top: 48px; right: 40px; line-height: 1; padding: 0; } @media (min-width: 768px) { .native--search .modal__header .modal__close { right: 40px; } } .native--search .modal__header .modal__close:focus { outline: none; } .native--search .modal__centered { width: 100%; height: 100%; overflow: auto; } @media (min-width: 768px) { .native--search .modal__centered { justify-content: center; } } .native--search .modal__centered-content { padding: 50px 32px; height: 100%; max-height: inherit; margin: 0 auto; } @media (min-width: 768px) { .native--search .modal__centered-content { padding: 60px 40px; height: auto; } } .native--search .search-bar { display: flex; position: relative; width: 760px; height: 56px; margin-right: 45px; max-width: 100%; } @media (min-width: 992px) { .native--search .search-bar { margin-right: 0; } } .native--search .search-bar .jp-search-small { position: absolute; top: 16px; font-size: 22px; } .native--search .search-bar input[type='search'] { font-family: CircularStd, sans-serif; font-size: 16px; letter-spacing: 0.25px; color: black; border: none; height: 56px; padding: 0 0 0 40px; border-bottom: 1px solid #ccc; } .native--search .search-bar input[type='search']:focus { outline: none; } .native--search .search-bar input[type='search']::placeholder { color: #666; } .native--search .search-bar button[type='submit'] { font-size: 14px; font-weight: bold; font-stretch: normal; line-height: 2.14; letter-spacing: 1.5px; text-transform: uppercase; width: 60px; height: 60px; margin-left: 20px; min-width: 60px; } @media (min-width: 768px) { .native--search .search-bar button[type='submit'] { margin-left: 40px; } } .native--search .search-suggestions { max-width: 760px; margin: 0 auto 50px; } .native--search .search-suggestions ul { list-style: none; margin: 0; padding: 0; width: max-content; } @media (min-width: 768px) { .native--search .search-suggestions ul { column-count: 2; } } .native--search .search-suggestions ul li { font-family: CircularStd, sans-serif; font-size: 16px; line-height: 1; letter-spacing: 0.25px; min-width: 160px; margin-right: 40px; margin-bottom: 16px; cursor: pointer; display: flex; align-items: center; } .native--search .search-suggestions ul li:last-child { margin-bottom: 0; } .native--search .search-suggestions ul li:before { font-family: "junipurr" !default; content: "\e917"; font-size: 24px; color: #a68d5b; margin-right: 16px; } .native--search .search-recent { max-width: 760px; margin-left: auto; margin-right: auto; } .native--search .search-recent ul { display: flex; list-style: none; margin: 0 -8px; } @media (min-width: 768px) { .native--search .search-recent ul { margin: 0 -12px; } } .native--search .search-recent ul li { width: 33.33333333%; padding: 0 8px; margin: 0; } @media (min-width: 768px) { .native--search .search-recent ul li { padding: 0 12px; } } .native--search .search-recent ul a { display: block; } .native--search .search-recent .copy-wrapper { padding-top: 15px; } .native--search .search-recent .prod-title { font-size: 14px; line-height: 1.43; letter-spacing: 0.25px; display: -webkit-box; -webkit-line-clamp: 4; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; margin: 0; text-align: center; } @media (min-width: 768px) { .native--search .search-recent .prod-title { font-size: 16px; } } .native--search .search-recent .prod-cta { font-size: 16px; font-weight: 600; line-height: 1.88; letter-spacing: 0.25px; border-bottom: 2px solid; display: inline-block; } .native--search .search-results { margin: 0; list-style: none; } .native--search .search-results li { margin-bottom: 0; } .native--search .search-results .result-item { padding: 15px 0 16px; border-bottom: 1px solid #ccc; } .native--search .search-results .result-item a { display: flex; align-items: center; position: relative; padding: 10px 15px 10px 96px; min-height: 72px; } .native--search .search-results .result-item a:after { content: "\e912"; font-family: "junipurr" !default; font-size: 20px; font-weight: normal; position: absolute; right: 0; top: 28px; display: none; } .native--search .search-results .result-item:first-child { border-top: 1px solid #ccc; } .native--search .search-results .result-more { padding-top: 24px; } .native--search .search-results .result-more a { display: flex; align-items: center; justify-content: center; width: 100%; height: 48px; background-color: black; font-size: 12px; font-weight: bold; line-height: 1.67; letter-spacing: 1.25px; color: #f2f2f2; text-transform: uppercase; } .native--search .search-results .thumbnail { position: absolute; width: 72px; height: 72px; top: 0; left: 0; margin: 0; padding: 0; border: none; border-radius: 0; } .native--search .search-results .thumbnail img { width: 100%; height: 100%; object-fit: cover; } .native--search .search-results .title { font-size: 16px; line-height: 1.5; letter-spacing: 0.25px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; text-overflow: ellipsis; } .native--search .search-results .price { font-size: 14px; font-weight: 600; line-height: 2.14; letter-spacing: 0.22px; color: #b39862; } .native--search .cw-search-results-outer { max-width: 760px; margin: 0 auto; } .native--search .cw-search-results-outer .cp-label { margin-bottom: 26px; }';
      //$("body").append(searchNativeCss);
      $("body").append(generalCss);
      $("body").append(filterCss);
     
      var closeFilter =
        '<div class="close-filter d-flex align-items-center justify-content-center">' +
        filterSvg +
        "</div>";
      var filterClass = $(".collection-filter");
      if (filterClass) {
        filterClass
          .addClass("wv-collection-filter filter-closed")
          .append(closeFilter);
        $(".filter__footer").after("<div style='height:50px;width:20px;'></div>");

        $(".close-filter").on("click", function () {
          var checkClass = filterClass.hasClass("filter-closed");
          if (checkClass) {
            filterClass.removeClass("filter-closed");
            $(this).html(filterSvgClose);
            $("#tidio-chat-iframe").fadeOut();
          } else {
            filterClass.addClass("filter-closed");
            $(this).html(filterSvg);
            $("#tidio-chat-iframe").fadeIn();
          }
        });
      }
      var notifCss =
        "<style>.notif{width: 170px; height: 170px; background: #0eaf13; border-radius: 100%; top: -2px; right: -12px; border: 3px solid white; box-shadow: 0 0 9px rgba(0,0,0, 0.25);font-size: 11px;color: white;line-height: 12px;text-align: center;}</style>";
      var tidioHide =
        "<style>#tidio-chat-iframe{display:none!important;}</style>";
      var nativeMenuCss =
        "<style>" +
        ".jj-native-footer {" +
        "width: 100%;" +
        "height: 50px;" +
        "background: white;" +
        "box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);" +
        "position: fixed;" +
        "bottom: 0;" +
        "}" +
        ".native-menu-title {" +
        "  font-size: 9pt;" +
        "  line-height: 6pt;" +
        "}" +
        "</style>";
      var chatIcon =
        "<svg xmlns='http://www.w3.org/2000/svg' width='23.496' height='23.5' viewBox='0 0 23.496 23.5'><g id='Icon_ionic-ios-chatboxes' data-name='Icon ionic-ios-chatboxes' transform='translate(-3.375 -3.375)'><path id='Path_1' data-name='Path 1' d='M26.358,11.981H13.838a2.156,2.156,0,0,0-2.152,2.152v8.717A2.151,2.151,0,0,0,13.838,25H21a.617.617,0,0,1,.429.181l3.559,3.282c.2.192.525.113.525-.164V25.438c0-.339.215-.446.554-.446h.056A2.351,2.351,0,0,0,28.5,22.845V14.134A2.143,2.143,0,0,0,26.358,11.981Z' transform='translate(-1.633 -1.691)'/><path id='Path_2' data-name='Path 2' d='M10.516,8.906H20.538V5.217A1.842,1.842,0,0,0,18.7,3.375H5.217A1.842,1.842,0,0,0,3.375,5.217V14.55a1.842,1.842,0,0,0,1.842,1.842H8.669V10.748A1.851,1.851,0,0,1,10.516,8.906Z'/></g></svg>";
      var nativeMenuHtml = `<div id='jj-native-footer' class='jj-native-footer d-flex justify-content-between align-items-center px-3'>
        <a href='/' class='text-center native-footer-link h-100 d-flex flex-column align-items-center justify-content-center' style='width: 50px;'><svg xmlns='http://www.w3.org/2000/svg' width='21.5' height='21.493' viewBox='0 0 21.5 21.493'><g id='Icon_ionic-ios-home' data-name='Icon ionic-ios-home' transform='translate(-3.374 -3.375)'><path id='Path_9' data-name='Path 9' d='M15.146,7.3a.2.2,0,0,0-.258,0l-8.06,6.448a.217.217,0,0,0-.077.16V25.794a.1.1,0,0,0,.1.1h5.58a.1.1,0,0,0,.1-.1V18.561a.1.1,0,0,1,.1-.1h4.753a.1.1,0,0,1,.1.1v7.233a.1.1,0,0,0,.1.1h5.58a.1.1,0,0,0,.1-.1V13.911a.209.209,0,0,0-.077-.16Z' transform='translate(-0.895 -1.029)'/><path id='Path_10' data-name='Path 10' d='M24.594,11.445,14.829,3.623a1.134,1.134,0,0,0-1.416,0L9.161,7.079V4.9a.1.1,0,0,0-.1-.1h-3.1a.1.1,0,0,0-.1.1V9.663L3.648,11.476a.723.723,0,0,0-.062,1.08.719.719,0,0,0,.511.212.728.728,0,0,0,.455-.16l9.5-7.647a.093.093,0,0,1,.067-.021.125.125,0,0,1,.067.021l9.5,7.616a.728.728,0,0,0,.455.16.733.733,0,0,0,.728-.765A.734.734,0,0,0,24.594,11.445Z' transform='translate(0)'/></g></svg><div class='native-menu-title mt-2'>Home</div></a>
        <a href='/pages/categories' class='text-center native-footer-link h-100 d-flex flex-column align-items-center justify-content-center' style='width: 50px;'><svg xmlns='http://www.w3.org/2000/svg' width='27.278' height='24.807' viewBox='0 0 27.278 24.807'><path id='Path_22' data-name='Path 22' d='M109.156,125.409l-.006-.209c0-.075,0-.149-.006-.224-.011-.227-.028-.456-.052-.7-.044-.437-.108-.876-.192-1.305a13.9,13.9,0,0,0-3.814-7.182c-.138-.139-.281-.275-.425-.407l0,0-.026-.023-.616-.564.02.043-.01-.009.345.726.032.067,0,.009a10.238,10.238,0,0,1,1.053,4.328,9.941,9.941,0,1,1-19.877,0,10.288,10.288,0,0,1,1.089-4.4l.31-.653-.013.011.054-.114-.614.563a13.956,13.956,0,0,0-4.458,8.931c-.022.224-.039.454-.051.682,0,.073,0,.147-.006.221l-.006.212c0,.093-.006.186-.006.281a13.968,13.968,0,0,0,8.951,13.069,13.427,13.427,0,0,0,10-.249c.2-.087.406-.181.6-.279.4-.194.785-.411,1.159-.643a13.739,13.739,0,0,0,1.6-1.163c.335-.282.661-.584.968-.9s.6-.647.88-.988.541-.7.785-1.071a14.037,14.037,0,0,0,.984-1.747c.1-.2.187-.408.273-.616.173-.417.327-.847.459-1.278s.247-.885.337-1.333a14.319,14.319,0,0,0,.279-2.8C109.162,125.6,109.159,125.5,109.156,125.409Zm-24.314-5.053c0,.035,0,.07-.006.1q-.006.167-.006.334a10.694,10.694,0,1,0,21.384,0q0-.166-.006-.333c0-.043,0-.087-.007-.13,0-.068-.006-.136-.011-.2v-.005c.011.075.02.151.03.227.006.047.013.094.018.141.008.075.014.15.021.225,0,.052.01.1.014.155.006.08.009.161.014.241,0,.046.006.093.008.139q.007.19.007.381a10.783,10.783,0,1,1-21.561,0q0-.191.007-.381c0-.047.005-.094.008-.14,0-.08.007-.16.014-.24,0-.045.009-.09.013-.135.007-.082.014-.163.023-.245,0-.036.01-.072.014-.108.011-.087.021-.173.034-.26v0C84.85,120.2,84.846,120.279,84.843,120.356Zm-.425.877q-.007.2-.008.4a11.116,11.116,0,1,0,22.227,0q0-.2-.007-.4c0-.058-.007-.116-.01-.174s-.006-.134-.011-.2c.007.05.014.1.021.149s.016.118.023.178c.01.084.017.169.025.254.005.057.011.113.015.17.007.094.012.188.017.283,0,.048.006.1.008.144q.008.214.008.428a11.2,11.2,0,1,1-22.4,0q0-.215.008-.429c0-.048.005-.1.008-.143,0-.095.01-.189.017-.283,0-.057.01-.114.015-.17.008-.085.015-.169.025-.254.007-.06.015-.119.023-.178s.013-.1.021-.149c-.007.09-.011.179-.015.269C84.422,121.163,84.419,121.2,84.418,121.233Zm-.507,1.6c0-.05.005-.1.008-.151.005-.106.012-.212.02-.318,0-.058.01-.116.015-.175q.014-.149.031-.3c.007-.058.014-.117.022-.175,0-.025.008-.051.011-.076-.005.078-.009.156-.013.235,0,.05-.006.1-.008.149q-.008.221-.009.444a11.536,11.536,0,1,0,23.069,0c0-.148,0-.3-.009-.444,0-.05-.006-.1-.008-.148,0-.079-.007-.157-.013-.236,0,.025.008.05.011.076.008.059.015.118.022.177q.017.148.031.3c.005.059.011.117.016.175.008.106.015.212.02.318,0,.05.006.1.008.151.006.156.01.313.01.469a11.625,11.625,0,1,1-23.245,0C83.9,123.143,83.9,122.987,83.91,122.831Zm11.613,7.617a10.392,10.392,0,0,0,10.271-10.487q0-.271-.018-.545l.007.042c.009.064.018.128.026.193.006.048.012.1.018.144.007.067.013.133.019.2,0,.045.009.09.012.135.005.074.009.148.013.222,0,.037,0,.075.006.112q.006.167.006.333a10.362,10.362,0,1,1-20.719,0q0-.166.006-.333c0-.037,0-.075.006-.112,0-.074.007-.148.013-.223,0-.045.008-.089.012-.134.006-.067.012-.134.019-.2.005-.048.011-.1.017-.143.008-.065.016-.129.026-.194,0-.014,0-.027.006-.041q-.017.274-.018.545A10.393,10.393,0,0,0,95.523,130.447Z' transform='translate(-81.884 -114.796)' fill='#1a1818'/></svg><div class='native-menu-title mt-2'>Shop</div></a>
<a href="/products/threadless-titanium-labret-post" class="text-center native-footer-link h-100 d-flex flex-column align-items-center justify-content-center" style="width: 50px;"><svg xmlns='http://www.w3.org/2000/svg' width='27.278' height='24.807' viewBox='0 0 27.278 24.807'><path id='Path_22' data-name='Path 22' d='M109.156,125.409l-.006-.209c0-.075,0-.149-.006-.224-.011-.227-.028-.456-.052-.7-.044-.437-.108-.876-.192-1.305a13.9,13.9,0,0,0-3.814-7.182c-.138-.139-.281-.275-.425-.407l0,0-.026-.023-.616-.564.02.043-.01-.009.345.726.032.067,0,.009a10.238,10.238,0,0,1,1.053,4.328,9.941,9.941,0,1,1-19.877,0,10.288,10.288,0,0,1,1.089-4.4l.31-.653-.013.011.054-.114-.614.563a13.956,13.956,0,0,0-4.458,8.931c-.022.224-.039.454-.051.682,0,.073,0,.147-.006.221l-.006.212c0,.093-.006.186-.006.281a13.968,13.968,0,0,0,8.951,13.069,13.427,13.427,0,0,0,10-.249c.2-.087.406-.181.6-.279.4-.194.785-.411,1.159-.643a13.739,13.739,0,0,0,1.6-1.163c.335-.282.661-.584.968-.9s.6-.647.88-.988.541-.7.785-1.071a14.037,14.037,0,0,0,.984-1.747c.1-.2.187-.408.273-.616.173-.417.327-.847.459-1.278s.247-.885.337-1.333a14.319,14.319,0,0,0,.279-2.8C109.162,125.6,109.159,125.5,109.156,125.409Zm-24.314-5.053c0,.035,0,.07-.006.1q-.006.167-.006.334a10.694,10.694,0,1,0,21.384,0q0-.166-.006-.333c0-.043,0-.087-.007-.13,0-.068-.006-.136-.011-.2v-.005c.011.075.02.151.03.227.006.047.013.094.018.141.008.075.014.15.021.225,0,.052.01.1.014.155.006.08.009.161.014.241,0,.046.006.093.008.139q.007.19.007.381a10.783,10.783,0,1,1-21.561,0q0-.191.007-.381c0-.047.005-.094.008-.14,0-.08.007-.16.014-.24,0-.045.009-.09.013-.135.007-.082.014-.163.023-.245,0-.036.01-.072.014-.108.011-.087.021-.173.034-.26v0C84.85,120.2,84.846,120.279,84.843,120.356Zm-.425.877q-.007.2-.008.4a11.116,11.116,0,1,0,22.227,0q0-.2-.007-.4c0-.058-.007-.116-.01-.174s-.006-.134-.011-.2c.007.05.014.1.021.149s.016.118.023.178c.01.084.017.169.025.254.005.057.011.113.015.17.007.094.012.188.017.283,0,.048.006.1.008.144q.008.214.008.428a11.2,11.2,0,1,1-22.4,0q0-.215.008-.429c0-.048.005-.1.008-.143,0-.095.01-.189.017-.283,0-.057.01-.114.015-.17.008-.085.015-.169.025-.254.007-.06.015-.119.023-.178s.013-.1.021-.149c-.007.09-.011.179-.015.269C84.422,121.163,84.419,121.2,84.418,121.233Zm-.507,1.6c0-.05.005-.1.008-.151.005-.106.012-.212.02-.318,0-.058.01-.116.015-.175q.014-.149.031-.3c.007-.058.014-.117.022-.175,0-.025.008-.051.011-.076-.005.078-.009.156-.013.235,0,.05-.006.1-.008.149q-.008.221-.009.444a11.536,11.536,0,1,0,23.069,0c0-.148,0-.3-.009-.444,0-.05-.006-.1-.008-.148,0-.079-.007-.157-.013-.236,0,.025.008.05.011.076.008.059.015.118.022.177q.017.148.031.3c.005.059.011.117.016.175.008.106.015.212.02.318,0,.05.006.1.008.151.006.156.01.313.01.469a11.625,11.625,0,1,1-23.245,0C83.9,123.143,83.9,122.987,83.91,122.831Zm11.613,7.617a10.392,10.392,0,0,0,10.271-10.487q0-.271-.018-.545l.007.042c.009.064.018.128.026.193.006.048.012.1.018.144.007.067.013.133.019.2,0,.045.009.09.012.135.005.074.009.148.013.222,0,.037,0,.075.006.112q.006.167.006.333a10.362,10.362,0,1,1-20.719,0q0-.166.006-.333c0-.037,0-.075.006-.112,0-.074.007-.148.013-.223,0-.045.008-.089.012-.134.006-.067.012-.134.019-.2.005-.048.011-.1.017-.143.008-.065.016-.129.026-.194,0-.014,0-.027.006-.041q-.017.274-.018.545A10.393,10.393,0,0,0,95.523,130.447Z' transform='translate(-81.884 -114.796)' fill='#787674'/></svg><div class='native-menu-title mt-2'>Titanium</div></a>
<a href='/account${accountURL}' class='text-center native-footer-link h-100 d-flex flex-column align-items-center justify-content-center' style='width: 50px;'><svg xmlns='http://www.w3.org/2000/svg' width='23.5' height='23.5' viewBox='0 0 23.5 23.5'><path id='Path_8' data-name='Path 8' d='M264.844,308.083A11.75,11.75,0,1,1,253.083,319.8,11.743,11.743,0,0,1,264.844,308.083Zm0,21.718a9.774,9.774,0,0,0,6.247-2.247c1.207-1.018,1.16-1.783-.18-2.7a4.238,4.238,0,0,0-.951-.514,14.546,14.546,0,0,0-10.251.034,6.1,6.1,0,0,0-1.9,1.569c-.324.328-.225.7.162,1.077A9.865,9.865,0,0,0,264.842,329.8Zm.148-16.308a4.078,4.078,0,1,0,4.041,4.141A4.1,4.1,0,0,0,264.991,313.493Z' transform='translate(-253.083 -308.083)'/></svg><div class='native-menu-title mt-2'>${loginText}</div></a>
        </div>`;
      //"<div class='chat-button position-relative'><div class='icon-container'><svg fill='#dbdbdb' class='rotating' xmlns='http://www.w3.org/2000/svg' width='20.9' height='20.9' viewBox='0 0 20.9 20.9'> <g id='Group_32' data-name='Group 32' transform='translate(1087.64 -183.38)'> <path id='Path_20' data-name='Path 20' d='M-1069.721,220.248l-1.865,1.865a7.784,7.784,0,0,1,2.214,5.444,7.827,7.827,0,0,1-7.817,7.817,7.826,7.826,0,0,1-7.818-7.817,7.8,7.8,0,0,1,2.433-5.662l-1.864-1.864a10.416,10.416,0,0,0-3.2,7.526,10.45,10.45,0,0,0,10.45,10.45,10.45,10.45,0,0,0,10.45-10.45A10.414,10.414,0,0,0-1069.721,220.248Z' transform='translate(0 -33.726)'/> <path id='Path_21' data-name='Path 21' d='M-1032.792,186.521l-1.865,1.865a7.788,7.788,0,0,0-5.6-2.374,7.787,7.787,0,0,0-5.385,2.155l-1.864-1.864a10.411,10.411,0,0,1,7.249-2.924A10.419,10.419,0,0,1-1032.792,186.521Z' transform='translate(-36.929)' fill='#fff'/> </g> </svg> </div><div class='notif position-absolute d-none'></div></div>" +

      //Redirect from the homepage only if it is on the homepage
      //Insert the new native footer
      
      if(navigator.userAgent.indexOf("---has-test-config") != -1){
        console.warn("🧪 You Are Using A Test Version of The App :: User Agent :: ", navigator.userAgent);
        
        nativeMenuHtml = `<div class="junipurr-ui-tab-bar-wrapper"><div class="junipurr-ui-tab-bar">

    <a href="/" class="junipurr-ui-tab-bar__item junipurr-ui-tab-bar__item--home">
      <!-- House icon -->
      <svg class="junipurr-ui-tab-bar__item-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clipHome)">
          <path
            d="M23.6331 10.226L12.6331 1.22597C12.4545 1.07991 12.2308 1.00012 12.0001 1.00012C11.7694 1.00012 11.5457 1.07991 11.3671 1.22597L0.367099 10.226C0.166425 10.3953 0.0403921 10.6367 0.0162144 10.8982C-0.00796332 11.1596 0.0716538 11.4201 0.237875 11.6233C0.404096 11.8266 0.643583 11.9563 0.904628 11.9845C1.16567 12.0127 1.42733 11.9371 1.6331 11.774L3.0001 10.656V22C3.0001 22.2652 3.10546 22.5195 3.29299 22.7071C3.48053 22.8946 3.73488 23 4.0001 23H10.0001V17H14.0001V23H20.0001C20.2653 23 20.5197 22.8946 20.7072 22.7071C20.8947 22.5195 21.0001 22.2652 21.0001 22V10.656L22.3671 11.774C22.4685 11.8595 22.5858 11.924 22.7123 11.9637C22.8388 12.0035 22.972 12.0176 23.104 12.0054C23.2361 11.9932 23.3644 11.9549 23.4815 11.8926C23.5986 11.8303 23.7021 11.7454 23.7861 11.6427C23.87 11.5401 23.9327 11.4218 23.9705 11.2947C24.0083 11.1675 24.0204 11.0342 24.0062 10.9023C23.992 10.7705 23.9516 10.6428 23.8876 10.5267C23.8235 10.4106 23.737 10.3083 23.6331 10.226Z"
            fill="black" />
        </g>
        <defs>
          <clipPath id="clipHome">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <span href="/" class="junipurr-ui-tab-bar__item-text">
        Home
      </span>
    </a>

    <!-- SHOP -->
    <a href="/pages/categories" class="junipurr-ui-tab-bar__item junipurr-ui-tab-bar__item--shop">
      <!-- Shop icon -->
      <svg class="junipurr-ui-tab-bar__item-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M19.7821 1.9811L20.0494 1.83385C20.0583 1.84714 20.0644 1.859 20.0682 1.86672C20.0693 1.86917 20.0705 1.87157 20.0714 1.87374L20.0998 1.91606V1.9346C20.1037 1.94285 20.1076 1.9511 20.1115 1.95936L20.1268 1.97465L20.1413 1.99969C20.9115 3.33521 21.4214 4.89802 21.4214 6.57396C21.4214 11.8464 17.2074 16.1329 11.9972 16.1329C6.78418 16.1329 2.57302 11.8463 2.57302 6.57396C2.57302 4.89802 3.08288 3.33521 3.85315 1.99969L3.86151 1.9852L3.87203 1.97212C3.87215 1.97198 3.87277 1.97119 3.8745 1.96885L3.87763 1.96458C3.87885 1.96292 3.88047 1.9607 3.88218 1.95839C3.88388 1.9561 3.88605 1.95318 3.88867 1.94979C3.88962 1.94789 3.89068 1.94582 3.89186 1.9436C3.89277 1.94165 3.89368 1.9397 3.8946 1.93775V1.91885L3.92297 1.87652C3.92396 1.87435 3.92508 1.87195 3.92627 1.8695C3.93 1.86179 3.93613 1.84993 3.94504 1.83664L4.2129 1.98389H4.33632V2.02148L4.32775 2.04702L4.32951 2.04799C4.32692 2.05343 4.32433 2.05887 4.32174 2.06431C4.31889 2.07181 4.31616 2.078 4.31411 2.08245C4.31288 2.08513 4.31165 2.08768 4.3106 2.08982L4.30483 2.10705L4.29671 2.11915C4.29573 2.12132 4.29461 2.12372 4.29342 2.12618C4.29144 2.13027 4.28879 2.13552 4.28541 2.14154C3.75665 3.27559 3.38512 4.53067 3.38512 5.84848C3.38512 10.6911 7.2494 14.6052 12 14.6052C16.7507 14.6052 20.6148 10.6939 20.6093 5.84593V5.84569C20.6093 4.53856 20.2479 3.29828 19.7257 2.17408C19.721 2.16612 19.7175 2.15919 19.715 2.15407C19.7132 2.15021 19.7115 2.14648 19.7102 2.14358C19.7062 2.13671 19.7032 2.13073 19.701 2.12619C19.6992 2.12247 19.6976 2.11889 19.6963 2.11603C19.6832 2.09356 19.6753 2.07261 19.6702 2.05623C19.6685 2.05268 19.6668 2.04913 19.6651 2.04557L19.6668 2.04463C19.6659 2.04142 19.6652 2.0385 19.6645 2.03591L19.6581 2.01028V1.9811H19.7821ZM20.9622 7.14841C20.3438 11.6066 16.5718 15.0391 12 15.0391C7.42267 15.0391 3.64719 11.5959 3.03135 7.13383C3.31611 11.9185 7.22632 15.699 11.9972 15.699C16.7606 15.699 20.6702 11.9261 20.9622 7.14841Z"
          fill="black" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M3.87481 1.97489L4.24025 2.21639C3.50095 3.4982 3.01752 4.988 3.01752 6.57673C3.01752 11.6229 7.04723 15.7017 12 15.7017C16.9555 15.7017 20.9825 11.623 20.9825 6.57673C20.9825 4.988 20.499 3.4982 19.7597 2.21639L20.1252 1.97489L20.1652 2.02459L20.1707 2.03297C21.1653 3.53509 21.7918 5.34754 21.7918 7.30221C21.7918 12.7784 17.4149 17.2295 12 17.2295C6.58506 17.2295 2.20823 12.7784 2.20823 7.30221C2.20823 5.34763 2.83465 3.53232 3.82939 2.03281L3.83489 2.02452L3.87481 1.97489ZM2.67042 7.93577C2.9916 12.8892 7.0515 16.7955 12 16.7955C16.9482 16.7955 21.008 12.8896 21.3295 7.93655C20.6792 12.5668 16.7566 16.1357 12 16.1357C7.24567 16.1357 3.32082 12.5664 2.67042 7.93577Z"
          fill="black" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M3.84115 2.01677L4.19957 2.26962C3.24686 3.7085 2.64996 5.43975 2.64996 7.30224C2.64996 12.552 6.84232 16.7955 12 16.7955C17.1577 16.7955 21.35 12.552 21.35 7.30224C21.35 5.43966 20.7531 3.70569 19.8005 2.26978L20.1589 2.01677L20.1957 2.06253L20.1986 2.06656C21.4137 3.72806 22.1593 5.78931 22.1593 8.02493C22.1593 13.7049 17.6169 18.3205 12 18.3205C6.38316 18.3205 1.84067 13.7049 1.84067 8.02493C1.84067 5.79213 2.58627 3.72808 3.8014 2.06656L3.80435 2.06253L3.84115 2.01677ZM2.30496 8.70262C2.64821 13.8389 6.86409 17.8866 12 17.8866C17.1359 17.8866 21.3518 13.8389 21.6951 8.70259C21.0243 13.5175 16.945 17.2295 12 17.2295C7.055 17.2295 2.97576 13.5175 2.30496 8.70262Z"
          fill="black" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M1.47308 8.75599C1.47308 6.22001 2.34904 3.89354 3.80676 2.06229L4.1601 2.32255C2.99581 3.91457 2.28237 5.88812 2.28237 8.02771C2.28237 13.4811 6.64017 17.8894 12 17.8894C17.3598 17.8894 21.7176 13.4811 21.7176 8.02771C21.7176 5.89088 21.0041 3.91454 19.8399 2.32255L20.1932 2.06229C21.6509 3.89354 22.5269 6.22001 22.5269 8.75599C22.5269 14.6397 17.8216 19.4199 12 19.4199C6.18121 19.4199 1.47308 14.6398 1.47308 8.75599ZM1.93835 9.46086C2.29553 14.788 6.67101 18.986 12 18.986C17.3317 18.986 21.7048 14.7879 22.0616 9.46066C21.3738 14.464 17.136 18.3233 12 18.3233C6.86399 18.3233 2.62628 14.4642 1.93835 9.46086Z"
          fill="black" />
        <path
          d="M19.9154 2.04538C19.9323 2.0677 19.9463 2.09281 19.9631 2.11514C19.9828 2.14025 20.0024 2.16815 20.0192 2.19327C21.4474 3.98744 22.306 6.26713 22.306 8.7533C22.306 14.5237 17.6904 19.2003 12 19.2003C6.30684 19.2003 1.69395 14.5237 1.69395 8.7533C1.69395 6.26713 2.55256 3.98744 3.98076 2.19327C4.0004 2.16815 4.02004 2.14025 4.03687 2.11514C4.05371 2.09281 4.06774 2.0677 4.08458 2.04538C4.0958 2.02585 4.10702 2.00631 4.11825 1.98957C4.12386 1.97841 4.12666 1.97004 4.13228 1.95888C2.01102 3.88978 0.585626 6.58802 0.28259 9.62109C0.28259 9.62388 0.28259 9.62946 0.28259 9.63225C0.262948 9.82758 0.248919 10.0229 0.237695 10.2182C0.232084 10.3103 0.232084 10.4052 0.229278 10.4973C0.226472 10.6089 0.22086 10.7177 0.22086 10.8293C0.226472 15.9886 3.44483 20.3806 7.9511 22.0575C9.21375 22.5263 10.5774 22.783 12 22.783C13.6246 22.783 15.1735 22.4482 16.582 21.8427C16.7588 21.7673 16.9328 21.6864 17.1039 21.6027C17.4462 21.4353 17.7801 21.2511 18.1056 21.0502C18.591 20.7517 19.054 20.4168 19.4889 20.0513C19.7807 19.8085 20.0585 19.549 20.3251 19.2812C20.5916 19.0105 20.8442 18.7287 21.0855 18.4329C21.3268 18.1371 21.5513 17.8302 21.7645 17.5121C22.0816 17.035 22.3678 16.5327 22.6147 16.0109C22.6961 15.8379 22.7774 15.6593 22.8504 15.4808C22.9991 15.1236 23.131 14.7581 23.246 14.3814C23.3611 14.0075 23.4593 13.6252 23.5378 13.2346C23.695 12.4561 23.7791 11.6497 23.7791 10.8265C23.7791 10.7149 23.7735 10.6033 23.7707 10.4945C23.7679 10.4024 23.7679 10.3075 23.7623 10.2154C23.7511 10.0201 23.7371 9.82479 23.7174 9.62946C23.7174 9.62667 23.7174 9.62109 23.7174 9.6183C23.6781 9.23882 23.6248 8.86492 23.5519 8.49659C23.0833 6.10529 21.9076 3.9707 20.2577 2.3272C20.1315 2.20164 20.0024 2.07607 19.8677 1.95609C19.8733 1.96725 19.8761 1.97562 19.8818 1.98678C19.8958 2.00911 19.9042 2.02585 19.9154 2.04538Z"
          fill="black" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M4.86073 1L4.33047 2.05462C4.33031 2.05499 4.3298 2.05613 4.32864 2.05882L4.32833 2.05954C4.32622 2.06446 4.32198 2.0743 4.31627 2.08567L4.31021 2.0977L4.3027 2.10892C4.29644 2.11825 4.28906 2.13089 4.27691 2.15204L4.27018 2.16375L4.26203 2.17455C4.25892 2.17868 4.25526 2.18415 4.24681 2.19712L4.24575 2.19875C4.2394 2.20852 4.22968 2.22348 4.21833 2.23893C4.20031 2.26566 4.17862 2.2964 4.15589 2.32547L4.15531 2.3262L4.15473 2.32693C2.75605 4.08402 1.91481 6.31693 1.91481 8.7533C1.91481 14.4103 6.4353 18.9833 12 18.9833C17.5619 18.9833 22.0852 14.4103 22.0852 8.7533C22.0852 6.31693 21.2439 4.08402 19.8453 2.32693L19.8397 2.31998L19.8348 2.31261C19.8197 2.2901 19.8033 2.26687 19.788 2.24734L19.7868 2.24583L19.7857 2.24431C19.7726 2.22699 19.7613 2.20962 19.7542 2.19872L19.7532 2.19712C19.7447 2.18415 19.7411 2.17868 19.738 2.17455L19.7298 2.16375L19.7231 2.15204C19.7153 2.13845 19.7109 2.13047 19.7075 2.12429C19.7031 2.11619 19.7004 2.11121 19.6938 2.10078L19.6884 2.09206L19.6837 2.08288C19.678 2.07154 19.6738 2.0617 19.6717 2.05678L19.6714 2.05604C19.6702 2.05334 19.6697 2.05219 19.6695 2.05183C19.6695 2.05173 19.6695 2.05169 19.6695 2.05169L19.1548 1.02805L20.0161 1.79536C20.1553 1.91936 20.2877 2.04825 20.4149 2.17471L20.415 2.17484C22.0949 3.8483 23.2916 6.02131 23.7687 8.45515C23.8431 8.83101 23.8973 9.21153 23.9371 9.59635L23.9383 9.6073V9.61882C23.9577 9.8145 23.9717 10.0095 23.9828 10.2032C23.9868 10.2684 23.9882 10.3387 23.9895 10.403C23.9901 10.433 23.9907 10.4617 23.9915 10.488L23.9915 10.489C23.9923 10.5208 23.9935 10.5546 23.9947 10.5896C23.9972 10.6659 24 10.7477 24 10.8265C24 11.6642 23.9143 12.4847 23.7545 13.2768C23.6744 13.6747 23.5745 14.0638 23.4574 14.4442C23.3404 14.8273 23.2063 15.1991 23.055 15.5625C22.9801 15.7458 22.897 15.9279 22.8152 16.1019L22.815 16.1024C22.5634 16.634 22.272 17.1453 21.9494 17.6307L21.949 17.6315C21.7324 17.9544 21.504 18.2669 21.2578 18.5686C21.0123 18.8696 20.7552 19.1565 20.4838 19.4321L20.4834 19.4325L20.483 19.4329C20.2129 19.7043 19.9302 19.9685 19.6321 20.2165C19.1892 20.5887 18.7177 20.9298 18.2231 21.234C17.8915 21.4387 17.5512 21.6263 17.2023 21.797C17.0288 21.8818 16.8515 21.9643 16.6706 22.0415C15.2347 22.6587 13.6558 23 12 23C10.5501 23 9.16006 22.7383 7.87302 22.2605L7.87286 22.2604C3.28022 20.5513 0.00570921 16.0783 1.22867e-07 10.8295L0 10.8293C0 10.7518 0.00268098 10.6724 0.00522497 10.5971C0.00644753 10.5608 0.00763846 10.5256 0.00848499 10.4919L0.00849928 10.4913L0.00851657 10.4908C0.00931627 10.4645 0.00989798 10.4358 0.0105064 10.4058C0.0118116 10.3414 0.0132398 10.2709 0.017207 10.2056C0.0283365 10.012 0.0422649 9.81717 0.0617297 9.62162V9.61047L0.0627859 9.5999C0.371195 6.51305 1.82202 3.76602 3.98217 1.79972L4.86073 1ZM2.48849 4.18205C1.41087 5.76113 0.706133 7.62118 0.50345 9.63176V9.64295L0.50238 9.65359C0.483135 9.84496 0.469316 10.0371 0.458204 10.2305L0.45816 10.2312C0.454679 10.2883 0.453597 10.3431 0.452432 10.4021C0.451798 10.4342 0.451139 10.4675 0.450056 10.5032C0.449009 10.5447 0.447679 10.5837 0.446392 10.6215C0.443984 10.6922 0.441722 10.7586 0.44172 10.8292C0.447282 15.899 3.60948 20.2098 8.02933 21.8546C9.26755 22.3143 10.6047 22.566 12 22.566C13.5934 22.566 15.1122 22.2377 16.4935 21.6439L16.4941 21.6436C16.6665 21.5702 16.8369 21.4909 17.0055 21.4085C17.3412 21.2443 17.6688 21.0636 17.9881 20.8665L17.9884 20.8663C18.4645 20.5735 18.9186 20.2451 19.3454 19.8864L19.3458 19.8861L19.3462 19.8857C19.6315 19.6484 19.904 19.3939 20.1668 19.1299C20.4283 18.8643 20.6762 18.5876 20.9131 18.2972C21.1496 18.0074 21.3701 17.706 21.5801 17.3928C21.8913 16.9243 22.1721 16.4315 22.4142 15.9199C22.495 15.7482 22.5745 15.5735 22.6454 15.3999L22.6457 15.3993L22.646 15.3986C22.792 15.0479 22.9215 14.689 23.0345 14.319L23.0346 14.3186C23.1477 13.9512 23.2441 13.5758 23.3212 13.1925L23.3212 13.1924C23.4756 12.4274 23.5583 11.6351 23.5583 10.8265C23.5583 10.7548 23.5559 10.6858 23.5535 10.6136C23.5522 10.577 23.551 10.5397 23.55 10.5007C23.5499 10.5005 23.5499 10.5002 23.5499 10.5L23.7707 10.4945L23.55 10.501C23.55 10.5009 23.55 10.5008 23.55 10.5007C23.5489 10.4649 23.5482 10.4315 23.5476 10.3993C23.5464 10.3403 23.5453 10.2855 23.5418 10.2284L23.5418 10.2277C23.5307 10.0343 23.5169 9.84217 23.4976 9.65079L23.4965 9.64016V9.62946C23.4969 9.63306 23.4973 9.63666 23.4977 9.64026L23.7174 9.6183H23.4965V9.62928C23.4579 9.2589 23.4058 8.89532 23.3351 8.53804L23.335 8.53761C23.0222 6.94143 22.3887 5.46191 21.5064 4.17127C21.1841 3.48689 20.792 2.84265 20.3397 2.24782C20.3397 2.2478 20.3396 2.24777 20.3396 2.24775C20.2932 2.18678 20.2462 2.12633 20.1986 2.0664C20.1814 2.04102 20.1611 2.01227 20.1398 1.9849C20.1368 1.98087 20.1331 1.97529 20.1254 1.9634L20.1243 1.96171C20.119 1.95366 20.1115 1.94212 20.1027 1.92967C20.0969 1.91917 20.0876 1.9024 20.0777 1.88595C20.0756 1.88098 20.0714 1.87123 20.0657 1.86L19.8677 1.95609L19.7194 2.11682C19.728 2.12447 19.7365 2.13215 19.7451 2.13986C19.7511 2.1453 19.7571 2.15075 19.7632 2.15622C19.7844 2.1755 19.8055 2.19495 19.8266 2.21453C19.8273 2.21521 19.828 2.21589 19.8288 2.21656C19.8498 2.23618 19.8708 2.25593 19.8917 2.2758C19.8947 2.27865 19.8977 2.28151 19.9007 2.28436C19.9678 2.34841 20.0343 2.41371 20.1006 2.47969C20.6195 2.99655 21.0906 3.56293 21.5064 4.17127C22.1602 5.55931 22.5269 7.11245 22.5269 8.7533C22.5269 14.6371 17.8188 19.4172 12 19.4172C6.17839 19.4172 1.47309 14.6371 1.47309 8.7533C1.47309 7.1167 1.83792 5.56735 2.48849 4.18205Z"
          fill="black" />
      </svg>


      <span href="/pages/categories" class="junipurr-ui-tab-bar__item-text">
        Shop
      </span>
    </a>

    <!-- CREATE -->
    <a href="/pages/configurator-tool" class="junipurr-ui-tab-bar__item junipurr-ui-tab-bar__item--create">
      <!-- Create icon -->
      <svg class="junipurr-ui-tab-bar__item-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clipCreate)">
          <path
            d="M18.7681 1.36C18.5781 1.132 18.2971 1 18.0001 1H6.00012C5.70312 1 5.42212 1.132 5.23212 1.36L0.232121 7.36C-0.0618791 7.713 -0.077879 8.221 0.193121 8.591L11.1931 23.591C11.3821 23.848 11.6821 24 12.0001 24C12.3181 24 12.6181 23.848 12.8071 23.591L23.8071 8.591C24.0781 8.22 24.0631 7.713 23.7681 7.36L18.7681 1.36ZM19.0001 8C19.0001 8.55228 18.5524 9 18.0001 9H6.00012C5.44784 9 5.00012 8.55228 5.00012 8C5.00012 7.44772 5.44784 7 6.00012 7H18.0001C18.5524 7 19.0001 7.44772 19.0001 8Z"
            fill="url(#paint0_angular)" />
        </g>
        <defs>
          <radialGradient id="paint0_angular" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
            gradientTransform="translate(12.0003 12.5) rotate(90) scale(11.5)">
            <stop stop-color="#A46300" />
            <stop offset="1" stop-color="#FFCE85" />
          </radialGradient>
          <clipPath id="clipCreate">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>

      <span href="/pages/configurator-tool" class="junipurr-ui-tab-bar__item-text">
        Create
      </span>
    </a>

    <!-- Titanium -->
<a href="/collections/all-titanium" class="junipurr-ui-tab-bar__item junipurr-ui-tab-bar__item--shop">
      <!-- Shop icon -->
      <svg class="junipurr-ui-tab-bar__item-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M19.7821 1.9811L20.0494 1.83385C20.0583 1.84714 20.0644 1.859 20.0682 1.86672C20.0693 1.86917 20.0705 1.87157 20.0714 1.87374L20.0998 1.91606V1.9346C20.1037 1.94285 20.1076 1.9511 20.1115 1.95936L20.1268 1.97465L20.1413 1.99969C20.9115 3.33521 21.4214 4.89802 21.4214 6.57396C21.4214 11.8464 17.2074 16.1329 11.9972 16.1329C6.78418 16.1329 2.57302 11.8463 2.57302 6.57396C2.57302 4.89802 3.08288 3.33521 3.85315 1.99969L3.86151 1.9852L3.87203 1.97212C3.87215 1.97198 3.87277 1.97119 3.8745 1.96885L3.87763 1.96458C3.87885 1.96292 3.88047 1.9607 3.88218 1.95839C3.88388 1.9561 3.88605 1.95318 3.88867 1.94979C3.88962 1.94789 3.89068 1.94582 3.89186 1.9436C3.89277 1.94165 3.89368 1.9397 3.8946 1.93775V1.91885L3.92297 1.87652C3.92396 1.87435 3.92508 1.87195 3.92627 1.8695C3.93 1.86179 3.93613 1.84993 3.94504 1.83664L4.2129 1.98389H4.33632V2.02148L4.32775 2.04702L4.32951 2.04799C4.32692 2.05343 4.32433 2.05887 4.32174 2.06431C4.31889 2.07181 4.31616 2.078 4.31411 2.08245C4.31288 2.08513 4.31165 2.08768 4.3106 2.08982L4.30483 2.10705L4.29671 2.11915C4.29573 2.12132 4.29461 2.12372 4.29342 2.12618C4.29144 2.13027 4.28879 2.13552 4.28541 2.14154C3.75665 3.27559 3.38512 4.53067 3.38512 5.84848C3.38512 10.6911 7.2494 14.6052 12 14.6052C16.7507 14.6052 20.6148 10.6939 20.6093 5.84593V5.84569C20.6093 4.53856 20.2479 3.29828 19.7257 2.17408C19.721 2.16612 19.7175 2.15919 19.715 2.15407C19.7132 2.15021 19.7115 2.14648 19.7102 2.14358C19.7062 2.13671 19.7032 2.13073 19.701 2.12619C19.6992 2.12247 19.6976 2.11889 19.6963 2.11603C19.6832 2.09356 19.6753 2.07261 19.6702 2.05623C19.6685 2.05268 19.6668 2.04913 19.6651 2.04557L19.6668 2.04463C19.6659 2.04142 19.6652 2.0385 19.6645 2.03591L19.6581 2.01028V1.9811H19.7821ZM20.9622 7.14841C20.3438 11.6066 16.5718 15.0391 12 15.0391C7.42267 15.0391 3.64719 11.5959 3.03135 7.13383C3.31611 11.9185 7.22632 15.699 11.9972 15.699C16.7606 15.699 20.6702 11.9261 20.9622 7.14841Z"
          fill="#787674" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M3.87481 1.97489L4.24025 2.21639C3.50095 3.4982 3.01752 4.988 3.01752 6.57673C3.01752 11.6229 7.04723 15.7017 12 15.7017C16.9555 15.7017 20.9825 11.623 20.9825 6.57673C20.9825 4.988 20.499 3.4982 19.7597 2.21639L20.1252 1.97489L20.1652 2.02459L20.1707 2.03297C21.1653 3.53509 21.7918 5.34754 21.7918 7.30221C21.7918 12.7784 17.4149 17.2295 12 17.2295C6.58506 17.2295 2.20823 12.7784 2.20823 7.30221C2.20823 5.34763 2.83465 3.53232 3.82939 2.03281L3.83489 2.02452L3.87481 1.97489ZM2.67042 7.93577C2.9916 12.8892 7.0515 16.7955 12 16.7955C16.9482 16.7955 21.008 12.8896 21.3295 7.93655C20.6792 12.5668 16.7566 16.1357 12 16.1357C7.24567 16.1357 3.32082 12.5664 2.67042 7.93577Z"
          fill="#787674" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M3.84115 2.01677L4.19957 2.26962C3.24686 3.7085 2.64996 5.43975 2.64996 7.30224C2.64996 12.552 6.84232 16.7955 12 16.7955C17.1577 16.7955 21.35 12.552 21.35 7.30224C21.35 5.43966 20.7531 3.70569 19.8005 2.26978L20.1589 2.01677L20.1957 2.06253L20.1986 2.06656C21.4137 3.72806 22.1593 5.78931 22.1593 8.02493C22.1593 13.7049 17.6169 18.3205 12 18.3205C6.38316 18.3205 1.84067 13.7049 1.84067 8.02493C1.84067 5.79213 2.58627 3.72808 3.8014 2.06656L3.80435 2.06253L3.84115 2.01677ZM2.30496 8.70262C2.64821 13.8389 6.86409 17.8866 12 17.8866C17.1359 17.8866 21.3518 13.8389 21.6951 8.70259C21.0243 13.5175 16.945 17.2295 12 17.2295C7.055 17.2295 2.97576 13.5175 2.30496 8.70262Z"
          fill="#787674" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M1.47308 8.75599C1.47308 6.22001 2.34904 3.89354 3.80676 2.06229L4.1601 2.32255C2.99581 3.91457 2.28237 5.88812 2.28237 8.02771C2.28237 13.4811 6.64017 17.8894 12 17.8894C17.3598 17.8894 21.7176 13.4811 21.7176 8.02771C21.7176 5.89088 21.0041 3.91454 19.8399 2.32255L20.1932 2.06229C21.6509 3.89354 22.5269 6.22001 22.5269 8.75599C22.5269 14.6397 17.8216 19.4199 12 19.4199C6.18121 19.4199 1.47308 14.6398 1.47308 8.75599ZM1.93835 9.46086C2.29553 14.788 6.67101 18.986 12 18.986C17.3317 18.986 21.7048 14.7879 22.0616 9.46066C21.3738 14.464 17.136 18.3233 12 18.3233C6.86399 18.3233 2.62628 14.4642 1.93835 9.46086Z"
          fill="#787674" />
        <path
          d="M19.9154 2.04538C19.9323 2.0677 19.9463 2.09281 19.9631 2.11514C19.9828 2.14025 20.0024 2.16815 20.0192 2.19327C21.4474 3.98744 22.306 6.26713 22.306 8.7533C22.306 14.5237 17.6904 19.2003 12 19.2003C6.30684 19.2003 1.69395 14.5237 1.69395 8.7533C1.69395 6.26713 2.55256 3.98744 3.98076 2.19327C4.0004 2.16815 4.02004 2.14025 4.03687 2.11514C4.05371 2.09281 4.06774 2.0677 4.08458 2.04538C4.0958 2.02585 4.10702 2.00631 4.11825 1.98957C4.12386 1.97841 4.12666 1.97004 4.13228 1.95888C2.01102 3.88978 0.585626 6.58802 0.28259 9.62109C0.28259 9.62388 0.28259 9.62946 0.28259 9.63225C0.262948 9.82758 0.248919 10.0229 0.237695 10.2182C0.232084 10.3103 0.232084 10.4052 0.229278 10.4973C0.226472 10.6089 0.22086 10.7177 0.22086 10.8293C0.226472 15.9886 3.44483 20.3806 7.9511 22.0575C9.21375 22.5263 10.5774 22.783 12 22.783C13.6246 22.783 15.1735 22.4482 16.582 21.8427C16.7588 21.7673 16.9328 21.6864 17.1039 21.6027C17.4462 21.4353 17.7801 21.2511 18.1056 21.0502C18.591 20.7517 19.054 20.4168 19.4889 20.0513C19.7807 19.8085 20.0585 19.549 20.3251 19.2812C20.5916 19.0105 20.8442 18.7287 21.0855 18.4329C21.3268 18.1371 21.5513 17.8302 21.7645 17.5121C22.0816 17.035 22.3678 16.5327 22.6147 16.0109C22.6961 15.8379 22.7774 15.6593 22.8504 15.4808C22.9991 15.1236 23.131 14.7581 23.246 14.3814C23.3611 14.0075 23.4593 13.6252 23.5378 13.2346C23.695 12.4561 23.7791 11.6497 23.7791 10.8265C23.7791 10.7149 23.7735 10.6033 23.7707 10.4945C23.7679 10.4024 23.7679 10.3075 23.7623 10.2154C23.7511 10.0201 23.7371 9.82479 23.7174 9.62946C23.7174 9.62667 23.7174 9.62109 23.7174 9.6183C23.6781 9.23882 23.6248 8.86492 23.5519 8.49659C23.0833 6.10529 21.9076 3.9707 20.2577 2.3272C20.1315 2.20164 20.0024 2.07607 19.8677 1.95609C19.8733 1.96725 19.8761 1.97562 19.8818 1.98678C19.8958 2.00911 19.9042 2.02585 19.9154 2.04538Z"
          fill="#787674" />
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M4.86073 1L4.33047 2.05462C4.33031 2.05499 4.3298 2.05613 4.32864 2.05882L4.32833 2.05954C4.32622 2.06446 4.32198 2.0743 4.31627 2.08567L4.31021 2.0977L4.3027 2.10892C4.29644 2.11825 4.28906 2.13089 4.27691 2.15204L4.27018 2.16375L4.26203 2.17455C4.25892 2.17868 4.25526 2.18415 4.24681 2.19712L4.24575 2.19875C4.2394 2.20852 4.22968 2.22348 4.21833 2.23893C4.20031 2.26566 4.17862 2.2964 4.15589 2.32547L4.15531 2.3262L4.15473 2.32693C2.75605 4.08402 1.91481 6.31693 1.91481 8.7533C1.91481 14.4103 6.4353 18.9833 12 18.9833C17.5619 18.9833 22.0852 14.4103 22.0852 8.7533C22.0852 6.31693 21.2439 4.08402 19.8453 2.32693L19.8397 2.31998L19.8348 2.31261C19.8197 2.2901 19.8033 2.26687 19.788 2.24734L19.7868 2.24583L19.7857 2.24431C19.7726 2.22699 19.7613 2.20962 19.7542 2.19872L19.7532 2.19712C19.7447 2.18415 19.7411 2.17868 19.738 2.17455L19.7298 2.16375L19.7231 2.15204C19.7153 2.13845 19.7109 2.13047 19.7075 2.12429C19.7031 2.11619 19.7004 2.11121 19.6938 2.10078L19.6884 2.09206L19.6837 2.08288C19.678 2.07154 19.6738 2.0617 19.6717 2.05678L19.6714 2.05604C19.6702 2.05334 19.6697 2.05219 19.6695 2.05183C19.6695 2.05173 19.6695 2.05169 19.6695 2.05169L19.1548 1.02805L20.0161 1.79536C20.1553 1.91936 20.2877 2.04825 20.4149 2.17471L20.415 2.17484C22.0949 3.8483 23.2916 6.02131 23.7687 8.45515C23.8431 8.83101 23.8973 9.21153 23.9371 9.59635L23.9383 9.6073V9.61882C23.9577 9.8145 23.9717 10.0095 23.9828 10.2032C23.9868 10.2684 23.9882 10.3387 23.9895 10.403C23.9901 10.433 23.9907 10.4617 23.9915 10.488L23.9915 10.489C23.9923 10.5208 23.9935 10.5546 23.9947 10.5896C23.9972 10.6659 24 10.7477 24 10.8265C24 11.6642 23.9143 12.4847 23.7545 13.2768C23.6744 13.6747 23.5745 14.0638 23.4574 14.4442C23.3404 14.8273 23.2063 15.1991 23.055 15.5625C22.9801 15.7458 22.897 15.9279 22.8152 16.1019L22.815 16.1024C22.5634 16.634 22.272 17.1453 21.9494 17.6307L21.949 17.6315C21.7324 17.9544 21.504 18.2669 21.2578 18.5686C21.0123 18.8696 20.7552 19.1565 20.4838 19.4321L20.4834 19.4325L20.483 19.4329C20.2129 19.7043 19.9302 19.9685 19.6321 20.2165C19.1892 20.5887 18.7177 20.9298 18.2231 21.234C17.8915 21.4387 17.5512 21.6263 17.2023 21.797C17.0288 21.8818 16.8515 21.9643 16.6706 22.0415C15.2347 22.6587 13.6558 23 12 23C10.5501 23 9.16006 22.7383 7.87302 22.2605L7.87286 22.2604C3.28022 20.5513 0.00570921 16.0783 1.22867e-07 10.8295L0 10.8293C0 10.7518 0.00268098 10.6724 0.00522497 10.5971C0.00644753 10.5608 0.00763846 10.5256 0.00848499 10.4919L0.00849928 10.4913L0.00851657 10.4908C0.00931627 10.4645 0.00989798 10.4358 0.0105064 10.4058C0.0118116 10.3414 0.0132398 10.2709 0.017207 10.2056C0.0283365 10.012 0.0422649 9.81717 0.0617297 9.62162V9.61047L0.0627859 9.5999C0.371195 6.51305 1.82202 3.76602 3.98217 1.79972L4.86073 1ZM2.48849 4.18205C1.41087 5.76113 0.706133 7.62118 0.50345 9.63176V9.64295L0.50238 9.65359C0.483135 9.84496 0.469316 10.0371 0.458204 10.2305L0.45816 10.2312C0.454679 10.2883 0.453597 10.3431 0.452432 10.4021C0.451798 10.4342 0.451139 10.4675 0.450056 10.5032C0.449009 10.5447 0.447679 10.5837 0.446392 10.6215C0.443984 10.6922 0.441722 10.7586 0.44172 10.8292C0.447282 15.899 3.60948 20.2098 8.02933 21.8546C9.26755 22.3143 10.6047 22.566 12 22.566C13.5934 22.566 15.1122 22.2377 16.4935 21.6439L16.4941 21.6436C16.6665 21.5702 16.8369 21.4909 17.0055 21.4085C17.3412 21.2443 17.6688 21.0636 17.9881 20.8665L17.9884 20.8663C18.4645 20.5735 18.9186 20.2451 19.3454 19.8864L19.3458 19.8861L19.3462 19.8857C19.6315 19.6484 19.904 19.3939 20.1668 19.1299C20.4283 18.8643 20.6762 18.5876 20.9131 18.2972C21.1496 18.0074 21.3701 17.706 21.5801 17.3928C21.8913 16.9243 22.1721 16.4315 22.4142 15.9199C22.495 15.7482 22.5745 15.5735 22.6454 15.3999L22.6457 15.3993L22.646 15.3986C22.792 15.0479 22.9215 14.689 23.0345 14.319L23.0346 14.3186C23.1477 13.9512 23.2441 13.5758 23.3212 13.1925L23.3212 13.1924C23.4756 12.4274 23.5583 11.6351 23.5583 10.8265C23.5583 10.7548 23.5559 10.6858 23.5535 10.6136C23.5522 10.577 23.551 10.5397 23.55 10.5007C23.5499 10.5005 23.5499 10.5002 23.5499 10.5L23.7707 10.4945L23.55 10.501C23.55 10.5009 23.55 10.5008 23.55 10.5007C23.5489 10.4649 23.5482 10.4315 23.5476 10.3993C23.5464 10.3403 23.5453 10.2855 23.5418 10.2284L23.5418 10.2277C23.5307 10.0343 23.5169 9.84217 23.4976 9.65079L23.4965 9.64016V9.62946C23.4969 9.63306 23.4973 9.63666 23.4977 9.64026L23.7174 9.6183H23.4965V9.62928C23.4579 9.2589 23.4058 8.89532 23.3351 8.53804L23.335 8.53761C23.0222 6.94143 22.3887 5.46191 21.5064 4.17127C21.1841 3.48689 20.792 2.84265 20.3397 2.24782C20.3397 2.2478 20.3396 2.24777 20.3396 2.24775C20.2932 2.18678 20.2462 2.12633 20.1986 2.0664C20.1814 2.04102 20.1611 2.01227 20.1398 1.9849C20.1368 1.98087 20.1331 1.97529 20.1254 1.9634L20.1243 1.96171C20.119 1.95366 20.1115 1.94212 20.1027 1.92967C20.0969 1.91917 20.0876 1.9024 20.0777 1.88595C20.0756 1.88098 20.0714 1.87123 20.0657 1.86L19.8677 1.95609L19.7194 2.11682C19.728 2.12447 19.7365 2.13215 19.7451 2.13986C19.7511 2.1453 19.7571 2.15075 19.7632 2.15622C19.7844 2.1755 19.8055 2.19495 19.8266 2.21453C19.8273 2.21521 19.828 2.21589 19.8288 2.21656C19.8498 2.23618 19.8708 2.25593 19.8917 2.2758C19.8947 2.27865 19.8977 2.28151 19.9007 2.28436C19.9678 2.34841 20.0343 2.41371 20.1006 2.47969C20.6195 2.99655 21.0906 3.56293 21.5064 4.17127C22.1602 5.55931 22.5269 7.11245 22.5269 8.7533C22.5269 14.6371 17.8188 19.4172 12 19.4172C6.17839 19.4172 1.47309 14.6371 1.47309 8.7533C1.47309 7.1167 1.83792 5.56735 2.48849 4.18205Z"
          fill="#787674" />
      </svg>


      <span href="/products/threadless-titanium-labret-post" class="junipurr-ui-tab-bar__item-text">
        Titanium
      </span>
    </a>



    <!-- ACCOUNT -->
    <a href="/account${accountURL}" class="junipurr-ui-tab-bar__item junipurr-ui-tab-bar__item--account">
      <!-- Account icon -->
      <svg class=class="junipurr-ui-tab-bar__item-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM8 10C8 7.791 9.844 6 12 6C14.156 6 16 7.791 16 10V11C16 13.209 14.156 15 12 15C9.844 15 8 13.209 8 11V10ZM12 22C9.567 22 7.335 21.124 5.599 19.674C6.438 18.091 8.083 17 10 17H14C15.917 17 17.562 18.091 18.401 19.674C16.665 21.124 14.433 22 12 22Z"
          fill="black" />
      </svg>

      <span href="/account${accountURL}" class="junipurr-ui-tab-bar__item-text">
        ${loginText}
      </span>
    </a>

  </div></div>`;
        
        nativeMenuCss = `<style>
    .junipurr-ui-tab-bar {
      background: #fff;
      height: 56px;
      font-family: 'CircularStd', sans-serif;
      display: flex;
      justify-content: space-between;
      align-items: center;

      /* Top border - optionallly put this on the wrapper */
      box-shadow: 0px -1px 0px rgba(0, 0, 0, 0.08);

      /* border: 1px solid deeppink; */
    }

    .junipurr-ui-tab-bar__item {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 20%; /* This will need to change if you add another tab */
      color: inherit;
      text-decoration: none;
    }

    .junipurr-ui-tab-bar__item-icon {
      margin-bottom: 2px;
    }

    .junipurr-ui-tab-bar__item-text {
      font-weight: 700;
      font-size: 10px;
    }

    /* Modifications */
    .junipurr-ui-tab-bar__item--home {}

    .junipurr-ui-tab-bar__item--shop {}

    .junipurr-ui-tab-bar__item--create {
      color: #A36507;
    }

    .junipurr-ui-tab-bar__item--offers {}

    .junipurr-ui-tab-bar__item--account {}

    .junipurr-ui-tab-bar-wrapper{
        position: fixed;
        bottom: 0;
        width: 100% !important;
    }
  </style>`;
        
      }
      
      $("head").append(nativeMenuCss);
      $("body").append(nativeMenuHtml);

      
      //handles iOS communication to have a popup
      window.navigateToDesiredURL = (destination) => {
          window.location.replace(destination);
      }
      
      $(".junipurr-ui-tab-bar__item").click((event) => {
        event.preventDefault();
        console.log("🏋️‍♀️ EXIT INTENT");

        //check to see if we are on the page that contains the configurator
        if(window.location.pathname.includes("configurator-tool")){

          let isIPad = false;
          if((navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 0) || navigator.platform === 'iPad'){
            isIPad
          }
          
          if(ios || isIPad){
           let serializedMessageForIos = JSON.stringify({
              type: 'getConfirmation',
              metadata: event.currentTarget.href,
              ok: 'Leave',
              cancel: 'Stay',
              title: 'Warning',
              message: 'Are you sure you want to leave? You will lose your curation. It is recommended that you save your curation before leaving.'
            });

            window.webkit?.messageHandlers?.junipurrMessageHandler?.postMessage(
            serializedMessageForIos
            ); 
          } else if(/android/.test(userAgent)){
            
            console.log("🤖 you are on Android");
            console.log("❓ do we have a webview?", window.ReactNativeWebView);
            
            let serializedMessageForAndroid = JSON.stringify({
              type: 'getConfirmation',
              metadata: event.currentTarget.href,
              ok: 'Leave',
              cancel: 'Stay',
              title: 'Warning',
              message: 'Are you sure you want to leave? You will lose your curation. It is recommended that you save your curation before leaving.'
            });

            window.ReactNativeWebView?.postMessage(
            serializedMessageForAndroid
            ); 
            
          } else {
            window.navigateToDesiredURL(event.currentTarget.href);
          }

        } else {
          window.navigateToDesiredURL(event.currentTarget.href);
        }
      });
      
      $('.native-footer-link').bind('click', function(evt) {
        if (evt.metaKey) return true;
        evt.preventDefault();
        $('body').addClass('unloading');
        var src = $(this).attr('href');
        window.setTimeout(function() {
          location.href = src;
        }, 50);
      });
      //remove the current footer
      var desktopFooter = document.getElementById("shopify-section-footer-v4");
      //desktopFooter.css("display", "none");
      desktopFooter.remove();
            
      $('.homepage-v3').css("bottom", "505px");

      //$("body").append(spinCss);
      //$("body").append(notifCss);

      (function () {
        function onTidioChatApiReady() {
          // window.tidioChatApi.hide();
          window.tidioChatApi.on("open", function () {
            //window.tidioChatApi.hide();
            $("#tidio-chat-iframe").css("bottom", "55px");
          });
          window.tidioChatApi.on("close", function () {
            //window.tidioChatApi.hide();
            $("#tidio-chat-iframe").css("bottom", "55px");
          });
        }

        if (window.tidioChatApi) {
          window.tidioChatApi.on("ready", onTidioChatApiReady);
        } else {
          document.addEventListener("tidioChat-ready", onTidioChatApiReady);
        }
      })();
    }
  });
})();
